var _style, _g, _path, _g2, _path2, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs, _circle, _g10, _g11, _polygon, _polygon2, _g12, _g13, _polygon3, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _defs2, _polygon4, _polygon5, _polygon6, _polygon7, _g22, _g23, _g24, _polygon8, _defs3, _circle2, _path3, _g25, _defs4, _circle3, _defs5, _path4, _ellipse, _path5, _path6, _ellipse2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g26, _path19, _g27, _g28, _defs6, _circle4, _defs7, _polygon9, _polygon10, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _defs8, _circle5, _g37, _circle6, _g38, _defs9, _polygon11, _g39, _path20, _path21, _path22, _path23, _polygon12, _path24, _polygon13, _polygon14, _polygon15, _path25, _path26, _path27, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _polygon16, _polygon17, _polygon18, _g49, _g50, _polygon19, _g51, _defs10, _g52, _g53, _g54, _g55, _g56, _polygon20, _path28, _polygon21, _polygon22, _polygon23, _polygon24, _path29, _polygon25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgTest2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 880.8 444.9",
    style: {
      enableBackground: "new 0 0 880.8 444.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DFEAF2;}\n\t.st1{fill:#BBD2E3;}\n\t.st2{fill:#437BAC;}\n\t.st3{fill:#83D3EF;}\n\t.st4{fill:#5B87B7;}\n\t.st5{font-family:'Gotham-Bold';}\n\t.st6{font-size:16px;}\n\t.st7{font-family:'Gotham-Medium';}\n\t.st8{font-size:11px;}\n\t.st9{fill:none;stroke:#0099CE;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:5,5;}\n\t.st10{fill:#0099CE;}\n\t.st11{clip-path:url(#SVGID_00000095330409531401947640000006756292313058543797_);}\n\t.st12{opacity:0.24;fill:none;stroke:#5B87B7;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st13{opacity:0.45;fill:#FFFFFF;}\n\t.st14{fill:#FFFFFF;}\n\t.st15{fill:#F4F8FB;}\n\t.st16{clip-path:url(#SVGID_00000151532388253098313360000014514572877020775333_);}\n\t.st17{fill:none;}\n\t.st18{clip-path:url(#SVGID_00000158727181756167089800000005825716250684515719_);}\n\t.st19{fill:#99B6D1;}\n\t.st20{fill:#EBF0F6;}\n\t.st21{fill:#5C87B7;}\n\t.st22{fill:#5C88B8;}\n\t.st23{fill:#5D88B8;}\n\t.st24{fill:#5D89B8;}\n\t.st25{fill:#5E89B8;}\n\t.st26{fill:#5F8AB9;}\n\t.st27{fill:#608BB9;}\n\t.st28{fill:#618BB9;}\n\t.st29{fill:#618CBA;}\n\t.st30{fill:#628CBA;}\n\t.st31{fill:#628DBA;}\n\t.st32{fill:#638DBA;}\n\t.st33{fill:#648EBB;}\n\t.st34{fill:#658EBB;}\n\t.st35{fill:#658FBB;}\n\t.st36{fill:#668FBC;}\n\t.st37{fill:#6790BC;}\n\t.st38{fill:#6891BC;}\n\t.st39{fill:#6991BD;}\n\t.st40{fill:#6992BD;}\n\t.st41{fill:#6A92BD;}\n\t.st42{fill:#6A93BD;}\n\t.st43{fill:#6B93BE;}\n\t.st44{fill:#6C94BE;}\n\t.st45{fill:#6D94BE;}\n\t.st46{fill:#6D95BF;}\n\t.st47{fill:#6E95BF;}\n\t.st48{fill:#6F96BF;}\n\t.st49{fill:#7097C0;}\n\t.st50{fill:#7198C0;}\n\t.st51{fill:#7298C1;}\n\t.st52{fill:#7299C1;}\n\t.st53{fill:#7399C1;}\n\t.st54{fill:#749AC1;}\n\t.st55{fill:#749AC2;}\n\t.st56{fill:#759BC2;}\n\t.st57{fill:#769BC2;}\n\t.st58{fill:#779CC3;}\n\t.st59{fill:#789DC3;}\n\t.st60{fill:#799EC4;}\n\t.st61{fill:#7A9EC4;}\n\t.st62{fill:#7A9FC4;}\n\t.st63{fill:#7B9FC4;}\n\t.st64{fill:#7CA0C5;}\n\t.st65{fill:#7DA1C5;}\n\t.st66{fill:#7EA2C6;}\n\t.st67{fill:#7FA2C6;}\n\t.st68{fill:#80A3C6;}\n\t.st69{fill:#80A3C7;}\n\t.st70{fill:#81A4C7;}\n\t.st71{fill:#82A4C7;}\n\t.st72{fill:#82A5C7;}\n\t.st73{fill:#83A5C8;}\n\t.st74{fill:#84A6C8;}\n\t.st75{fill:#85A7C9;}\n\t.st76{fill:#86A8C9;}\n\t.st77{fill:#87A8C9;}\n\t.st78{fill:#87A9CA;}\n\t.st79{fill:#88A9CA;}\n\t.st80{fill:#89AACA;}\n\t.st81{fill:#8AAACB;}\n\t.st82{fill:#8AABCB;}\n\t.st83{fill:#8BABCB;}\n\t.st84{fill:#8BACCB;}\n\t.st85{fill:#8CACCC;}\n\t.st86{fill:#8DADCC;}\n\t.st87{fill:#8EAECC;}\n\t.st88{fill:#8FAECD;}\n\t.st89{fill:#8FAFCD;}\n\t.st90{fill:#90AFCD;}\n\t.st91{fill:#91B0CE;}\n\t.st92{fill:#92B0CE;}\n\t.st93{fill:#92B1CE;}\n\t.st94{fill:#93B1CE;}\n\t.st95{fill:#93B2CF;}\n\t.st96{fill:#94B2CF;}\n\t.st97{fill:#95B3CF;}\n\t.st98{fill:#96B4D0;}\n\t.st99{fill:#97B4D0;}\n\t.st100{fill:#97B5D0;}\n\t.st101{fill:#98B5D0;}\n\t.st102{fill:#98B6D1;}\n\t.st103{fill:#6891BD;}\n\t.st104{fill:#7198C1;}\n\t.st105{fill:#759AC2;}\n\t.st106{fill:#779BC3;}\n\t.st107{fill:#789CC3;}\n\t.st108{fill:#799DC4;}\n\t.st109{fill:#7B9EC5;}\n\t.st110{fill:#7C9FC5;}\n\t.st111{fill:#7DA0C6;}\n\t.st112{fill:#7FA1C6;}\n\t.st113{fill:#80A2C7;}\n\t.st114{fill:#81A3C7;}\n\t.st115{fill:#82A4C8;}\n\t.st116{fill:#84A5C9;}\n\t.st117{fill:#85A6C9;}\n\t.st118{fill:#86A7CA;}\n\t.st119{fill:#88A8CA;}\n\t.st120{fill:#89A9CB;}\n\t.st121{fill:#8AAACC;}\n\t.st122{fill:#8CABCC;}\n\t.st123{fill:#8DACCD;}\n\t.st124{fill:#8EADCD;}\n\t.st125{fill:#90ADCE;}\n\t.st126{fill:#91AECE;}\n\t.st127{fill:#92AFCF;}\n\t.st128{fill:#93B0D0;}\n\t.st129{fill:#95B1D0;}\n\t.st130{fill:#96B2D1;}\n\t.st131{fill:#97B3D1;}\n\t.st132{fill:#99B4D2;}\n\t.st133{fill:#9AB5D2;}\n\t.st134{fill:#9BB6D3;}\n\t.st135{fill:#9DB7D4;}\n\t.st136{fill:#9EB8D4;}\n\t.st137{fill:#9FB9D5;}\n\t.st138{fill:#A1BAD5;}\n\t.st139{fill:#A2BBD6;}\n\t.st140{fill:#A3BCD6;}\n\t.st141{fill:#A4BDD7;}\n\t.st142{fill:#A6BED8;}\n\t.st143{fill:#A7BFD8;}\n\t.st144{fill:#A8C0D9;}\n\t.st145{fill:#AAC0D9;}\n\t.st146{fill:#ABC1DA;}\n\t.st147{fill:#ACC2DA;}\n\t.st148{fill:#AEC3DB;}\n\t.st149{fill:#AFC4DC;}\n\t.st150{fill:#B0C5DC;}\n\t.st151{fill:#B1C6DD;}\n\t.st152{fill:#B3C7DD;}\n\t.st153{fill:#B4C8DE;}\n\t.st154{fill:#B5C9DE;}\n\t.st155{fill:#B7CADF;}\n\t.st156{fill:#B8CBE0;}\n\t.st157{fill:#B9CCE0;}\n\t.st158{fill:#BBCDE1;}\n\t.st159{fill:#BCCEE1;}\n\t.st160{fill:#BDCFE2;}\n\t.st161{fill:#BFD0E2;}\n\t.st162{fill:#C0D1E3;}\n\t.st163{fill:#C1D2E4;}\n\t.st164{fill:#C2D3E4;}\n\t.st165{fill:#C4D3E5;}\n\t.st166{fill:#C5D4E5;}\n\t.st167{fill:#C6D5E6;}\n\t.st168{fill:#C8D6E6;}\n\t.st169{fill:#C9D7E7;}\n\t.st170{fill:#CAD8E8;}\n\t.st171{fill:#CCD9E8;}\n\t.st172{fill:#CDDAE9;}\n\t.st173{fill:#CEDBE9;}\n\t.st174{fill:#D0DCEA;}\n\t.st175{fill:#D1DDEB;}\n\t.st176{fill:#D2DEEB;}\n\t.st177{fill:#D3DFEC;}\n\t.st178{fill:#D5E0EC;}\n\t.st179{fill:#D6E1ED;}\n\t.st180{fill:#D7E2ED;}\n\t.st181{fill:#D9E3EE;}\n\t.st182{fill:#DAE4EF;}\n\t.st183{fill:#DBE5EF;}\n\t.st184{fill:#DDE6F0;}\n\t.st185{fill:#DEE6F0;}\n\t.st186{fill:#DFE7F1;}\n\t.st187{fill:#E1E8F1;}\n\t.st188{fill:#E2E9F2;}\n\t.st189{fill:#E3EAF3;}\n\t.st190{fill:#E4EBF3;}\n\t.st191{fill:#E6ECF4;}\n\t.st192{fill:#E7EDF4;}\n\t.st193{fill:#E8EEF5;}\n\t.st194{fill:#EAEFF5;}\n\t.st195{fill:none;stroke:#437BAC;stroke-width:0.25;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st196{clip-path:url(#SVGID_00000022536119211173603910000012184168373211433643_);}\n\t.st197{fill:#B4CBDF;}\n\t.st198{clip-path:url(#SVGID_00000045587885845987653190000007975354640799186869_);}\n\t.st199{fill:#ABC4DA;}\n\t.st200{fill:#AEC3D6;}\n\t.st201{fill:#467BAA;}\n\t.st202{fill:#E6EDF4;}\n\t.st203{fill:#F5F7FB;}\n\t.st204{fill:#5789B6;stroke:#E6EDF4;stroke-miterlimit:10;}\n\t.st205{clip-path:url(#SVGID_00000045595807879332862710000000448485919797002140_);}\n\t.st206{clip-path:url(#SVGID_00000032631286560912550120000001717323913124172167_);}\n\t.st207{clip-path:url(#SVGID_00000154421886628303768140000016014614680129884852_);}\n\t.st208{fill:#404041;}\n\t.st209{fill:#F1F1F2;}\n\t.st210{fill:#DBDCDD;}\n\t.st211{fill:none;stroke:#437BAC;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st212{fill:none;stroke:#437BAC;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:2.0294,2.0294;}\n\t.st213{fill:#7BA0C5;}\n\t.st214{fill:#7EA1C6;}\n\t.st215{fill:#84A6C9;}\n\t.st216{fill:#87A8CA;}\n\t.st217{fill:#8BABCC;}\n\t.st218{fill:#8DADCD;}\n\t.st219{fill:#90AECE;}\n\t.st220{fill:#91AFCE;}\n\t.st221{fill:#92B0CF;}\n\t.st222{fill:#93B1CF;}\n\t.st223{fill:#94B1D0;}\n\t.st224{fill:#95B2D0;}\n\t.st225{fill:#96B3D1;}\n\t.st226{fill:#97B4D1;}\n\t.st227{fill:#99B5D2;}\n\t.st228{fill:#9AB6D2;}\n\t.st229{fill:#9CB7D3;}\n\t.st230{fill:#9DB8D4;}\n\t.st231{fill:#9EB9D4;}\n\t.st232{fill:#9FBAD5;}\n\t.st233{fill:#A5BED7;}\n\t.st234{fill:#AAC1D9;}\n\t.st235{fill:#ABC2DA;}\n\t.st236{fill:#ACC3DA;}\n\t.st237{fill:#ADC3DB;}\n\t.st238{fill:#AEC4DB;}\n\t.st239{fill:#AFC5DC;}\n\t.st240{fill:#B0C6DC;}\n\t.st241{fill:#B1C7DD;}\n\t.st242{fill:#B6CADF;}\n\t.st243{fill:#B7CBDF;}\n\t.st244{fill:#BACDE1;}\n\t.st245{fill:#BED0E2;}\n\t.st246{fill:#BFD0E3;}\n\t.st247{fill:#C3D4E5;}\n\t.st248{fill:#C7D6E6;}\n\t.st249{fill:#C8D7E7;}\n\t.st250{fill:#C9D8E7;}\n\t.st251{fill:#CBD9E8;}\n\t.st252{fill:#CFDCEA;}\n\t.st253{fill:#D0DDEA;}\n\t.st254{fill:#D4E0EC;}\n\t.st255{fill:#D7E1ED;}\n\t.st256{fill:#D8E2EE;}\n\t.st257{fill:#DCE5F0;}\n\t.st258{fill:#E0E8F1;}\n\t.st259{fill:#E1E9F2;}\n\t.st260{fill:#E2EAF2;}\n\t.st261{fill:#E5ECF4;}\n\t.st262{fill:#E9EEF5;}\n\t.st263{fill:#EAEFF6;}\n\t.st264{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st265{fill:#C1D2E3;}\n\t.st266{fill:#C2D2E4;}\n\t.st267{fill:#C3D3E4;}\n\t.st268{fill:#C3D3E5;}\n\t.st269{fill:#C4D4E5;}\n\t.st270{fill:#C5D5E5;}\n\t.st271{fill:#C6D5E5;}\n\t.st272{fill:#C6D6E6;}\n\t.st273{fill:#C8D7E6;}\n\t.st274{fill:#CAD8E7;}\n\t.st275{fill:#CCDAE8;}\n\t.st276{fill:#CDDBE9;}\n\t.st277{fill:#D1DDEA;}\n\t.st278{fill:#D1DEEB;}\n\t.st279{fill:#D3DFEB;}\n\t.st280{fill:#D4DFEC;}\n\t.st281{fill:#DAE3EE;}\n\t.st282{fill:#DAE4EE;}\n\t.st283{fill:#DBE4EF;}\n\t.st284{fill:#DCE5EF;}\n\t.st285{fill:#DEE7F0;}\n\t.st286{fill:#E1E9F1;}\n\t.st287{fill:#E3EAF2;}\n\t.st288{fill:#E5EBF3;}\n\t.st289{fill:#E5ECF3;}\n\t.st290{fill:#E8EEF4;}\n\t.st291{fill:#E9EFF5;}\n\t.st292{fill:none;stroke:#5B87B7;stroke-width:0.25;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st293{clip-path:url(#SVGID_00000151519090450156637780000006417116767725055131_);}\n\t.st294{fill:#B5B5B5;}\n\t.st295{fill:#DCDCDC;}\n\t.st296{fill:#144957;}\n\t.st297{fill:#5D5D5D;}\n\t.st298{fill:#626262;}\n\t.st299{fill:#8F8F8F;}\n\t.st300{fill:#7E7E7E;}\n\t.st301{fill:#383838;}\n\t.st302{fill:#767676;}\n\t.st303{fill:#B8B8B8;}\n\t.st304{opacity:9.000000e-02;fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "622.3,242.1 622.3,252 612.2,252 612.2,205.8 608.7,205.8 603.6,200.7 596.9,200.7 591.7,205.9  588.5,205.9 588.5,252 576.7,252 576.7,266.8 567.7,266.8 567.7,225.3 563.4,225.3 563.4,232.2 561.5,232.2 561.5,239.9  559.3,239.9 559.3,266.8 556.1,266.8 556.1,232.4 553.4,232.4 553.4,182.9 545.5,182.9 545.5,180.4 536.4,180.4 536.4,182.9  534.1,182.9 534.1,232.4 530.9,232.4 530.9,249.4 519.4,249.4 519.4,263.1 509.4,263.1 509.4,241 494,241 494,176.8 490.8,176.8  490.8,174.1 472.3,174.1 459.6,184.1 459.6,227.6 447.7,227.6 444.3,230.9 444.3,235 445.9,235 445.9,259 440.5,259 440.5,251.8  429.1,251.8 429.1,190.3 408,190.3 402,196.3 402,203.5 404.8,203.5 404.8,246.1 395.2,246.1 395.2,233.4 371.2,233.4 371.2,245.8  344.8,245.8 344.8,205.9 340.3,205.9 333.9,199.4 325.5,199.4 318.9,206 314.9,206 314.9,245.8 313.8,245.8 313.8,264.5  310.7,264.5 310.7,237 305.4,237 305.4,245.7 302.9,245.7 302.9,255.3 300.2,255.3 300.2,264.5 287.9,264.5 287.9,241 260.1,241  259,241 259,275.6 429.1,275.6 472.3,275.6 498.4,275.6 629.9,275.6 629.9,242.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M539.5,175.6c-0.4-0.4-0.6-0.9-0.6-1.5c0-0.6,0.2-1.1,0.6-1.5c0,0-0.1-0.1-0.1-0.1c-1,0.9-0.9,2.4,0,3.3 C539.4,175.6,539.5,175.6,539.5,175.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M542.6,175.6c0,0,0.1,0.1,0.1,0.1c0.9-0.9,0.9-2.4,0-3.3c0,0-0.1,0.1-0.1,0.1c0.4,0.4,0.6,0.9,0.6,1.5 C543.2,174.6,543,175.1,542.6,175.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M539.8,175.3c0,0,0.1-0.1,0.1-0.1c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.4,0.2-0.8,0.5-1.1c0,0-0.1-0.1-0.1-0.1 C539.1,173.5,539.1,174.6,539.8,175.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M542.2,175.2c0,0,0.1,0.1,0.1,0.1c0.7-0.7,0.7-1.9,0-2.5c0,0-0.1,0.1-0.1,0.1 C542.8,173.5,542.9,174.5,542.2,175.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M542,174.9c0.5-0.5,0.5-1.3,0-1.7c0,0-0.1,0.1-0.1,0.1c0.2,0.2,0.3,0.5,0.3,0.8c0,0.3-0.1,0.5-0.3,0.7 C541.9,174.8,541.9,174.9,542,174.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M540.2,174.9c0,0,0.1-0.1,0.1-0.1c-0.4-0.5-0.4-1,0-1.5c0,0-0.1-0.1-0.1-0.1 C539.6,173.7,539.7,174.5,540.2,174.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M544.3,180.1h-1.2l-1.6-5.8c0.1-0.1,0.1-0.2,0.1-0.3c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 c0,0.1,0,0.2,0.1,0.3l-0.6,2.2c0,0,0,0,0,0c0,0,0,0,0,0l-0.4,1.5c0,0,0,0,0,0c0,0,0,0,0,0l-0.6,2.1h-1.2v0.2h6.4V180.1z  M542.6,179.3l-1.3-0.6l1-0.5L542.6,179.3z M541.7,176.4h-1.3l0.6-0.7L541.7,176.4z M540.8,175.1h0.5l-0.2,0.2L540.8,175.1z  M541.6,176.6L541,177l-0.5-0.4H541.6z M542,177.9h-1.9l0.9-0.6L542,177.9z M541.9,178.1l-0.8,0.4l-0.8-0.4H541.9z M542.3,179.4 l-1.2,0l-1.2,0l1.2-0.6L542.3,179.4z M542.2,177.7l-0.9-0.6l0.6-0.4L542.2,177.7z M541.5,175.2l0.2,0.8l-0.5-0.5L541.5,175.2z  M541.1,173.6c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3C540.7,173.8,540.9,173.6,541.1,173.6z  M540.8,174.5c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.2-0.1l0.1,0.4h-0.7L540.8,174.5z M540.6,175.2l0.3,0.3l-0.5,0.5L540.6,175.2z  M540.2,176.7l0.6,0.4l-0.9,0.6L540.2,176.7z M539.8,178.2l1,0.5l-1.3,0.6L539.8,178.2z M539.3,180.1l0.1-0.5l1.7,0l1.7,0l0.1,0.5 H539.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M638.8,261.2h-73v0.1h-4.5v-18h-19.2v9.1h-9.9v-32.6h-18.3v11.1h-6.3v-3.9h-7.6v3.9h-3.7v23.5h-7.8v4.5 l-3.9,3.9h-6.3v-2.9h-4.9v-11.5h-2.5v-12.2h-2v-23.9h-12V236h-3.2v-9.2h-6.5l-3.5-3.5v-4.1h-3.4v4.6h-6.5v11.5h-2.8v-4.6h-1.4v4.8 h-2.3v28.9h-3.5v-14.3h-11l-5.6,6.9h-15.1v-31.2h-4.1V214h-8.1l-4.5-4.5v-5.2h-4.3v5.8h-8.1v14.5h-1.7v-5.8h-1.7v6h-4.7v36.5h-4.5 v-14.5h-19.2v5.5h-9.9v-16.7h-18.3v11.1h-6.3v-3.9H293v-10.7h0.4v1.2h0.2v-0.2h0.2v1.1h0.4v0.1h-0.2v0.1h0.1v0.4h0v-0.4h0.6v0.4h0 v-0.4h0.1v-0.1h-0.2v-0.1h0.4V232l0.3-0.1v1.2h0v1.4h0.1v-1.4h0v-1.2l0.3-0.1v0.6h0.2v-0.2h0.2v1.2h0.4v0.1h-0.2v0.1h0.1v0.4h0v-0.4 h0.6v0.4h0v-0.4h0.1v-0.1h-0.2v-0.1h0.4v-4.9h-0.2v-0.9h-0.1v0.9h-0.1v-0.5h-0.1v0.5h-0.8v0.7h-0.2v-0.2h-0.2v1.7h-0.3V229h0v-0.9 h-0.1v0.9h0v1.8h-0.3v-1.5h-0.2v-0.9h-0.1v0.9h-0.1v-0.5h-0.1v0.5h-0.8v0.8h-0.2v-0.2h-0.2v0.9H293V225h0.4v1.2h0.2V226h0.2v1.1h0.4 v0.1h-0.2v0.1h0.1v0.4h0v-0.4h0.6v0.4h0v-0.4h0.1v-0.1h-0.2v-0.1h0.4v-2.2l0.3-0.1v1.2h0v1.4h0.1V226h0v-1.2l0.3-0.1v0.6h0.2v-0.2 h0.2v1.2h0.4v0.1h-0.2v0.1h0.1v0.4h0v-0.4h0.6v0.4h0v-0.4h0.1v-0.1h-0.2v-0.1h0.4v-4.9h-0.2v-0.9h-0.1v0.9h-0.1V221h-0.1v0.5h-0.8 v0.7h-0.2v-0.2h-0.2v1.7h-0.3v-1.8h0V221h-0.1v0.9h0v1.8h-0.3v-1.5h-0.2v-0.9h-0.1v0.9h-0.1v-0.5h-0.1v0.5h-0.8v0.8h-0.2v-0.2h-0.2 v0.9H293v-4.5h-0.1v0.2h-0.4V219h0.1l-0.1-0.4h0.1l0.1-0.4h0.2c0,0,0.1,0,0.1-0.1v-0.3h0.4v1.2h0.2v-0.2h0.2v1.1h0.4v0.1h-0.2v0.1 h0.1v0.4h0v-0.4h0.6v0.4h0v-0.4h0.1v-0.1h-0.2V220h0.4v-2.2l0.3-0.1v1.2h0v1.4h0.1v-1.4h0v-1.2l0.3-0.1v0.6h0.2V218h0.2v1.2h0.4v0.1 h-0.2v0.1h0.1v0.4h0v-0.4h0.6v0.4h0v-0.4h0.1v-0.1h-0.2v-0.1h0.4v-4.9h-0.2v-0.9h-0.1v0.9h-0.1v-0.5h-0.1v0.5h-0.8v0.7h-0.2v-0.2 h-0.2v1.7h-0.3v-1.8h0v-0.9h-0.1v0.9h0v1.8h-0.3v-1.5h-0.2v-0.9h-0.1v0.9h-0.1v-0.5h-0.1v0.5h-0.8v0.8h-0.2v-0.2h-0.2v0.9h-1.1v-0.4 h-0.1v0.4H292v-3.1h-0.1v3.1h-0.2v-0.4h-0.1v0.4h-1.2v-1.5h-0.2v-0.9h-0.1v0.9h-0.1v-0.5H290v0.5h-0.8v0.8h-0.2v-0.2h-0.2v0.9h-0.4 v-1.8h0v-0.9h-0.1v0.9h0v1.8H288v-2.2h-0.2v-0.9h-0.1v0.9h-0.1v-0.5h-0.1v0.5h-0.8v0.7h-0.2v-0.2h-0.2v3.4h0.2V218h0.2v1.2h0.4v0.1 h-0.2v0.1h0.1v0.4h0v-0.4h0.6v0.4h0v-0.4h0.1v-0.1h-0.2v-0.1h0.4v-1.8l0.4,0.1v1.2h0v1.4h0.1v-1.4h0v-1.2l0.4,0.1v1.4h0.2v-0.2h0.2 v1.1h0.4v0.1h-0.2v0.1h0.1v0.4h0v-0.4h0.6v0.4h0v-0.4h0.1v-0.1h-0.2V220h0.4v-2.1h0.4v0.3c0,0,0,0.1,0.1,0.1h0.2l0.1,0.4h0.1v0.1 l0,0.2h0v4.7h-0.9v-1.5h-0.2v-0.9h-0.1v0.9h-0.1v-0.5H290v0.5h-0.8v0.8h-0.2v-0.2h-0.2v0.9h-0.4v-1.8h0V221h-0.1v0.9h0v1.8H288v-2.2 h-0.2v-0.9h-0.1v0.9h-0.1V221h-0.1v0.5h-0.8v0.7h-0.2v-0.2h-0.2v3.4h0.2v-0.2h0.2v1.2h0.4v0.1h-0.2v0.1h0.1v0.4h0v-0.4h0.6v0.4h0 v-0.4h0.1v-0.1h-0.2v-0.1h0.4v-1.8l0.4,0.1v1.2h0v1.4h0.1V226h0v-1.2l0.4,0.1v1.4h0.2V226h0.2v1.1h0.4v0.1h-0.2v0.1h0.1v0.4h0v-0.4 h0.6v0.4h0v-0.4h0.1v-0.1h-0.2v-0.1h0.4V225h0.4v0.3c0,0,0,0.1,0.1,0.1h0.2l0.1,0.4h0.1v0.1l0,0.2h0v4.7h-0.9v-1.5h-0.2v-0.9h-0.1 v0.9h-0.1v-0.5H290v0.5h-0.8v0.8h-0.2v-0.2h-0.2v0.9h-0.4V229h0v-0.9h-0.1v0.9h0v1.8H288v-2.2h-0.2v-0.9h-0.1v0.9h-0.1v-0.5h-0.1 v0.5h-0.8v0.7h-0.2v-0.2h-0.2v3.4h0.2v-0.2h0.2v1.2h0.4v0.1h-0.2v0.1h0.1v0.4h0v-0.4h0.6v0.4h0v-0.4h0.1v-0.1h-0.2v-0.1h0.4v-1.8 l0.4,0.1v1.2h0v1.4h0.1v-1.4h0v-1.2l0.4,0.1v1.4h0.2v-0.2h0.2v1.1h0.4v0.1h-0.2v0.1h0.1v0.4h0v-0.4h0.6v0.4h0v-0.4h0.1v-0.1h-0.2 v-0.1h0.4v-2.1h0.4v0.3c0,0,0,0.1,0.1,0.1h0.2l0.1,0.4h0.1v0.1l0,0.2h0v9.5h-2v3.9h-3.7v7.6h-7.8v4.5l-3.9,3.9h-6.3v-2.9h-4.9v-11.5 h-2.5v-12.2H259v2.9h-11.7v19.8h-7.8V257h2.2v-3.3h-11.3v3.3h2.2v1.8h-9.5V257h2.2v-3.3h-11.3v3.3h2.2v1.8h-7.3v2.5h-1h-1.5v7.8h1.5 v-1.9h1v4h-3.5l-1.5,4.4h5H233h14.3H259h8.7h90.6h60.9h59.3h169.3L638.8,261.2z M295.7,229.4h0.2v1.4h-0.2V229.4z M295.7,230.8h0.2 v0.1L295.7,230.8L295.7,230.8z M295.7,231h0.2v0.3h-0.2V231z M295.7,231.5l0.2,0v0.1L295.7,231.5L295.7,231.5z M295.7,231.8l0.2,0 v0.4h-0.2V231.8z M295.5,231.6h-0.1H295.5L295.5,231.6z M295.3,230.8h0.3v0.1L295.3,230.8L295.3,230.8z M295.3,231h0.3v0.3h-0.3V231 z M294.9,230.8h0.3v0.1L294.9,230.8L294.9,230.8z M294.9,231h0.3v0.3h-0.3V231z M293.6,230.2h0.2v0.6h-0.2V230.2z M293.6,230.8h0.2 v0.1L293.6,230.8L293.6,230.8z M293.6,231h0.2v0.3h-0.2V231z M293.6,232.1h0.2v0.9h-0.2V232.1z M295.7,222.2h0.2v1.4h-0.2V222.2z  M295.7,223.7h0.2v0.1L295.7,223.7L295.7,223.7z M295.7,223.9h0.2v0.3h-0.2V223.9z M295.7,224.4l0.2,0v0.1L295.7,224.4L295.7,224.4z  M295.7,224.7l0.2,0v0.4h-0.2V224.7z M295.5,224.5h-0.1H295.5L295.5,224.5z M295.3,223.7h0.3v0.1L295.3,223.7L295.3,223.7z  M295.3,223.9h0.3v0.3h-0.3V223.9z M294.9,223.7h0.3v0.1L294.9,223.7L294.9,223.7z M294.9,223.9h0.3v0.3h-0.3V223.9z M293.6,223.1 h0.2v0.6h-0.2V223.1z M293.6,223.7h0.2v0.1L293.6,223.7L293.6,223.7z M293.6,223.9h0.2v0.3h-0.2V223.9z M293.6,225h0.2v0.9h-0.2V225 z M295.7,215.1h0.2v1.4h-0.2V215.1z M295.7,216.6h0.2v0.1L295.7,216.6L295.7,216.6z M295.7,216.8h0.2v0.3h-0.2V216.8z M295.7,217.3 l0.2,0v0.1L295.7,217.3L295.7,217.3z M295.7,217.5l0.2,0v0.4h-0.2V217.5z M295.5,217.4h-0.1H295.5L295.5,217.4z M295.3,216.6h0.3 v0.1L295.3,216.6L295.3,216.6z M295.3,216.8h0.3v0.3h-0.3V216.8z M294.9,216.6h0.3v0.1L294.9,216.6L294.9,216.6z M294.9,216.8h0.3 v0.3h-0.3V216.8z M293.6,216h0.2v0.6h-0.2V216z M293.6,216.6h0.2v0.1L293.6,216.6L293.6,216.6z M293.6,216.8h0.2v0.3h-0.2V216.8z  M293.6,217.9h0.2v0.9h-0.2V217.9z M286.7,218h-0.2v-2.8h0.2V218z M288.4,217.4H288v-0.1L288.4,217.4L288.4,217.4z M288.4,217.1H288 v-0.3h0.4V217.1z M288.4,216.7H288v-0.1L288.4,216.7L288.4,216.7z M288.5,217.4L288.5,217.4h0.1H288.5z M288.9,217.1h-0.4v-0.3h0.4 V217.1z M288.9,216.7h-0.4v-0.1L288.9,216.7L288.9,216.7z M289.3,218.8h-0.2v-1.1l0.2,0V218.8z M289.3,217.1h-0.2v-0.3h0.2V217.1z  M289.3,216.7h-0.2v-0.1L289.3,216.7L289.3,216.7z M289.3,216.5h-0.2V216h0.2V216.5z M292.2,216.6h1.1v0.1L292.2,216.6L292.2,216.6z  M292.2,216.8h1.1v0.3h-1.1V216.8z M292,216.6h0.2v0.1L292,216.6L292,216.6z M292,216.8h0.2v0.3H292V216.8z M291.7,216.6h0.2v0.1 L291.7,216.6L291.7,216.6z M291.7,216.8h0.2v0.3h-0.2V216.8z M290.5,216.6h1.2v0.1L290.5,216.6L290.5,216.6z M290.5,217.1v-0.3h1.2 v0.3H290.5z M286.7,225.1h-0.2v-2.8h0.2V225.1z M288.4,224.5H288v-0.1L288.4,224.5L288.4,224.5z M288.4,224.2H288v-0.3h0.4V224.2z  M288.4,223.8H288v-0.1L288.4,223.8L288.4,223.8z M288.5,224.5L288.5,224.5h0.1H288.5z M288.9,224.2h-0.4v-0.3h0.4V224.2z  M288.9,223.8h-0.4v-0.1L288.9,223.8L288.9,223.8z M289.3,226h-0.2v-1.1l0.2,0V226z M289.3,224.2h-0.2v-0.3h0.2V224.2z M289.3,223.8 h-0.2v-0.1L289.3,223.8L289.3,223.8z M289.3,223.7h-0.2v-0.6h0.2V223.7z M286.7,232.2h-0.2v-2.8h0.2V232.2z M288.4,231.6H288v-0.1 L288.4,231.6L288.4,231.6z M288.4,231.3H288V231h0.4V231.3z M288.4,230.9H288v-0.1L288.4,230.9L288.4,230.9z M288.5,231.6 L288.5,231.6h0.1H288.5z M288.9,231.3h-0.4V231h0.4V231.3z M288.9,230.9h-0.4v-0.1L288.9,230.9L288.9,230.9z M289.3,233.1h-0.2V232 l0.2,0V233.1z M289.3,231.3h-0.2V231h0.2V231.3z M289.3,230.9h-0.2v-0.1L289.3,230.9L289.3,230.9z M289.3,230.8h-0.2v-0.6h0.2V230.8 z M222.4,258.8h-5.6V257h5.6V258.8z M238.8,258.8h-5.6V257h5.6V258.8z M292.9,233.3v0.2h-0.4v-0.2H292.9z M292.9,230.9h-0.4v-0.1 L292.9,230.9L292.9,230.9z M292.6,233.1h0.4v0.2h-0.3L292.6,233.1z M292.6,233l0-0.1h0.1l0,0h0.3v0.2H292.6z M292.7,232.8l0-0.2h0.2 v0.2H292.7z M292.7,232.6L292.7,232.6l0.2-0.1v0.1H292.7z M292.9,231.2h-0.4v-0.2h0.4V231.2z M292.5,231.3h0.4v0L292.5,231.3 L292.5,231.3z M292.9,233.5v0.2h-0.4v-0.2H292.9z M292.9,233.8v0.2h-0.4v-0.2H292.9z M292.9,234v0.2h-0.4V234H292.9z M292.9,234.2 v0.2h-0.4v-0.2H292.9z M292.9,234.4v0.2h-0.4v-0.2H292.9z M292.9,234.7v0.2h-0.4v-0.2H292.9z M292.9,234.9v0.2h-0.4v-0.2H292.9z  M292.9,235.1v0.2h-0.4v-0.2H292.9z M292.9,235.3v0.2h-0.4v-0.2H292.9z M292.9,235.6v0.2h-0.4v-0.2H292.9z M292.9,235.8v0.2h-0.4 v-0.2H292.9z M292.9,236v0.2h-0.4V236H292.9z M292.9,236.2v0.2h-0.4v-0.2H292.9z M292.9,236.5v0.2h-0.4v-0.2H292.9z M292.9,236.7 v0.2h-0.4v-0.2H292.9z M292.9,236.9v0.2h-0.4v-0.2H292.9z M292.9,237.1v0.2h-0.4v-0.2H292.9z M292.9,237.3v0.2h-0.4v-0.2H292.9z  M292.9,237.6v0.2h-0.4v-0.2H292.9z M292.9,237.8v0.2h-0.4v-0.2H292.9z M292.9,238v0.2h-0.4V238H292.9z M292.9,238.2v0.2h-0.4v-0.2 H292.9z M292.9,238.5v0.2h-0.4v-0.2H292.9z M292.9,238.7v0.2h-0.4v-0.2H292.9z M292.9,238.9v0.2h-0.4v-0.2H292.9z M292.9,239.1v0.2 h-0.4v-0.2H292.9z M292.9,239.4v0.2h-0.4v-0.2H292.9z M292.9,239.6v0.2h-0.4v-0.2H292.9z M292.9,239.8v0.2h-0.4v-0.2H292.9z  M292.9,240v0.2h-0.4V240H292.9z M292.9,240.3v0.2h-0.4v-0.2H292.9z M292.9,240.5v0.2h-0.4v-0.2H292.9z M292.9,240.7v0.2h-0.4v-0.2 H292.9z M292.9,240.9v0.2h-0.4v-0.2H292.9z M292.9,241.2v0.2h-0.4v-0.2H292.9z M292.9,241.4v0.2h-0.4v-0.2H292.9z M292.9,241.6v0.2 h-0.4v-0.2H292.9z M292.9,241.8v0.2h-0.4v-0.2H292.9z M292.9,242.1v0.2h-0.4v-0.2H292.9z M292.9,242.3v0.2h-0.4v-0.2H292.9z  M292.9,242.5v0.2h-0.4v-0.2H292.9z M293.4,231.3H293V231h0.4V231.3z M293.4,230.8L293.4,230.8l-0.4,0.1v-0.1H293.4z M292.9,226.1 v0.2h-0.4v-0.2H292.9z M292.6,225.9h0.4v0.2h-0.3L292.6,225.9z M292.5,225.9L292.5,225.9L292.5,225.9l0.1-0.2h0.3v0.2H292.5z  M292.7,225.6l0-0.2h0.2v0.2H292.7z M292.7,225.4L292.7,225.4l0.2,0v0H292.7z M292.9,224.1h-0.4v-0.2h0.4V224.1z M292.5,223.8 L292.5,223.8l0.4-0.1v0.1H292.5z M292.5,224.1h0.4v0.1L292.5,224.1L292.5,224.1z M292.9,226.4v0.2h-0.4v-0.2H292.9z M292.9,226.6 v0.2h-0.4v-0.2H292.9z M292.9,226.8v0.2h-0.4v-0.2H292.9z M292.9,227v0.2h-0.4V227H292.9z M292.9,227.3v0.2h-0.4v-0.2H292.9z  M292.9,227.5v0.2h-0.4v-0.2H292.9z M292.9,227.7v0.2h-0.4v-0.2H292.9z M292.9,227.9v0.2h-0.4v-0.2H292.9z M292.9,228.2v0.2h-0.4 v-0.2H292.9z M292.9,228.4v0.2h-0.4v-0.2H292.9z M292.9,228.6v0.2h-0.4v-0.2H292.9z M292.9,228.8v0.2h-0.4v-0.2H292.9z M292.9,229.1 v0.2h-0.4v-0.2H292.9z M292.9,229.3v0.2h-0.4v-0.2H292.9z M292.9,229.5v0.2h-0.4v-0.2H292.9z M292.9,229.7v0.2h-0.4v-0.2H292.9z  M292.9,230v0.2h-0.4V230H292.9z M292.9,230.2v0.2h-0.4v-0.2H292.9z M292.9,230.4v0.2h-0.4v-0.2H292.9z M292.9,230.6v0.2h-0.4v-0.2 H292.9z M293.4,224.2H293v-0.3h0.4V224.2z M293.4,223.8H293v-0.1L293.4,223.8L293.4,223.8z M292.9,219.9v0.2h-0.4v-0.2H292.9z  M292.5,219.8v-0.2h0.4v0.2H292.5z M292.9,220.1v0.2h-0.4v-0.2H292.9z M292.9,220.3v0.2h-0.4v-0.2H292.9z M292.9,220.5v0.2h-0.4 v-0.2H292.9z M292.9,220.8v0.2h-0.4v-0.2H292.9z M292.9,221v0.2h-0.4V221H292.9z M292.9,221.2v0.2h-0.4v-0.2H292.9z M292.9,221.4 v0.2h-0.4v-0.2H292.9z M292.9,221.7v0.2h-0.4v-0.2H292.9z M292.9,221.9v0.2h-0.4v-0.2H292.9z M292.9,222.1v0.2h-0.4v-0.2H292.9z  M292.9,222.3v0.2h-0.4v-0.2H292.9z M292.9,222.6v0.2h-0.4v-0.2H292.9z M292.9,222.8v0.2h-0.4v-0.2H292.9z M292.9,223v0.2h-0.4V223 H292.9z M292.9,223.2v0.2h-0.4v-0.2H292.9z M292.9,223.5v0.2h-0.4v-0.2H292.9z M292.9,219.4v0.2h-0.4v-0.2H292.9z M290.5,223.7h0.9 v0.1L290.5,223.7L290.5,223.7z M290.5,224.2v-0.3h0.9v0.3H290.5z M290.5,230.8h0.9v0.1L290.5,230.8L290.5,230.8z M290.5,231.3V231 h0.9v0.3H290.5z M292.5,242.7h0.4v0.1L292.5,242.7L292.5,242.7z M530.1,240.8h-14.1v-18.6h14.1V240.8z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M607.9,275.6v-0.3h-1v-16.2l0.8-0.8v-0.5h0.2v-3h-1v-1.2c0-0.3-0.3-0.6-0.6-0.6h-2V253h-3.8v0.9h3.8v-0.2h2 v21.6h-1.9v0.3h-87v-0.3h-1v-16.2l0.8-0.8v-0.5h0.2v-3h-1v-1.2c0-0.3-0.3-0.6-0.6-0.6h-2V253h-3.8v0.9h3.8v-0.2h2v21.6h-1.9v0.3 h-81.6v-0.3h-1v-16.2l0.8-0.8v-0.5h0.2v-3h-1v-1.2c0-0.3-0.3-0.6-0.6-0.6h-2V253h-3.8v0.9h3.8v-0.2h2v21.6h-1.9v0.3h-81.6v-0.3h-1 v-16.2l0.8-0.8v-0.5h0.2v-3h-1v-1.2c0-0.3-0.3-0.6-0.6-0.6h-2V253h-3.8v0.9h3.8v-0.2h2v21.6h-1.9v0.3h-71.6v-0.3h-1v-16.2l0.8-0.8 v-0.5h0.2v-3h-1v-1.2c0-0.3-0.3-0.6-0.6-0.6h-2V253h-3.8v0.9h3.8v-0.2h2v21.6h-1.9v0.3H0v13.2h880.8v-13.2H607.9z M607,255h0.8v2.6 H607V255z M606.9,257.8h0.6v0.4l-0.6,0.6V257.8z M516.4,255h0.8v2.6h-0.8V255z M516.3,257.8h0.6v0.4l-0.6,0.6V257.8z M431.2,255 h0.8v2.6h-0.8V255z M431.1,257.8h0.6v0.4l-0.6,0.6V257.8z M346,255h0.8v2.6H346V255z M345.9,257.8h0.6v0.4l-0.6,0.6V257.8z  M270.8,255h0.8v2.6h-0.8V255z M270.7,257.8h0.6v0.4l-0.6,0.6V257.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M519,252.7c0.5,0.5,0.8,1.1,0.8,1.9c0.1,0,0.1,0,0.2,0c0-1.6-1.3-2.9-2.8-2.8c0,0.1,0,0.1,0,0.2 C517.9,252,518.5,252.2,519,252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M519.1,254.6c0.1,0,0.1,0,0.2,0c0-1.2-1.1-2.2-2.1-2.2c0,0.1,0,0.1,0,0.2C518.1,252.6,519.1,253.5,519.1,254.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M517.1,253.1c0,0.1,0,0.1,0,0.2c0.4,0,0.7,0.1,0.9,0.4c0.3,0.3,0.4,0.6,0.4,0.9c0.1,0,0.1,0,0.2,0 C518.7,253.7,517.9,253,517.1,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M433.8,252.7c0.5,0.5,0.8,1.1,0.8,1.9c0.1,0,0.1,0,0.2,0c0-1.6-1.3-2.9-2.8-2.8c0,0.1,0,0.1,0,0.2 C432.7,252,433.3,252.2,433.8,252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M433.9,254.6c0.1,0,0.1,0,0.2,0c0-1.2-1.1-2.2-2.1-2.2c0,0.1,0,0.1,0,0.2C432.9,252.6,433.9,253.5,433.9,254.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M431.9,253.1c0,0.1,0,0.1,0,0.2c0.4,0,0.7,0.1,0.9,0.4c0.3,0.3,0.4,0.6,0.4,0.9c0.1,0,0.1,0,0.2,0 C433.5,253.7,432.7,253,431.9,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M348.6,252.7c0.5,0.5,0.8,1.1,0.8,1.9c0.1,0,0.1,0,0.2,0c0-1.6-1.3-2.9-2.8-2.8c0,0.1,0,0.1,0,0.2 C347.5,252,348.1,252.2,348.6,252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M348.7,254.6c0.1,0,0.1,0,0.2,0c0-1.2-1.1-2.2-2.1-2.2c0,0.1,0,0.1,0,0.2C347.8,252.6,348.7,253.5,348.7,254.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M346.8,253.1c0,0.1,0,0.1,0,0.2c0.4,0,0.7,0.1,0.9,0.4c0.3,0.3,0.4,0.6,0.4,0.9c0.1,0,0.1,0,0.2,0 C348.3,253.7,347.5,253,346.8,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.4,252.7c0.5,0.5,0.8,1.1,0.8,1.9c0.1,0,0.1,0,0.2,0c0-1.6-1.3-2.9-2.8-2.8c0,0.1,0,0.1,0,0.2 C272.3,252,272.9,252.2,273.4,252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.5,254.6c0.1,0,0.1,0,0.2,0c0-1.2-1.1-2.2-2.1-2.2c0,0.1,0,0.1,0,0.2C272.6,252.6,273.5,253.5,273.5,254.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M271.6,253.1c0,0.1,0,0.1,0,0.2c0.4,0,0.7,0.1,0.9,0.4c0.3,0.3,0.4,0.6,0.4,0.9c0.1,0,0.1,0,0.2,0 C273.1,253.7,272.3,253,271.6,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M609.6,252.7c0.5,0.5,0.8,1.1,0.8,1.9c0.1,0,0.1,0,0.2,0c0-1.6-1.3-2.9-2.8-2.8c0,0.1,0,0.1,0,0.2 C608.4,252,609.1,252.2,609.6,252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M609.7,254.6c0.1,0,0.1,0,0.2,0c0-1.2-1.1-2.2-2.1-2.2c0,0.1,0,0.1,0,0.2C608.7,252.6,609.7,253.5,609.7,254.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M607.7,253.1c0,0.1,0,0.1,0,0.2c0.4,0,0.7,0.1,0.9,0.4c0.3,0.3,0.4,0.6,0.4,0.9c0.1,0,0.1,0,0.2,0 C609.3,253.7,608.5,253,607.7,253.1z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M911.5,280.7H598.1v-6.9c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v6.9h-204v-6.9c0-0.8-0.7-1.5-1.5-1.5 s-1.5,0.7-1.5,1.5v6.9h-124v-6.9c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v6.9H-12.1c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h923.6 c0.8,0,1.5-0.7,1.5-1.5S912.3,280.7,911.5,280.7z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 381.1684 163.2653)",
    className: "st4 st5 st6"
  }, "Core Network")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 180.5468 20.0145)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st4 st7 st8"
  }, "Macro"), /*#__PURE__*/React.createElement("tspan", {
    x: -15.4,
    y: 11.2,
    className: "st4 st7 st8"
  }, "Cell Towers"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 241.2123 423.8358)",
    className: "st4 st7 st8"
  }, "Outdoor DAS")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 345.0851 20.0145)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st4 st7 st8"
  }, "Fiber"), /*#__PURE__*/React.createElement("tspan", {
    x: -12,
    y: 11.2,
    className: "st4 st7 st8"
  }, "Networks"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 570.3554 423.8359)",
    className: "st4 st7 st8"
  }, "Indoor DAS")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 660.6662 20.4851)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st4 st7 st8"
  }, "Rooftop"), /*#__PURE__*/React.createElement("tspan", {
    x: -9.6,
    y: 11.2,
    className: "st4 st7 st8"
  }, "Cell Towers"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 485.4582 23.6932)",
    className: "st4 st7 st8"
  }, "Data Centers")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 410.3408 423.8363)",
    className: "st4 st7 st8"
  }, "Small Cells")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "278.6,315.5 278.6,265.3 234.2,265.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "235.6,260.3 227,265.3 235.6,270.3  "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "197.6,134.8 197.6,223.4 277.7,223.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "276.2,228.4 284.8,223.4 276.2,218.4  "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "359.6,134.8 359.6,198.9 389.5,198.9 389.5,265.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "384.5,263.7 389.5,272.3 394.5,263.7  "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "440.4,315.5 440.4,256.4 501.1,256.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "499.6,261.3 508.3,256.4 499.6,251.4  "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 602.5,
    y1: 315.5,
    x2: 602.5,
    y2: 220.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "607.5,221.8 602.5,213.2 597.5,221.8  "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 521.5,
    y1: 134,
    x2: 521.5,
    y2: 208.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "516.5,207.3 521.5,216 526.5,207.3  "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "683.5,134.8 683.5,179.1 554.4,179.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "555.8,174.1 547.2,179.1 555.8,184.1  "
  }))))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "642.5,385.4 642.5,339.2 602.5,316 562.5,339.2 562.5,385.4 602.5,408.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157267221353554013040000006610273207434677437_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000157267221353554013040000006610273207434677437_)"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 602.5,
    cy: 364.9,
    r: 72.3
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M602.5,419.1c-0.1,0-0.1,0-0.2,0l-23.9-10.4c-0.2-0.1-0.3-53.4-0.3-53.6c0-0.2,0.1-0.4,0.3-0.4l23.9-10.4 c0.1-0.1,0.3-0.1,0.4,0l23.9,10.4c0.2,0.1,0.3,0.2,0.3,0.4c0,0.2-0.1,53.5-0.3,53.6l-23.9,10.4 C602.6,419.1,602.6,419.1,602.5,419.1z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 623.2,
    cy: 350.1,
    r: 69.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 623.2,
    cy: 350.1,
    r: 64.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 623.2,
    cy: 350.1,
    r: 58.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 623.2,
    cy: 350.1,
    r: 52.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 623.2,
    cy: 350.1,
    r: 47.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 623.2,
    cy: 350.1,
    r: 41.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 623.2,
    cy: 350.1,
    r: 36.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 623.2,
    cy: 350.1,
    r: 30.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 623.2,
    cy: 350.1,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 623.2,
    cy: 350.1,
    r: 19.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 623.2,
    cy: 350.1,
    r: 13.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 623.2,
    cy: 350.1,
    r: 8.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 623.2,
    cy: 350.1,
    r: 2.7
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "602.5,344.7 578.6,355.1 578.6,402.6 602.5,412.9 626.4,402.6 626.4,355.1  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "602.5,394.8 578.6,384.5 602.5,374.1 626.4,384.5  "
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M602.5,391.5c0,0-0.1,0-0.1,0l-15.6-6.8c-0.1,0-0.2-0.2-0.2-0.3s0.1-0.2,0.2-0.3l15.6-6.8 c0.1,0,0.2,0,0.2,0l15.6,6.8c0.1,0,0.2,0.2,0.2,0.3s-0.1,0.2-0.2,0.3l-15.6,6.8C602.6,391.5,602.6,391.5,602.5,391.5z  M587.7,384.5l14.8,6.4l14.8-6.4l-14.8-6.4L587.7,384.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 618.1,
    cy: 384.5,
    rx: 2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 602.5,
    cy: 377.7,
    rx: 2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 586.9,
    cy: 384.5,
    rx: 2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 602.5,
    cy: 391.2,
    rx: 2,
    ry: 1.2
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "590.6,389.8 590.5,389.5 610.3,380.9 610.4,381.2  "
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "602.5,384.5 578.6,374.1 602.5,363.7 626.4,374.1  "
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M590.5,379.6c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.2,0-0.3,0.2-0.4l19.8-8.6c0.2-0.1,0.3,0,0.4,0.2 c0.1,0.2,0,0.3-0.2,0.4l-19.8,8.6C590.6,379.6,590.6,379.6,590.5,379.6z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M602.5,381.2c0,0-0.1,0-0.1,0l-15.6-6.8c-0.1,0-0.2-0.2-0.2-0.3c0-0.1,0.1-0.2,0.2-0.3l15.6-6.8 c0.1,0,0.2,0,0.2,0l15.6,6.8c0.1,0,0.2,0.2,0.2,0.3c0,0.1-0.1,0.2-0.2,0.3l-15.6,6.8C602.6,381.2,602.6,381.2,602.5,381.2z  M587.7,374.1l14.8,6.4l14.8-6.4l-14.8-6.4L587.7,374.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 618.1,
    cy: 374.1,
    rx: 2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 602.5,
    cy: 367.3,
    rx: 2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 586.9,
    cy: 374.1,
    rx: 2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 602.5,
    cy: 380.9,
    rx: 2,
    ry: 1.2
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "602.5,374.1 578.6,363.7 602.5,353.4 626.4,363.7  "
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M602.5,370.8c0,0-0.1,0-0.1,0l-15.6-6.8c-0.1,0-0.2-0.2-0.2-0.3s0.1-0.2,0.2-0.3l15.6-6.8 c0.1,0,0.2,0,0.2,0l15.6,6.8c0.1,0,0.2,0.2,0.2,0.3s-0.1,0.2-0.2,0.3l-15.6,6.8C602.6,370.8,602.6,370.8,602.5,370.8z  M587.7,363.7l14.8,6.4l14.8-6.4l-14.8-6.4L587.7,363.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 618.1,
    cy: 363.7,
    rx: 2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 602.5,
    cy: 357,
    rx: 2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 586.9,
    cy: 363.7,
    rx: 2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 602.5,
    cy: 370.5,
    rx: 2,
    ry: 1.2
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M590.5,408.1c-0.2,0-0.3-0.1-0.3-0.3v-38.8c0-0.1,0.1-0.2,0.2-0.3l19.8-8.6c0.2-0.1,0.3,0,0.4,0.2 c0.1,0.2,0,0.3-0.2,0.4l-19.6,8.5v38.6C590.9,407.9,590.7,408.1,590.5,408.1z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M602.5,413.4c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.4v-47.5c0-0.2,0.1-0.4,0.3-0.4l23.9-10.4 c0.1-0.1,0.3,0,0.4,0c0.1,0.1,0.2,0.2,0.2,0.4v47.5c0,0.2-0.1,0.4-0.3,0.4l-23.9,10.4C602.6,413.4,602.6,413.4,602.5,413.4z  M603,365.8v46.5l23-10v-46.5L603,365.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M602.5,365.9c-0.1,0-0.1,0-0.2,0l-23.9-10.4c-0.2-0.1-0.3-0.2-0.3-0.4c0-0.2,0.1-0.4,0.3-0.4l23.9-10.4 c0.1-0.1,0.3-0.1,0.4,0l23.9,10.4c0.2,0.1,0.3,0.2,0.3,0.4c0,0.2-0.1,0.4-0.3,0.4l-23.9,10.4 C602.6,365.9,602.6,365.9,602.5,365.9z M579.8,355.1l22.8,9.9l22.8-9.9l-22.8-9.9L579.8,355.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M602.5,413.4c-0.1,0-0.1,0-0.2,0L578.4,403c-0.2-0.1-0.3-0.2-0.3-0.4v-47.5c0-0.2,0.1-0.3,0.2-0.4 c0.1-0.1,0.3-0.1,0.4,0l23.9,10.4c0.2,0.1,0.3,0.2,0.3,0.4v47.5c0,0.2-0.1,0.3-0.2,0.4C602.7,413.4,602.6,413.4,602.5,413.4z  M579,402.3l23,10v-46.5l-23-10V402.3z"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "624.4,355.1 623.2,355.6 623.2,350.6 624.4,350.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "623.2,350.6 621.9,350.1 623.2,349.5 624.4,350.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "623.2,355.6 621.9,355.1 621.9,350.1 623.2,350.6  "
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M602.5,413.2c0,0-0.1,0-0.1,0l-12-5.2c-0.2-0.1-0.2-0.3-0.2-0.4c0.1-0.2,0.3-0.2,0.4-0.2l11.8,5.1l20.3-8.8 v-47.3c0-0.1,0.1-0.2,0.2-0.3l1-0.4l-0.4-0.2c-0.2-0.1-0.2-0.3-0.2-0.4c0.1-0.2,0.3-0.2,0.4-0.2l1,0.5c0.1,0.1,0.2,0.2,0.2,0.3 s-0.1,0.2-0.2,0.3l-1.4,0.6V404c0,0.1-0.1,0.2-0.2,0.3l-20.7,8.9C602.6,413.2,602.6,413.2,602.5,413.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000012473338839883875520000010298464497908344714_",
    points: "480.4,385.4 480.4,339.2 440.4,316 400.4,339.2  400.4,385.4 440.4,408.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047045100173811263240000017874046734907928225_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000012473338839883875520000010298464497908344714_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000047045100173811263240000017874046734907928225_)"
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "400.4,339.2 400.4,369.6 480.4,369.6 480.4,339.2 440.4,316  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "480.4,355.6 479.4,355.6 479.4,338.6 466.1,330.9 464.1,332.4 464.1,349.6 458.8,349.6 457.3,351.1  457.3,352.9 458,352.9 458,363.6 455.6,363.6 455.6,360.4 450.5,360.4 450.5,333 441.1,333 438.4,335.7 438.4,338.9 439.7,338.9  439.7,357.8 435.4,357.8 435.4,352.2 424.7,352.2 424.7,357.7 419.1,357.7 419.1,331.8 417.1,331.8 415.7,330.3 405.8,336  405.8,357.7 400.4,357.7 400.4,371 450.5,371 469.7,371 480.4,371  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "400.4,371 424.8,371 451.1,371 480.4,371 480.4,356.7 479.3,356.7 479.3,360.7 474.9,360.7  474.9,346.3 466.8,346.3 466.8,351.2 464,351.2 464,349.4 460.7,349.4 460.7,351.2 459,351.2 459,361.6 455.6,361.6 455.6,363.5  453.9,365.3 451.1,365.3 451.1,364 448.9,364 448.9,358.9 447.9,358.9 447.9,353.5 447,353.5 447,342.9 441.7,342.9 441.7,353.4  440.2,353.4 440.2,349.3 437.4,349.3 435.8,347.8 435.8,345.9 434.3,345.9 434.3,348 431.4,348 431.4,353.1 430.2,353.1  430.2,351 429.6,351 429.6,353.1 428.6,353.1 428.6,366 427,366 427,359.6 422.1,359.6 422.1,355.7 420.7,355.7 420.7,348.9  419.6,348.9 419.6,335.6 412.9,335.6 412.9,348.8 411.1,348.8 411.1,343.7 407.5,343.7 405.5,341.7 405.5,339.4 403.6,339.4  403.6,342 400.4,342  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "480.4,385.4 480.4,339.2 440.4,316 400.4,339.2 400.4,385.4 440.4,408.5  "
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M419.5,350.9c0,0.1,0,0.1,0,0.2c0.6,0,1,0.2,1.4,0.6c0.4,0.4,0.6,0.9,0.6,1.4c0.1,0,0.1,0,0.2,0 C421.7,351.9,420.7,350.9,419.5,350.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M419.5,351.5c0,0.1,0,0.1,0,0.2c0.8,0,1.5,0.7,1.5,1.5c0.1,0,0.1,0,0.2,0 C421.2,352.2,420.4,351.4,419.5,351.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M419.5,352c0,0.1,0,0.1,0,0.2c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7c0.1,0,0.1,0,0.2,0 C420.7,352.5,420.1,351.9,419.5,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M418.9,356.6l0.6-0.6v-0.4h0.2v-2.3h-0.8v-0.9c0-0.3-0.2-0.5-0.5-0.5h-1.6v-0.1h-3v0.7h3v-0.2h1.6v16.8h-1.5 v0.2h2.8v-0.2h-0.8V356.6z M416.7,352.5H414V352h2.7V352.5z M418.9,353.5h0.6v2.1h-0.6V353.5z M419.3,355.7v0.3l-0.4,0.4v-0.8 H419.3z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M452.7,350.9c0,0.1,0,0.1,0,0.2c0.6,0,1,0.2,1.4,0.6c0.4,0.4,0.6,0.9,0.6,1.4c0.1,0,0.1,0,0.2,0 C454.9,351.9,453.9,350.9,452.7,350.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M452.7,351.5c0,0.1,0,0.1,0,0.2c0.8,0,1.5,0.7,1.5,1.5c0.1,0,0.1,0,0.2,0 C454.4,352.2,453.5,351.4,452.7,351.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M452.7,352c0,0.1,0,0.1,0,0.2c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7c0.1,0,0.1,0,0.2,0 C453.9,352.5,453.3,351.9,452.7,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M452.1,356.6l0.6-0.6v-0.4h0.2v-2.3h-0.8v-0.9c0-0.3-0.2-0.5-0.5-0.5H450v-0.1h-3v0.7h3v-0.2h1.6v16.8h-1.5 v0.2h2.8v-0.2h-0.8V356.6z M449.9,352.5h-2.7V352h2.7V352.5z M452.1,353.5h0.6v2.1h-0.6V353.5z M452.5,355.7v0.3l-0.4,0.4v-0.8 H452.5z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M478.9,350.9c0,0.1,0,0.1,0,0.2c0.6,0,1,0.2,1.4,0.6c0.4,0.4,0.6,0.9,0.6,1.4c0.1,0,0.1,0,0.2,0 C481.1,351.9,480.1,350.9,478.9,350.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M478.9,351.5c0,0.1,0,0.1,0,0.2c0.8,0,1.5,0.7,1.5,1.5c0.1,0,0.1,0,0.2,0 C480.6,352.2,479.7,351.4,478.9,351.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M478.9,352c0,0.1,0,0.1,0,0.2c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7c0.1,0,0.1,0,0.2,0 C480.1,352.5,479.5,351.9,478.9,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M478.3,356.6l0.6-0.6v-0.4h0.2v-2.3h-0.8v-0.9c0-0.3-0.2-0.5-0.5-0.5h-1.6v-0.1h-3v0.7h3v-0.2h1.6v16.8h-1.5 v0.2h2.8v-0.2h-0.8V356.6z M476.1,352.5h-2.7V352h2.7V352.5z M478.3,353.5h0.6v2.1h-0.6V353.5z M478.7,355.7v0.3l-0.4,0.4v-0.8 H478.7z"
  }))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "400.4,369.4 400.4,385.4 440.4,408.5 480.4,385.4 480.4,369.4  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000165942121722677397490000002426924771892432319_",
    points: "237.6,111.7 237.6,65.5 197.6,42.3 157.5,65.5  157.5,111.7 197.6,134.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122719700073011290120000004576861979835234722_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165942121722677397490000002426924771892432319_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122719700073011290120000004576861979835234722_)"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 197.6,
    cy: 94.9,
    r: 63.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M136.2,109.9c7.4,27,32.1,46.8,61.4,46.8c29.1,0,53.6-19.5,61.2-46.1c-15.3-13.1-37.2-21.3-61.7-21.3 C173.1,89.2,151.4,97.2,136.2,109.9z"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "197.6,120.6 182.1,113.9 182.1,111.2 197.6,117.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "213,113.9 197.6,120.6 197.6,117.9 213,111.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "197.6,117.9 182.1,111.2 197.6,104.5 213,111.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 197.6,
    cy: 110.6,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st21",
    cx: 197.6,
    cy: 110.5,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st22",
    cx: 197.6,
    cy: 110.5,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st23",
    cx: 197.6,
    cy: 110.5,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st24",
    cx: 197.6,
    cy: 110.4,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st25",
    cx: 197.6,
    cy: 110.4,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st26",
    cx: 197.6,
    cy: 110.3,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st26",
    cx: 197.6,
    cy: 110.3,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st27",
    cx: 197.6,
    cy: 110.2,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st28",
    cx: 197.6,
    cy: 110.2,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st29",
    cx: 197.6,
    cy: 110.2,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st30",
    cx: 197.6,
    cy: 110.1,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st31",
    cx: 197.6,
    cy: 110.1,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st32",
    cx: 197.6,
    cy: 110,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st33",
    cx: 197.6,
    cy: 110,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st33",
    cx: 197.6,
    cy: 110,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st34",
    cx: 197.6,
    cy: 109.9,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st35",
    cx: 197.6,
    cy: 109.9,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st36",
    cx: 197.6,
    cy: 109.8,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st37",
    cx: 197.6,
    cy: 109.8,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st37",
    cx: 197.6,
    cy: 109.7,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st38",
    cx: 197.6,
    cy: 109.7,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st39",
    cx: 197.6,
    cy: 109.7,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st40",
    cx: 197.6,
    cy: 109.6,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st41",
    cx: 197.6,
    cy: 109.6,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st42",
    cx: 197.6,
    cy: 109.5,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st43",
    cx: 197.6,
    cy: 109.5,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st44",
    cx: 197.6,
    cy: 109.4,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st44",
    cx: 197.6,
    cy: 109.4,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st45",
    cx: 197.6,
    cy: 109.4,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st46",
    cx: 197.6,
    cy: 109.3,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st47",
    cx: 197.6,
    cy: 109.3,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st48",
    cx: 197.6,
    cy: 109.2,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st48",
    cx: 197.6,
    cy: 109.2,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st49",
    cx: 197.6,
    cy: 109.1,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st49",
    cx: 197.6,
    cy: 109.1,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st50",
    cx: 197.6,
    cy: 109.1,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st51",
    cx: 197.6,
    cy: 109,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st52",
    cx: 197.6,
    cy: 109,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st53",
    cx: 197.6,
    cy: 108.9,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st54",
    cx: 197.6,
    cy: 108.9,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st55",
    cx: 197.6,
    cy: 108.8,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st56",
    cx: 197.6,
    cy: 108.8,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st56",
    cx: 197.6,
    cy: 108.8,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st57",
    cx: 197.6,
    cy: 108.7,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st58",
    cx: 197.6,
    cy: 108.7,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st58",
    cx: 197.6,
    cy: 108.6,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st59",
    cx: 197.6,
    cy: 108.6,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st59",
    cx: 197.6,
    cy: 108.5,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st60",
    cx: 197.6,
    cy: 108.5,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st61",
    cx: 197.6,
    cy: 108.5,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st62",
    cx: 197.6,
    cy: 108.4,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st63",
    cx: 197.6,
    cy: 108.4,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st64",
    cx: 197.6,
    cy: 108.3,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st64",
    cx: 197.6,
    cy: 108.3,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st65",
    cx: 197.6,
    cy: 108.2,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st65",
    cx: 197.6,
    cy: 108.2,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st66",
    cx: 197.6,
    cy: 108.2,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st67",
    cx: 197.6,
    cy: 108.1,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st67",
    cx: 197.6,
    cy: 108.1,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st68",
    cx: 197.6,
    cy: 108,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st69",
    cx: 197.6,
    cy: 108,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st70",
    cx: 197.6,
    cy: 107.9,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st71",
    cx: 197.6,
    cy: 107.9,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st72",
    cx: 197.6,
    cy: 107.9,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st73",
    cx: 197.6,
    cy: 107.8,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st74",
    cx: 197.6,
    cy: 107.8,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st74",
    cx: 197.6,
    cy: 107.7,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st75",
    cx: 197.6,
    cy: 107.7,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st75",
    cx: 197.6,
    cy: 107.6,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st76",
    cx: 197.6,
    cy: 107.6,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st77",
    cx: 197.6,
    cy: 107.6,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st78",
    cx: 197.6,
    cy: 107.5,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st79",
    cx: 197.6,
    cy: 107.5,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st79",
    cx: 197.6,
    cy: 107.4,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st80",
    cx: 197.6,
    cy: 107.4,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st81",
    cx: 197.6,
    cy: 107.3,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st82",
    cx: 197.6,
    cy: 107.3,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st83",
    cx: 197.6,
    cy: 107.3,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st84",
    cx: 197.6,
    cy: 107.2,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st85",
    cx: 197.6,
    cy: 107.2,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st86",
    cx: 197.6,
    cy: 107.1,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st86",
    cx: 197.6,
    cy: 107.1,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st87",
    cx: 197.6,
    cy: 107,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st88",
    cx: 197.6,
    cy: 107,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st89",
    cx: 197.6,
    cy: 107,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st90",
    cx: 197.6,
    cy: 106.9,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st90",
    cx: 197.6,
    cy: 106.9,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st91",
    cx: 197.6,
    cy: 106.8,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st92",
    cx: 197.6,
    cy: 106.8,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st93",
    cx: 197.6,
    cy: 106.7,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st94",
    cx: 197.6,
    cy: 106.7,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st95",
    cx: 197.6,
    cy: 106.7,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st96",
    cx: 197.6,
    cy: 106.6,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st97",
    cx: 197.6,
    cy: 106.6,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st97",
    cx: 197.6,
    cy: 106.5,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st98",
    cx: 197.6,
    cy: 106.5,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st99",
    cx: 197.6,
    cy: 106.4,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st100",
    cx: 197.6,
    cy: 106.4,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st101",
    cx: 197.6,
    cy: 106.4,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st102",
    cx: 197.6,
    cy: 106.3,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st19",
    cx: 197.6,
    cy: 106.3,
    rx: 6.5,
    ry: 2.4
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 197.6,
    cy: 106.3,
    rx: 6.5,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M201.5,77.3c0-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2,0.1-0.2,0.2l0.5,5.5l-3.9-1.7v-2.5c0-0.1-0.1-0.2-0.2-0.2 c-0.1,0-0.2,0.1-0.2,0.2v2.5l-3.9,1.7l0.5-5.5c0-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2,0.1-0.2,0.2l-0.6,5.9c0,0,0,0,0,0c0,0,0,0,0,0 l-0.4,4.6c0,0,0,0,0,0c0,0,0,0,0,0l-0.4,4.6c0,0,0,0,0,0c0,0,0,0,0,0l-0.4,4.6c0,0,0,0,0,0c0,0,0,0,0,0l-0.4,4.6c0,0,0,0,0,0 c0,0,0,0,0,0l-0.4,4.7c0,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0c0.1,0,0.2-0.1,0.2-0.2l0.4-4.5l5.7,2.5v4.3c0,0.1,0.1,0.2,0.2,0.2 c0.1,0,0.2-0.1,0.2-0.2v-4.3l5.7-2.5l0.4,4.5c0,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0c0.1,0,0.2-0.1,0.2-0.2L201.5,77.3z M202.5,92.1 l-4.8-2.1v-0.1l4.4-1.9L202.5,92.1z M197.4,94.3l-4.5-1.9l4.5-1.9V94.3z M197.8,90.5l4.5,1.9l-4.5,1.9V90.5z M197.8,89.5V86 l4,1.7L197.8,89.5z M197.4,89.5l-4-1.7l4-1.7V89.5z M197.4,89.9L197.4,89.9l-4.7,2.1l0.4-4L197.4,89.9z M197,94.6l-4.8,2.1l0.4-4 L197,94.6z M197.4,94.9v4l-0.3,0.1l-4.6-2L197.4,94.9z M197.8,98.9v-4l4.9,2.1l-4.6,2L197.8,98.9z M198.1,94.6l4.5-1.9l0.4,4 L198.1,94.6z M202.1,87.4l-4.3-1.9v-0.5l3.9-1.7L202.1,87.4z M201.4,83.1l-3.6,1.6v-3.1L201.4,83.1z M197.4,81.6v3.1l-3.6-1.6 L197.4,81.6z M197.4,85.1v0.5l-4.3,1.9l0.4-4L197.4,85.1z M192.1,97.3l4.4,1.9l-4.8,2.1L192.1,97.3z M192,101.7l5.1-2.2l0.3,0.1 v4.4L192,101.7z M197.8,104v-4.4l0.3-0.1l5.1,2.2L197.8,104z M198.6,99.3l4.5-1.9l0.4,4L198.6,99.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "uZYL1A_5_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.1,77.1C188.1,77.1,188.1,77.1,188.1,77.1c-0.1,0.1-0.3,0.1-0.4,0c-2.9-3-3-8.1,0-11.2 c0.1-0.1,0.3-0.1,0.4,0l0,0c0.1,0.1,0.1,0.3,0,0.4c-1.3,1.5-2,3.2-2,5.2c0,2,0.7,3.7,2,5.2C188.3,76.8,188.3,76.9,188.1,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M207,77.1C207,77.1,207,77.1,207,77.1c-0.1-0.1-0.1-0.3,0-0.4c1.3-1.5,2-3.2,2-5.2c0-2-0.7-3.7-2-5.2 c-0.1-0.1-0.1-0.3,0-0.4c0,0,0,0,0,0c0.1-0.1,0.3-0.1,0.4,0c2.9,3,3,8,0,11.2C207.3,77.2,207.1,77.2,207,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.5,67.2C189.5,67.2,189.5,67.2,189.5,67.2c0.1,0.1,0.1,0.3,0,0.4c-1,1.1-1.5,2.3-1.5,3.8 c0,1.5,0.5,2.7,1.5,3.8c0.1,0.1,0.1,0.3,0,0.4c0,0,0,0,0,0c-0.1,0.1-0.3,0.1-0.4,0c-2.2-2.3-2.2-6.1,0-8.4 C189.2,67.1,189.4,67.1,189.5,67.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.6,75.7C205.6,75.7,205.6,75.7,205.6,75.7c-0.1-0.1-0.1-0.3,0-0.4c2-2.2,1.8-5.5,0-7.6 c-0.1-0.1-0.1-0.3,0-0.4c0,0,0,0,0,0c0.1-0.1,0.3-0.1,0.4,0c2,2.1,2.3,6,0,8.4C205.9,75.8,205.7,75.8,205.6,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M204.3,74.4C204.3,74.4,204.3,74.4,204.3,74.4c-0.1-0.1-0.1-0.3,0-0.4c0.6-0.7,0.9-1.5,0.9-2.5 c0-0.9-0.3-1.8-0.9-2.5c-0.1-0.1-0.1-0.3,0-0.4c0,0,0,0,0,0c0.1-0.1,0.3-0.1,0.4,0c1.4,1.4,1.5,4.1,0,5.8 C204.6,74.5,204.4,74.5,204.3,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M190.8,68.6C190.8,68.6,190.9,68.6,190.8,68.6c0.1,0.1,0.1,0.3,0,0.4c-1.3,1.7-1.3,3.3,0,5 c0.1,0.1,0.1,0.3,0,0.4c0,0,0,0,0,0c-0.1,0.1-0.3,0.1-0.4,0c-1.4-1.5-1.5-4.1,0-5.8C190.5,68.4,190.7,68.4,190.8,68.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st37",
    cx: 197.6,
    cy: 78.3,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st103",
    cx: 197.6,
    cy: 78.3,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st41",
    cx: 197.6,
    cy: 78.3,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st43",
    cx: 197.6,
    cy: 78.2,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st44",
    cx: 197.6,
    cy: 78.2,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st47",
    cx: 197.6,
    cy: 78.2,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st48",
    cx: 197.6,
    cy: 78.2,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st49",
    cx: 197.6,
    cy: 78.2,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st104",
    cx: 197.6,
    cy: 78.2,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st53",
    cx: 197.6,
    cy: 78.2,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st55",
    cx: 197.6,
    cy: 78.2,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st105",
    cx: 197.6,
    cy: 78.2,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st106",
    cx: 197.6,
    cy: 78.2,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st107",
    cx: 197.6,
    cy: 78.1,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st108",
    cx: 197.6,
    cy: 78.1,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st109",
    cx: 197.6,
    cy: 78.1,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st110",
    cx: 197.6,
    cy: 78.1,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st111",
    cx: 197.6,
    cy: 78.1,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st112",
    cx: 197.6,
    cy: 78.1,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st113",
    cx: 197.6,
    cy: 78.1,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st114",
    cx: 197.6,
    cy: 78.1,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st115",
    cx: 197.6,
    cy: 78.1,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st116",
    cx: 197.6,
    cy: 78.1,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st117",
    cx: 197.6,
    cy: 78,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st118",
    cx: 197.6,
    cy: 78,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st119",
    cx: 197.6,
    cy: 78,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st120",
    cx: 197.6,
    cy: 78,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st121",
    cx: 197.6,
    cy: 78,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st122",
    cx: 197.6,
    cy: 78,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st123",
    cx: 197.6,
    cy: 78,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st124",
    cx: 197.6,
    cy: 78,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st125",
    cx: 197.6,
    cy: 78,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st126",
    cx: 197.6,
    cy: 78,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st127",
    cx: 197.6,
    cy: 77.9,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st128",
    cx: 197.6,
    cy: 77.9,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st129",
    cx: 197.6,
    cy: 77.9,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st130",
    cx: 197.6,
    cy: 77.9,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st131",
    cx: 197.6,
    cy: 77.9,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st132",
    cx: 197.6,
    cy: 77.9,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st133",
    cx: 197.6,
    cy: 77.9,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st134",
    cx: 197.6,
    cy: 77.9,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st135",
    cx: 197.6,
    cy: 77.9,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st136",
    cx: 197.6,
    cy: 77.9,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st137",
    cx: 197.6,
    cy: 77.8,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st138",
    cx: 197.6,
    cy: 77.8,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st139",
    cx: 197.6,
    cy: 77.8,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st140",
    cx: 197.6,
    cy: 77.8,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st141",
    cx: 197.6,
    cy: 77.8,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st142",
    cx: 197.6,
    cy: 77.8,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st143",
    cx: 197.6,
    cy: 77.8,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st144",
    cx: 197.6,
    cy: 77.8,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st145",
    cx: 197.6,
    cy: 77.8,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st146",
    cx: 197.6,
    cy: 77.8,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st147",
    cx: 197.6,
    cy: 77.7,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st148",
    cx: 197.6,
    cy: 77.7,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st149",
    cx: 197.6,
    cy: 77.7,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st150",
    cx: 197.6,
    cy: 77.7,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st151",
    cx: 197.6,
    cy: 77.7,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st152",
    cx: 197.6,
    cy: 77.7,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st153",
    cx: 197.6,
    cy: 77.7,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st154",
    cx: 197.6,
    cy: 77.7,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st155",
    cx: 197.6,
    cy: 77.7,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st156",
    cx: 197.6,
    cy: 77.7,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st157",
    cx: 197.6,
    cy: 77.6,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st158",
    cx: 197.6,
    cy: 77.6,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st159",
    cx: 197.6,
    cy: 77.6,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st160",
    cx: 197.6,
    cy: 77.6,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st161",
    cx: 197.6,
    cy: 77.6,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st162",
    cx: 197.6,
    cy: 77.6,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st163",
    cx: 197.6,
    cy: 77.6,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st164",
    cx: 197.6,
    cy: 77.6,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st165",
    cx: 197.6,
    cy: 77.6,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st166",
    cx: 197.6,
    cy: 77.6,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st167",
    cx: 197.6,
    cy: 77.5,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st168",
    cx: 197.6,
    cy: 77.5,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st169",
    cx: 197.6,
    cy: 77.5,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st170",
    cx: 197.6,
    cy: 77.5,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st171",
    cx: 197.6,
    cy: 77.5,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st172",
    cx: 197.6,
    cy: 77.5,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st173",
    cx: 197.6,
    cy: 77.5,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st174",
    cx: 197.6,
    cy: 77.5,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st175",
    cx: 197.6,
    cy: 77.5,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st176",
    cx: 197.6,
    cy: 77.5,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st177",
    cx: 197.6,
    cy: 77.5,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st178",
    cx: 197.6,
    cy: 77.4,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st179",
    cx: 197.6,
    cy: 77.4,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st180",
    cx: 197.6,
    cy: 77.4,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st181",
    cx: 197.6,
    cy: 77.4,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st182",
    cx: 197.6,
    cy: 77.4,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st183",
    cx: 197.6,
    cy: 77.4,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st184",
    cx: 197.6,
    cy: 77.4,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st185",
    cx: 197.6,
    cy: 77.4,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st186",
    cx: 197.6,
    cy: 77.4,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st187",
    cx: 197.6,
    cy: 77.4,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st188",
    cx: 197.6,
    cy: 77.3,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st189",
    cx: 197.6,
    cy: 77.3,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st190",
    cx: 197.6,
    cy: 77.3,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st191",
    cx: 197.6,
    cy: 77.3,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st192",
    cx: 197.6,
    cy: 77.3,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st193",
    cx: 197.6,
    cy: 77.3,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st194",
    cx: 197.6,
    cy: 77.3,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 197.6,
    cy: 77.3,
    rx: 3.7,
    ry: 1.4
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 197.6,
    cy: 77.3,
    rx: 3.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 197.6,
    y1: 77.3,
    x2: 197.6,
    y2: 71.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 197.6,
    cy: 71.5,
    r: 0.9
  }))))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000147906893812147855230000011415895947400814502_",
    points: "399.6,111.7 399.6,65.5 359.6,42.3 319.5,65.5  319.5,111.7 359.6,134.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013192994547486088460000009708926784073447326_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147906893812147855230000011415895947400814502_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013192994547486088460000009708926784073447326_)"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st197",
    cx: 359.6,
    cy: 89.6,
    r: 47.2
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000075855850440465877680000017693438055185454501_",
    cx: 359.6,
    cy: 89.6,
    r: 47.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065066142516127635010000016816231460899223961_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075855850440465877680000017693438055185454501_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000065066142516127635010000016816231460899223961_)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M346.3,68.9H316V69c-3.8,0.9-6.8,9.7-6.8,20.6c0,10.8,3,19.7,6.8,20.6v0.1h30.3c4.1,0,7.4-9.2,7.4-20.7 C353.7,78.1,350.4,68.9,346.3,68.9z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st199",
    cx: 346.3,
    cy: 89.6,
    rx: 7.4,
    ry: 20.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M309.7,81.9h29.7c0.5-3.1,1.2-5.9,2.1-8.1h-29.7C310.9,76,310.1,78.8,309.7,81.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M371.6,89.6c0-9.1-2.7-16.5-5.9-16.5h-16.9c-3.3,0-5.9,7.4-5.9,16.5c0,9.1,2.7,16.5,5.9,16.5h16.9 C369,106,371.6,98.7,371.6,89.6z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st200",
    cx: 365.7,
    cy: 89.6,
    rx: 5.9,
    ry: 16.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st201",
    d: "M367,102.4c-0.5,1-2,1-2.5,0c-1.1-2-2.5-6.3-2.5-12.9c0-6.6,1.4-10.9,2.5-12.9c0.5-1,2-1,2.5,0 c1.1,2,2.5,6.3,2.5,12.9C369.5,96.2,368.1,100.4,367,102.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st202",
    d: "M362.6,82.6h25.1v-3.5h-24.2C363.1,80.1,362.8,81.2,362.6,82.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st202",
    d: "M362,88.1h16.2v-3.5h-15.9C362.1,85.6,362.1,86.8,362,88.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st202",
    d: "M362.2,93.6h30.6V90H362C362,91.3,362.1,92.5,362.2,93.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st202",
    d: "M363.1,99h20.7v-3.5h-21.5C362.6,96.8,362.9,98,363.1,99z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st203",
    d: "M343.2,84.5h16.9c0.3-2.5,0.8-4.8,1.5-6.7h-16.9C344,79.7,343.5,82,343.2,84.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M346.3,110.2c-2.1,0-3.9-2.3-5.3-6.1h-29.7c1.2,3.4,2.8,5.6,4.6,6v0.1H346.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M361.5,101.2h-16.9c1.1,3,2.6,4.9,4.2,4.9h16.9C364.1,106,362.6,104.2,361.5,101.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st204",
    d: "M388.9,84.5h-2.3c-1.4,0-2.5-1.1-2.5-2.5v-2.3c0-1.4,1.1-2.5,2.5-2.5h2.3c1.4,0,2.5,1.1,2.5,2.5V82 C391.4,83.4,390.2,84.5,388.9,84.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st204",
    d: "M379.4,90h-2.3c-1.4,0-2.5-1.1-2.5-2.5v-2.3c0-1.4,1.1-2.5,2.5-2.5h2.3c1.4,0,2.5,1.1,2.5,2.5v2.3 C381.9,88.9,380.8,90,379.4,90z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st204",
    d: "M392.6,95.5h-2.3c-1.4,0-2.5-1.1-2.5-2.5v-2.3c0-1.4,1.1-2.5,2.5-2.5h2.3c1.4,0,2.5,1.1,2.5,2.5V93 C395.1,94.4,394,95.5,392.6,95.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st204",
    d: "M384.9,101h-2.3c-1.4,0-2.5-1.1-2.5-2.5v-2.3c0-1.4,1.1-2.5,2.5-2.5h2.3c1.4,0,2.5,1.1,2.5,2.5v2.3 C387.4,99.8,386.3,101,384.9,101z"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st197",
    d: "M365.7,80.8c0-1,0.8-1.8,1.8-1.8h-4c-0.3,1-0.6,2.2-0.9,3.5h4.9C366.5,82.6,365.7,81.8,365.7,80.8z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st197",
    d: "M363.7,86.3c0-1,0.8-1.8,1.8-1.8h-3.2c-0.1,1.1-0.2,2.3-0.3,3.5l3.5,0C364.5,88.1,363.7,87.3,363.7,86.3z "
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st197",
    d: "M365.5,91.8c0-1,0.8-1.8,1.8-1.8H362c0,1.3,0.1,2.5,0.2,3.5h5.1C366.3,93.6,365.5,92.8,365.5,91.8z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st197",
    d: "M364.1,97.3c0-1,0.8-1.8,1.8-1.8h-3.5c0.2,1.3,0.5,2.5,0.7,3.5h2.8C364.9,99,364.1,98.3,364.1,97.3z"
  }))))))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000134939024736555653720000005983206375530438587_",
    points: "561.6,111.7 561.6,65.5 521.5,42.3 481.5,65.5  481.5,111.7 521.5,134.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036967469961834412520000011758409876497505924_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134939024736555653720000005983206375530438587_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036967469961834412520000011758409876497505924_)"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st197",
    cx: 521.5,
    cy: 88.4,
    r: 48.4
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000096049545717189549640000012727540098015184520_",
    cx: 521.5,
    cy: 88.4,
    r: 48.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158740670666780388130000012840392427723078551_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096049545717189549640000012727540098015184520_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000158740670666780388130000012840392427723078551_)"
    }
  }, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "518.3,132.7 452,102 534,64.1 600.3,94.8  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "452,102 452,64 534,26.1 600.3,56.8 600.3,94.8 534,64.1  "
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "511.3,87.6 502.5,83.5 502.5,70.6 511.3,74.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "530.5,57.7 502.5,70.6 511.3,74.7 539.2,61.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "539.2,61.8 539.2,74.7 511.3,87.6 511.3,74.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "537.5,64.2 534,65.8 534,75.5 537.5,73.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "532.2,66.6 528.7,68.2 528.7,77.9 532.2,76.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "527,69 523.5,70.6 523.5,80.3 527,78.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "521.7,71.5 518.3,73.1 518.3,82.7 521.7,81.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "516.5,73.9 513,75.5 513,85.2 516.5,83.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "537.5,73.3 537.5,64.2 536.7,64.5 536.7,73.7 537.5,73.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "536.7,73.7 536.7,73.7 534,74.9 534,75.5 537.5,73.9 537.5,73.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M534.2,66l2.1-1v0.3l-2.1,1V66z M534.2,66.7l2.1-1v-0.3l-2.1,1V66.7z M534.2,67.1l2.1-1v-0.3l-2.1,1V67.1 z M534.2,67.6l2.1-1v-0.3l-2.1,1V67.6z M534.2,68l2.1-1v-0.3l-2.1,1V68z M534.2,68.4l2.1-1v-0.3l-2.1,1V68.4z M534.2,68.8 l2.1-1v-0.3l-2.1,1V68.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "534.2,70.1 536.4,69.1 536.4,68.9 534.2,69.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "534.2,70.5 536.4,69.6 536.4,69.3 534.2,70.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "534.2,71 536.4,70 536.4,69.7 534.2,70.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "534.2,71.4 536.4,70.4 536.4,70.1 534.2,71.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "536.4,66.6 536.4,66.3 536.1,66.5 536.1,66.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "536.4,67 536.4,66.8 536.1,66.9 536.1,67.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "536.4,65.5 536.1,65.6 536.1,65.9 536.4,65.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "536.4,66.2 536.4,65.9 536.1,66 536.1,66.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "536.4,67.4 536.4,67.2 536.1,67.3 536.1,67.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "536.1,65.5 536.4,65.3 536.4,65.1 536.1,65.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "536.4,67.9 536.4,67.6 536.1,67.7 536.1,68  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "532.2,75.7 532.2,66.6 531.5,66.9 531.5,76.1 532.2,76.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "531.5,76.1 531.5,76.1 528.7,77.4 528.7,77.9 532.2,76.3 532.2,76.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M529,68.5l2.1-1v0.3l-2.1,1V68.5z M529,69.1l2.1-1v-0.3l-2.1,1V69.1z M529,69.6l2.1-1v-0.3l-2.1,1V69.6z  M529,70l2.1-1v-0.3l-2.1,1V70z M529,70.4l2.1-1v-0.3l-2.1,1V70.4z M529,70.8l2.1-1v-0.3l-2.1,1V70.8z M529,71.3l2.1-1V70 l-2.1,1V71.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "529,72.5 531.1,71.5 531.1,71.3 529,72.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "529,73 531.1,72 531.1,71.7 529,72.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "529,73.4 531.1,72.4 531.1,72.1 529,73.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "529,73.8 531.1,72.8 531.1,72.6 529,73.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "531.1,69 531.1,68.8 530.8,68.9 530.8,69.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "531.1,69.4 531.1,69.2 530.8,69.3 530.8,69.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "531.1,67.9 530.8,68 530.8,68.3 531.1,68.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "531.1,68.6 531.1,68.3 530.8,68.5 530.8,68.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "531.1,69.9 531.1,69.6 530.8,69.7 530.8,70  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "530.8,67.9 531.1,67.7 531.1,67.5 530.8,67.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "531.1,70.3 531.1,70 530.8,70.2 530.8,70.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "527,78.2 527,69 526.3,69.4 526.3,78.5 527,78.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "526.3,78.5 526.3,78.5 523.5,79.8 523.5,80.3 527,78.7 527,78.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M523.8,70.9l2.1-1v0.3l-2.1,1V70.9z M523.8,71.6l2.1-1v-0.3l-2.1,1V71.6z M523.8,72l2.1-1v-0.3l-2.1,1V72 z M523.8,72.4l2.1-1v-0.3l-2.1,1V72.4z M523.8,72.8l2.1-1v-0.3l-2.1,1V72.8z M523.8,73.3l2.1-1V72l-2.1,1V73.3z M523.8,73.7 l2.1-1v-0.3l-2.1,1V73.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "523.8,75 525.9,74 525.9,73.7 523.8,74.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "523.8,75.4 525.9,74.4 525.9,74.1 523.8,75.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "523.8,75.8 525.9,74.8 525.9,74.6 523.8,75.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "523.8,76.2 525.9,75.2 525.9,75 523.8,76  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "525.9,71.4 525.9,71.2 525.6,71.3 525.6,71.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "525.9,71.8 525.9,71.6 525.6,71.7 525.6,72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "525.9,70.3 525.6,70.5 525.6,70.7 525.9,70.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "525.9,71 525.9,70.7 525.6,70.9 525.6,71.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "525.9,72.3 525.9,72 525.6,72.2 525.6,72.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "525.6,70.3 525.9,70.2 525.9,69.9 525.6,70  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "525.9,72.7 525.9,72.4 525.6,72.6 525.6,72.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "521.7,80.6 521.7,71.5 521,71.8 521,80.9 521.7,81.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "521,80.9 521,80.9 518.3,82.2 518.3,82.7 521.7,81.1 521.7,81.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M518.5,73.3l2.1-1v0.3l-2.1,1V73.3z M518.5,74l2.1-1v-0.3l-2.1,1V74z M518.5,74.4l2.1-1v-0.3l-2.1,1V74.4 z M518.5,74.8l2.1-1v-0.3l-2.1,1V74.8z M518.5,75.3l2.1-1V74l-2.1,1V75.3z M518.5,75.7l2.1-1v-0.3l-2.1,1V75.7z M518.5,76.1 l2.1-1v-0.3l-2.1,1V76.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "518.5,77.4 520.7,76.4 520.7,76.1 518.5,77.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "518.5,77.8 520.7,76.8 520.7,76.6 518.5,77.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "518.5,78.2 520.7,77.2 520.7,77 518.5,78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "518.5,78.6 520.7,77.7 520.7,77.4 518.5,78.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "520.7,73.8 520.7,73.6 520.4,73.7 520.4,74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "520.7,74.3 520.7,74 520.4,74.2 520.4,74.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "520.7,72.7 520.4,72.9 520.4,73.1 520.7,73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "520.7,73.4 520.7,73.2 520.4,73.3 520.4,73.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "520.7,74.7 520.7,74.4 520.4,74.6 520.4,74.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "520.4,72.7 520.7,72.6 520.7,72.3 520.4,72.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "520.7,75.1 520.7,74.9 520.4,75 520.4,75.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "516.5,83 516.5,73.9 515.8,74.2 515.8,83.3 516.5,83.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "515.8,83.3 515.8,83.3 513,84.6 513,85.2 516.5,83.5 516.5,83.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M513.3,75.7l2.1-1V75l-2.1,1V75.7z M513.3,76.4l2.1-1v-0.3l-2.1,1V76.4z M513.3,76.8l2.1-1v-0.3l-2.1,1 V76.8z M513.3,77.2l2.1-1V76l-2.1,1V77.2z M513.3,77.7l2.1-1v-0.3l-2.1,1V77.7z M513.3,78.1l2.1-1v-0.3l-2.1,1V78.1z  M513.3,78.5l2.1-1v-0.3l-2.1,1V78.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "513.3,79.8 515.4,78.8 515.4,78.5 513.3,79.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "513.3,80.2 515.4,79.2 515.4,79 513.3,80  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "513.3,80.6 515.4,79.7 515.4,79.4 513.3,80.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "513.3,81.1 515.4,80.1 515.4,79.8 513.3,80.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "515.4,76.3 515.4,76 515.1,76.1 515.1,76.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "515.4,76.7 515.4,76.4 515.1,76.6 515.1,76.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "515.4,75.2 515.1,75.3 515.1,75.6 515.4,75.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "515.4,75.8 515.4,75.6 515.1,75.7 515.1,76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "515.4,77.1 515.4,76.9 515.1,77 515.1,77.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "515.1,75.1 515.4,75 515.4,74.7 515.1,74.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "515.4,77.5 515.4,77.3 515.1,77.4 515.1,77.7  "
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "471.1,106.1 462.4,102 462.4,89.1 471.1,93.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "490.3,76.2 462.4,89.1 471.1,93.2 499.1,80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "499.1,80.3 499.1,93.2 471.1,106.1 471.1,93.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "497.3,82.7 493.8,84.3 493.8,94 497.3,92.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "492.1,85.1 488.6,86.7 488.6,96.4 492.1,94.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "486.8,87.5 483.3,89.1 483.3,98.8 486.8,97.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "481.6,90 478.1,91.6 478.1,101.2 481.6,99.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "476.4,92.4 472.9,94 472.9,103.7 476.4,102  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "497.3,91.8 497.3,82.7 496.6,83 496.6,92.2 497.3,92.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "496.6,92.2 496.6,92.2 493.8,93.4 493.8,94 497.3,92.4 497.3,92.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M494.1,84.5l2.1-1v0.3l-2.1,1V84.5z M494.1,85.2l2.1-1V84l-2.1,1V85.2z M494.1,85.6l2.1-1v-0.3l-2.1,1 V85.6z M494.1,86.1l2.1-1v-0.3l-2.1,1V86.1z M494.1,86.5l2.1-1v-0.3l-2.1,1V86.5z M494.1,86.9l2.1-1v-0.3l-2.1,1V86.9z  M494.1,87.3l2.1-1v-0.3l-2.1,1V87.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "494.1,88.6 496.2,87.6 496.2,87.4 494.1,88.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "494.1,89 496.2,88.1 496.2,87.8 494.1,88.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "494.1,89.5 496.2,88.5 496.2,88.2 494.1,89.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "494.1,89.9 496.2,88.9 496.2,88.6 494.1,89.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "496.2,85.1 496.2,84.8 495.9,85 495.9,85.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "496.2,85.5 496.2,85.3 495.9,85.4 495.9,85.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "496.2,84 495.9,84.1 495.9,84.4 496.2,84.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "496.2,84.7 496.2,84.4 495.9,84.6 495.9,84.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "496.2,85.9 496.2,85.7 495.9,85.8 495.9,86.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "495.9,84 496.2,83.8 496.2,83.6 495.9,83.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "496.2,86.4 496.2,86.1 495.9,86.2 495.9,86.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "492.1,94.2 492.1,85.1 491.4,85.4 491.4,94.6 492.1,94.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "491.4,94.6 491.4,94.6 488.6,95.9 488.6,96.4 492.1,94.8 492.1,94.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M488.9,87l2.1-1v0.3l-2.1,1V87z M488.9,87.6l2.1-1v-0.3l-2.1,1V87.6z M488.9,88.1l2.1-1v-0.3l-2.1,1V88.1 z M488.9,88.5l2.1-1v-0.3l-2.1,1V88.5z M488.9,88.9l2.1-1v-0.3l-2.1,1V88.9z M488.9,89.3l2.1-1v-0.3l-2.1,1V89.3z M488.9,89.8 l2.1-1v-0.3l-2.1,1V89.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "488.9,91 491,90 491,89.8 488.9,90.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "488.9,91.5 491,90.5 491,90.2 488.9,91.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "488.9,91.9 491,90.9 491,90.6 488.9,91.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "488.9,92.3 491,91.3 491,91.1 488.9,92.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "491,87.5 491,87.3 490.7,87.4 490.7,87.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "491,87.9 491,87.7 490.7,87.8 490.7,88.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "491,86.4 490.7,86.5 490.7,86.8 491,86.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "491,87.1 491,86.8 490.7,87 490.7,87.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "491,88.4 491,88.1 490.7,88.2 490.7,88.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "490.7,86.4 491,86.2 491,86 490.7,86.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "491,88.8 491,88.5 490.7,88.7 490.7,88.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "486.8,96.7 486.8,87.5 486.1,87.9 486.1,97 486.8,97.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "486.1,97 486.1,97 483.3,98.3 483.3,98.8 486.8,97.2 486.8,97.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M483.6,89.4l2.1-1v0.3l-2.1,1V89.4z M483.6,90.1l2.1-1v-0.3l-2.1,1V90.1z M483.6,90.5l2.1-1v-0.3l-2.1,1 V90.5z M483.6,90.9l2.1-1v-0.3l-2.1,1V90.9z M483.6,91.3l2.1-1v-0.3l-2.1,1V91.3z M483.6,91.8l2.1-1v-0.3l-2.1,1V91.8z  M483.6,92.2l2.1-1v-0.3l-2.1,1V92.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "483.6,93.5 485.8,92.5 485.8,92.2 483.6,93.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "483.6,93.9 485.8,92.9 485.8,92.6 483.6,93.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "483.6,94.3 485.8,93.3 485.8,93.1 483.6,94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "483.6,94.7 485.8,93.7 485.8,93.5 483.6,94.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "485.8,89.9 485.8,89.7 485.5,89.8 485.5,90.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "485.8,90.3 485.8,90.1 485.5,90.2 485.5,90.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "485.8,88.8 485.5,89 485.5,89.2 485.8,89.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "485.8,89.5 485.8,89.2 485.5,89.4 485.5,89.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "485.8,90.8 485.8,90.5 485.5,90.7 485.5,90.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "485.5,88.8 485.8,88.7 485.8,88.4 485.5,88.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "485.8,91.2 485.8,90.9 485.5,91.1 485.5,91.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "481.6,99.1 481.6,90 480.9,90.3 480.9,99.4 481.6,99.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "480.9,99.4 480.9,99.4 478.1,100.7 478.1,101.2 481.6,99.6 481.6,99.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M478.4,91.8l2.1-1v0.3l-2.1,1V91.8z M478.4,92.5l2.1-1v-0.3l-2.1,1V92.5z M478.4,92.9l2.1-1v-0.3l-2.1,1 V92.9z M478.4,93.3l2.1-1v-0.3l-2.1,1V93.3z M478.4,93.8l2.1-1v-0.3l-2.1,1V93.8z M478.4,94.2l2.1-1v-0.3l-2.1,1V94.2z  M478.4,94.6l2.1-1v-0.3l-2.1,1V94.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "478.4,95.9 480.5,94.9 480.5,94.6 478.4,95.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "478.4,96.3 480.5,95.3 480.5,95.1 478.4,96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "478.4,96.7 480.5,95.7 480.5,95.5 478.4,96.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "478.4,97.1 480.5,96.2 480.5,95.9 478.4,96.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "480.5,92.3 480.5,92.1 480.2,92.2 480.2,92.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "480.5,92.8 480.5,92.5 480.2,92.7 480.2,92.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "480.5,91.2 480.2,91.4 480.2,91.6 480.5,91.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "480.5,91.9 480.5,91.7 480.2,91.8 480.2,92.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "480.5,93.2 480.5,92.9 480.2,93.1 480.2,93.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "480.2,91.2 480.5,91.1 480.5,90.8 480.2,91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "480.5,93.6 480.5,93.4 480.2,93.5 480.2,93.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "476.4,101.5 476.4,92.4 475.7,92.7 475.7,101.8 476.4,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "475.7,101.8 475.7,101.8 472.9,103.1 472.9,103.7 476.4,102 476.4,102  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M473.2,94.2l2.1-1v0.3l-2.1,1V94.2z M473.2,94.9l2.1-1v-0.3l-2.1,1V94.9z M473.2,95.3l2.1-1v-0.3l-2.1,1 V95.3z M473.2,95.7l2.1-1v-0.3l-2.1,1V95.7z M473.2,96.2l2.1-1v-0.3l-2.1,1V96.2z M473.2,96.6l2.1-1v-0.3l-2.1,1V96.6z  M473.2,97l2.1-1v-0.3l-2.1,1V97z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "473.2,98.3 475.3,97.3 475.3,97.1 473.2,98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "473.2,98.7 475.3,97.7 475.3,97.5 473.2,98.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "473.2,99.1 475.3,98.2 475.3,97.9 473.2,98.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "473.2,99.6 475.3,98.6 475.3,98.3 473.2,99.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "475.3,94.8 475.3,94.5 475,94.6 475,94.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "475.3,95.2 475.3,94.9 475,95.1 475,95.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "475.3,93.7 475,93.8 475,94.1 475.3,93.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "475.3,94.3 475.3,94.1 475,94.2 475,94.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "475.3,95.6 475.3,95.4 475,95.5 475,95.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "475,93.6 475.3,93.5 475.3,93.2 475,93.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "475.3,96 475.3,95.8 475,95.9 475,96.2  "
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "527,94.7 518.3,90.7 518.3,77.8 527,81.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "546.2,64.9 518.3,77.8 527,81.8 554.9,68.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "554.9,68.9 554.9,81.8 527,94.7 527,81.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "553.2,71.3 549.7,73 549.7,82.6 553.2,81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "547.9,73.8 544.5,75.4 544.5,85.1 547.9,83.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "542.7,76.2 539.2,77.8 539.2,87.5 542.7,85.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "537.5,78.6 534,80.2 534,89.9 537.5,88.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "532.2,81 528.7,82.6 528.7,92.3 532.2,90.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "553.2,80.5 553.2,71.3 552.5,71.7 552.5,80.8 553.2,81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "552.5,80.8 552.5,80.8 549.7,82.1 549.7,82.6 553.2,81 553.2,81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M550,73.2l2.1-1v0.3l-2.1,1V73.2z M550,73.9l2.1-1v-0.3l-2.1,1V73.9z M550,74.3l2.1-1v-0.3l-2.1,1V74.3z  M550,74.7l2.1-1v-0.3l-2.1,1V74.7z M550,75.1l2.1-1v-0.3l-2.1,1V75.1z M550,75.6l2.1-1v-0.3l-2.1,1V75.6z M550,76l2.1-1v-0.3 l-2.1,1V76z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "550,77.3 552.1,76.3 552.1,76 550,77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "550,77.7 552.1,76.7 552.1,76.5 550,77.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "550,78.1 552.1,77.1 552.1,76.9 550,77.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "550,78.5 552.1,77.6 552.1,77.3 550,78.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "552.1,73.7 552.1,73.5 551.8,73.6 551.8,73.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "552.1,74.2 552.1,73.9 551.8,74.1 551.8,74.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "552.1,72.6 551.8,72.8 551.8,73 552.1,72.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "552.1,73.3 552.1,73.1 551.8,73.2 551.8,73.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "552.1,74.6 552.1,74.3 551.8,74.5 551.8,74.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "551.8,72.6 552.1,72.5 552.1,72.2 551.8,72.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "552.1,75 552.1,74.8 551.8,74.9 551.8,75.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "547.9,82.9 547.9,73.8 547.2,74.1 547.2,83.2 547.9,83.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "547.2,83.2 547.2,83.2 544.5,84.5 544.5,85.1 547.9,83.4 547.9,83.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M544.7,75.6l2.1-1v0.3l-2.1,1V75.6z M544.7,76.3l2.1-1v-0.3l-2.1,1V76.3z M544.7,76.7l2.1-1v-0.3l-2.1,1 V76.7z M544.7,77.1l2.1-1v-0.3l-2.1,1V77.1z M544.7,77.6l2.1-1v-0.3l-2.1,1V77.6z M544.7,78l2.1-1v-0.3l-2.1,1V78z  M544.7,78.4l2.1-1v-0.3l-2.1,1V78.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "544.7,79.7 546.9,78.7 546.9,78.4 544.7,79.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "544.7,80.1 546.9,79.1 546.9,78.9 544.7,79.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "544.7,80.5 546.9,79.5 546.9,79.3 544.7,80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "544.7,81 546.9,80 546.9,79.7 544.7,80.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "546.9,76.2 546.9,75.9 546.6,76 546.6,76.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "546.9,76.6 546.9,76.3 546.6,76.5 546.6,76.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "546.9,75.1 546.6,75.2 546.6,75.5 546.9,75.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "546.9,75.7 546.9,75.5 546.6,75.6 546.6,75.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "546.9,77 546.9,76.8 546.6,76.9 546.6,77.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "546.6,75 546.9,74.9 546.9,74.6 546.6,74.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "546.9,77.4 546.9,77.2 546.6,77.3 546.6,77.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "542.7,85.3 542.7,76.2 542,76.5 542,85.6 542.7,85.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "542,85.6 542,85.6 539.2,86.9 539.2,87.5 542.7,85.9 542.7,85.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M539.5,78l2.1-1v0.3l-2.1,1V78z M539.5,78.7l2.1-1v-0.3l-2.1,1V78.7z M539.5,79.1l2.1-1v-0.3l-2.1,1V79.1 z M539.5,79.6l2.1-1v-0.3l-2.1,1V79.6z M539.5,80l2.1-1v-0.3l-2.1,1V80z M539.5,80.4l2.1-1v-0.3l-2.1,1V80.4z M539.5,80.8 l2.1-1v-0.3l-2.1,1V80.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "539.5,82.1 541.6,81.1 541.6,80.9 539.5,81.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "539.5,82.5 541.6,81.5 541.6,81.3 539.5,82.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "539.5,83 541.6,82 541.6,81.7 539.5,82.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "539.5,83.4 541.6,82.4 541.6,82.1 539.5,83.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "541.6,78.6 541.6,78.3 541.3,78.5 541.3,78.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "541.6,79 541.6,78.7 541.3,78.9 541.3,79.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "541.6,77.5 541.3,77.6 541.3,77.9 541.6,77.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "541.6,78.2 541.6,77.9 541.3,78 541.3,78.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "541.6,79.4 541.6,79.2 541.3,79.3 541.3,79.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "541.3,77.4 541.6,77.3 541.6,77.1 541.3,77.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "541.6,79.8 541.6,79.6 541.3,79.7 541.3,80  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "537.5,87.7 537.5,78.6 536.8,78.9 536.8,88.1 537.5,88.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "536.8,88.1 536.8,88.1 534,89.3 534,89.9 537.5,88.3 537.5,88.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M534.3,80.5l2.1-1v0.3l-2.1,1V80.5z M534.3,81.1l2.1-1v-0.3l-2.1,1V81.1z M534.3,81.6l2.1-1v-0.3l-2.1,1 V81.6z M534.3,82l2.1-1v-0.3l-2.1,1V82z M534.3,82.4l2.1-1v-0.3l-2.1,1V82.4z M534.3,82.8l2.1-1v-0.3l-2.1,1V82.8z  M534.3,83.3l2.1-1V82l-2.1,1V83.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "534.3,84.5 536.4,83.5 536.4,83.3 534.3,84.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "534.3,84.9 536.4,84 536.4,83.7 534.3,84.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "534.3,85.4 536.4,84.4 536.4,84.1 534.3,85.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "534.3,85.8 536.4,84.8 536.4,84.6 534.3,85.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "536.4,81 536.4,80.7 536.1,80.9 536.1,81.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "536.4,81.4 536.4,81.2 536.1,81.3 536.1,81.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "536.4,79.9 536.1,80 536.1,80.3 536.4,80.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "536.4,80.6 536.4,80.3 536.1,80.5 536.1,80.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "536.4,81.8 536.4,81.6 536.1,81.7 536.1,82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "536.1,79.9 536.4,79.7 536.4,79.5 536.1,79.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "536.4,82.3 536.4,82 536.1,82.2 536.1,82.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "532.2,90.2 532.2,81 531.5,81.4 531.5,90.5 532.2,90.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "531.5,90.5 531.5,90.5 528.7,91.8 528.7,92.3 532.2,90.7 532.2,90.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M529,82.9l2.1-1v0.3l-2.1,1V82.9z M529,83.6l2.1-1v-0.3l-2.1,1V83.6z M529,84l2.1-1v-0.3l-2.1,1V84z  M529,84.4l2.1-1v-0.3l-2.1,1V84.4z M529,84.8l2.1-1v-0.3l-2.1,1V84.8z M529,85.2l2.1-1V84l-2.1,1V85.2z M529,85.7l2.1-1v-0.3 l-2.1,1V85.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "529,86.9 531.2,86 531.2,85.7 529,86.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "529,87.4 531.2,86.4 531.2,86.1 529,87.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "529,87.8 531.2,86.8 531.2,86.6 529,87.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "529,88.2 531.2,87.2 531.2,87 529,88  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "531.2,83.4 531.2,83.2 530.9,83.3 530.9,83.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "531.2,83.8 531.2,83.6 530.9,83.7 530.9,84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "531.2,82.3 530.9,82.5 530.9,82.7 531.2,82.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "531.2,83 531.2,82.7 530.9,82.9 530.9,83.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "531.2,84.3 531.2,84 530.9,84.1 530.9,84.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "530.9,82.3 531.2,82.1 531.2,81.9 530.9,82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "531.2,84.7 531.2,84.4 530.9,84.6 530.9,84.8  "
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "486.9,113.2 478.1,109.2 478.1,96.3 486.9,100.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "506.1,83.4 478.1,96.3 486.9,100.3 514.8,87.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "514.8,87.4 514.8,100.3 486.9,113.2 486.9,100.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "513,89.9 509.5,91.5 509.5,101.1 513,99.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "507.8,92.3 504.3,93.9 504.3,103.6 507.8,101.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "502.6,94.7 499.1,96.3 499.1,106 502.6,104.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "497.3,97.1 493.8,98.7 493.8,108.4 497.3,106.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "492.1,99.5 488.6,101.1 488.6,110.8 492.1,109.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "513,99 513,89.9 512.3,90.2 512.3,99.3 513,99.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "512.3,99.3 512.3,99.3 509.5,100.6 509.5,101.1 513,99.5 513,99.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M509.8,91.7l2.1-1V91l-2.1,1V91.7z M509.8,92.4l2.1-1v-0.3l-2.1,1V92.4z M509.8,92.8l2.1-1v-0.3l-2.1,1 V92.8z M509.8,93.2l2.1-1V92l-2.1,1V93.2z M509.8,93.7l2.1-1v-0.3l-2.1,1V93.7z M509.8,94.1l2.1-1v-0.3l-2.1,1V94.1z  M509.8,94.5l2.1-1v-0.3l-2.1,1V94.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "509.8,95.8 512,94.8 512,94.5 509.8,95.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "509.8,96.2 512,95.2 512,95 509.8,95.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "509.8,96.6 512,95.6 512,95.4 509.8,96.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "509.8,97 512,96.1 512,95.8 509.8,96.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "512,92.2 512,92 511.7,92.1 511.7,92.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "512,92.7 512,92.4 511.7,92.6 511.7,92.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "512,91.1 511.7,91.3 511.7,91.5 512,91.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "512,91.8 512,91.6 511.7,91.7 511.7,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "512,93.1 512,92.8 511.7,93 511.7,93.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "511.7,91.1 512,91 512,90.7 511.7,90.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "512,93.5 512,93.3 511.7,93.4 511.7,93.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "507.8,101.4 507.8,92.3 507.1,92.6 507.1,101.7 507.8,101.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "507.1,101.7 507.1,101.7 504.3,103 504.3,103.6 507.8,101.9 507.8,101.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M504.6,94.1l2.1-1v0.3l-2.1,1V94.1z M504.6,94.8l2.1-1v-0.3l-2.1,1V94.8z M504.6,95.2l2.1-1V94l-2.1,1 V95.2z M504.6,95.6l2.1-1v-0.3l-2.1,1V95.6z M504.6,96.1l2.1-1v-0.3l-2.1,1V96.1z M504.6,96.5l2.1-1v-0.3l-2.1,1V96.5z  M504.6,96.9l2.1-1v-0.3l-2.1,1V96.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "504.6,98.2 506.7,97.2 506.7,96.9 504.6,97.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "504.6,98.6 506.7,97.6 506.7,97.4 504.6,98.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "504.6,99 506.7,98.1 506.7,97.8 504.6,98.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "504.6,99.5 506.7,98.5 506.7,98.2 504.6,99.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "506.7,94.7 506.7,94.4 506.4,94.5 506.4,94.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "506.7,95.1 506.7,94.8 506.4,95 506.4,95.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "506.7,93.6 506.4,93.7 506.4,94 506.7,93.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "506.7,94.2 506.7,94 506.4,94.1 506.4,94.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "506.7,95.5 506.7,95.3 506.4,95.4 506.4,95.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "506.4,93.5 506.7,93.4 506.7,93.1 506.4,93.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "506.7,95.9 506.7,95.7 506.4,95.8 506.4,96.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "502.6,103.8 502.6,94.7 501.9,95 501.9,104.1 502.6,104.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "501.9,104.1 501.9,104.1 499.1,105.4 499.1,106 502.6,104.4 502.6,104.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M499.4,96.5l2.1-1v0.3l-2.1,1V96.5z M499.4,97.2l2.1-1V96l-2.1,1V97.2z M499.4,97.6l2.1-1v-0.3l-2.1,1 V97.6z M499.4,98.1l2.1-1v-0.3l-2.1,1V98.1z M499.4,98.5l2.1-1v-0.3l-2.1,1V98.5z M499.4,98.9l2.1-1v-0.3l-2.1,1V98.9z  M499.4,99.3l2.1-1v-0.3l-2.1,1V99.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "499.4,100.6 501.5,99.6 501.5,99.4 499.4,100.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "499.4,101 501.5,100 501.5,99.8 499.4,100.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "499.4,101.5 501.5,100.5 501.5,100.2 499.4,101.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "499.4,101.9 501.5,100.9 501.5,100.6 499.4,101.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "501.5,97.1 501.5,96.8 501.2,97 501.2,97.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "501.5,97.5 501.5,97.2 501.2,97.4 501.2,97.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "501.5,96 501.2,96.1 501.2,96.4 501.5,96.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "501.5,96.7 501.5,96.4 501.2,96.5 501.2,96.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "501.5,97.9 501.5,97.7 501.2,97.8 501.2,98.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "501.2,95.9 501.5,95.8 501.5,95.6 501.2,95.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "501.5,98.4 501.5,98.1 501.2,98.2 501.2,98.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "497.3,106.2 497.3,97.1 496.6,97.4 496.6,106.6 497.3,106.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "496.6,106.6 496.6,106.6 493.8,107.8 493.8,108.4 497.3,106.8 497.3,106.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M494.1,99l2.1-1v0.3l-2.1,1V99z M494.1,99.6l2.1-1v-0.3l-2.1,1V99.6z M494.1,100.1l2.1-1v-0.3l-2.1,1 V100.1z M494.1,100.5l2.1-1v-0.3l-2.1,1V100.5z M494.1,100.9l2.1-1v-0.3l-2.1,1V100.9z M494.1,101.3l2.1-1v-0.3l-2.1,1V101.3z  M494.1,101.8l2.1-1v-0.3l-2.1,1V101.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "494.1,103 496.2,102 496.2,101.8 494.1,102.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "494.1,103.4 496.2,102.5 496.2,102.2 494.1,103.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "494.1,103.9 496.2,102.9 496.2,102.6 494.1,103.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "494.1,104.3 496.2,103.3 496.2,103.1 494.1,104  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "496.2,99.5 496.2,99.2 495.9,99.4 495.9,99.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "496.2,99.9 496.2,99.7 495.9,99.8 495.9,100.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "496.2,98.4 495.9,98.5 495.9,98.8 496.2,98.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "496.2,99.1 496.2,98.8 495.9,99 495.9,99.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "496.2,100.3 496.2,100.1 495.9,100.2 495.9,100.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "495.9,98.4 496.2,98.2 496.2,98 495.9,98.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "496.2,100.8 496.2,100.5 495.9,100.7 495.9,100.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "492.1,108.7 492.1,99.5 491.4,99.9 491.4,109 492.1,109.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "491.4,109 491.4,109 488.6,110.3 488.6,110.8 492.1,109.2 492.1,109.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M488.9,101.4l2.1-1v0.3l-2.1,1V101.4z M488.9,102.1l2.1-1v-0.3l-2.1,1V102.1z M488.9,102.5l2.1-1v-0.3 l-2.1,1V102.5z M488.9,102.9l2.1-1v-0.3l-2.1,1V102.9z M488.9,103.3l2.1-1v-0.3l-2.1,1V103.3z M488.9,103.7l2.1-1v-0.3l-2.1,1 V103.7z M488.9,104.2l2.1-1v-0.3l-2.1,1V104.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "488.9,105.4 491,104.5 491,104.2 488.9,105.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "488.9,105.9 491,104.9 491,104.6 488.9,105.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "488.9,106.3 491,105.3 491,105.1 488.9,106  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "488.9,106.7 491,105.7 491,105.5 488.9,106.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "491,101.9 491,101.7 490.7,101.8 490.7,102.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "491,102.3 491,102.1 490.7,102.2 490.7,102.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "491,100.8 490.7,101 490.7,101.2 491,101.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "491,101.5 491,101.2 490.7,101.4 490.7,101.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "491,102.8 491,102.5 490.7,102.7 490.7,102.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "490.7,100.8 491,100.6 491,100.4 490.7,100.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "491,103.2 491,102.9 490.7,103.1 490.7,103.3  "
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "542.7,102.1 534,98.1 534,85.2 542.7,89.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "561.9,72.3 534,85.2 542.7,89.2 570.6,76.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "570.6,76.3 570.6,89.2 542.7,102.1 542.7,89.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "568.9,78.7 565.4,80.3 565.4,90 568.9,88.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "563.7,81.1 560.2,82.7 560.2,92.4 563.7,90.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "558.4,83.5 554.9,85.2 554.9,94.8 558.4,93.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "553.2,86 549.7,87.6 549.7,97.2 553.2,95.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "547.9,88.4 544.5,90 544.5,99.7 547.9,98.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "568.9,87.8 568.9,78.7 568.2,79 568.2,88.2 568.9,88.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "568.2,88.2 568.2,88.2 565.4,89.4 565.4,90 568.9,88.4 568.9,88.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M565.7,80.6l2.1-1v0.3l-2.1,1V80.6z M565.7,81.2l2.1-1V80l-2.1,1V81.2z M565.7,81.7l2.1-1v-0.3l-2.1,1 V81.7z M565.7,82.1l2.1-1v-0.3l-2.1,1V82.1z M565.7,82.5l2.1-1v-0.3l-2.1,1V82.5z M565.7,82.9l2.1-1v-0.3l-2.1,1V82.9z  M565.7,83.3l2.1-1v-0.3l-2.1,1V83.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "565.7,84.6 567.8,83.6 567.8,83.4 565.7,84.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "565.7,85 567.8,84.1 567.8,83.8 565.7,84.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "565.7,85.5 567.8,84.5 567.8,84.2 565.7,85.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "565.7,85.9 567.8,84.9 567.8,84.7 565.7,85.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "567.8,81.1 567.8,80.8 567.5,81 567.5,81.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "567.8,81.5 567.8,81.3 567.5,81.4 567.5,81.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "567.8,80 567.5,80.1 567.5,80.4 567.8,80.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "567.8,80.7 567.8,80.4 567.5,80.6 567.5,80.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "567.8,81.9 567.8,81.7 567.5,81.8 567.5,82.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "567.5,80 567.8,79.8 567.8,79.6 567.5,79.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "567.8,82.4 567.8,82.1 567.5,82.3 567.5,82.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "563.7,90.2 563.7,81.1 562.9,81.4 562.9,90.6 563.7,90.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "562.9,90.6 562.9,90.6 560.2,91.9 560.2,92.4 563.7,90.8 563.7,90.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M560.4,83l2.1-1v0.3l-2.1,1V83z M560.4,83.6l2.1-1v-0.3l-2.1,1V83.6z M560.4,84.1l2.1-1v-0.3l-2.1,1V84.1 z M560.4,84.5l2.1-1v-0.3l-2.1,1V84.5z M560.4,84.9l2.1-1v-0.3l-2.1,1V84.9z M560.4,85.3l2.1-1v-0.3l-2.1,1V85.3z M560.4,85.8 l2.1-1v-0.3l-2.1,1V85.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "560.4,87 562.6,86.1 562.6,85.8 560.4,86.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "560.4,87.5 562.6,86.5 562.6,86.2 560.4,87.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "560.4,87.9 562.6,86.9 562.6,86.6 560.4,87.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "560.4,88.3 562.6,87.3 562.6,87.1 560.4,88.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "562.6,83.5 562.6,83.3 562.3,83.4 562.3,83.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "562.6,83.9 562.6,83.7 562.3,83.8 562.3,84.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "562.6,82.4 562.3,82.5 562.3,82.8 562.6,82.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "562.6,83.1 562.6,82.8 562.3,83 562.3,83.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "562.6,84.4 562.6,84.1 562.3,84.2 562.3,84.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "562.3,82.4 562.6,82.2 562.6,82 562.3,82.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "562.6,84.8 562.6,84.5 562.3,84.7 562.3,84.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "558.4,92.7 558.4,83.5 557.7,83.9 557.7,93 558.4,93.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "557.7,93 557.7,93 554.9,94.3 554.9,94.8 558.4,93.2 558.4,93.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M555.2,85.4l2.1-1v0.3l-2.1,1V85.4z M555.2,86.1l2.1-1v-0.3l-2.1,1V86.1z M555.2,86.5l2.1-1v-0.3l-2.1,1 V86.5z M555.2,86.9l2.1-1v-0.3l-2.1,1V86.9z M555.2,87.3l2.1-1v-0.3l-2.1,1V87.3z M555.2,87.8l2.1-1v-0.3l-2.1,1V87.8z  M555.2,88.2l2.1-1v-0.3l-2.1,1V88.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "555.2,89.5 557.3,88.5 557.3,88.2 555.2,89.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "555.2,89.9 557.3,88.9 557.3,88.6 555.2,89.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "555.2,90.3 557.3,89.3 557.3,89.1 555.2,90.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "555.2,90.7 557.3,89.7 557.3,89.5 555.2,90.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "557.3,85.9 557.3,85.7 557,85.8 557,86.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "557.3,86.4 557.3,86.1 557,86.2 557,86.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "557.3,84.8 557,85 557,85.2 557.3,85.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "557.3,85.5 557.3,85.3 557,85.4 557,85.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "557.3,86.8 557.3,86.5 557,86.7 557,86.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "557,84.8 557.3,84.7 557.3,84.4 557,84.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "557.3,87.2 557.3,86.9 557,87.1 557,87.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "553.2,95.1 553.2,86 552.5,86.3 552.5,95.4 553.2,95.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "552.5,95.4 552.5,95.4 549.7,96.7 549.7,97.2 553.2,95.6 553.2,95.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M550,87.8l2.1-1v0.3l-2.1,1V87.8z M550,88.5l2.1-1v-0.3l-2.1,1V88.5z M550,88.9l2.1-1v-0.3l-2.1,1V88.9z  M550,89.3l2.1-1v-0.3l-2.1,1V89.3z M550,89.8l2.1-1v-0.3l-2.1,1V89.8z M550,90.2l2.1-1v-0.3l-2.1,1V90.2z M550,90.6l2.1-1 v-0.3l-2.1,1V90.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "550,91.9 552.1,90.9 552.1,90.6 550,91.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "550,92.3 552.1,91.3 552.1,91.1 550,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "550,92.7 552.1,91.7 552.1,91.5 550,92.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "550,93.1 552.1,92.2 552.1,91.9 550,92.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "552.1,88.3 552.1,88.1 551.8,88.2 551.8,88.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "552.1,88.8 552.1,88.5 551.8,88.7 551.8,88.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "552.1,87.2 551.8,87.4 551.8,87.6 552.1,87.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "552.1,87.9 552.1,87.7 551.8,87.8 551.8,88.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "552.1,89.2 552.1,88.9 551.8,89.1 551.8,89.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "551.8,87.2 552.1,87.1 552.1,86.8 551.8,87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "552.1,89.6 552.1,89.4 551.8,89.5 551.8,89.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "547.9,97.5 547.9,88.4 547.2,88.7 547.2,97.8 547.9,98.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "547.2,97.8 547.2,97.8 544.5,99.1 544.5,99.7 547.9,98.1 547.9,98.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M544.7,90.2l2.1-1v0.3l-2.1,1V90.2z M544.7,90.9l2.1-1v-0.3l-2.1,1V90.9z M544.7,91.3l2.1-1v-0.3l-2.1,1 V91.3z M544.7,91.8l2.1-1v-0.3l-2.1,1V91.8z M544.7,92.2l2.1-1v-0.3l-2.1,1V92.2z M544.7,92.6l2.1-1v-0.3l-2.1,1V92.6z  M544.7,93l2.1-1v-0.3l-2.1,1V93z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "544.7,94.3 546.9,93.3 546.9,93.1 544.7,94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "544.7,94.7 546.9,93.7 546.9,93.5 544.7,94.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "544.7,95.1 546.9,94.2 546.9,93.9 544.7,94.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "544.7,95.6 546.9,94.6 546.9,94.3 544.7,95.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "546.9,90.8 546.9,90.5 546.6,90.7 546.6,90.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "546.9,91.2 546.9,90.9 546.6,91.1 546.6,91.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "546.9,89.7 546.6,89.8 546.6,90.1 546.9,89.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "546.9,90.3 546.9,90.1 546.6,90.2 546.6,90.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "546.9,91.6 546.9,91.4 546.6,91.5 546.6,91.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "546.6,89.6 546.9,89.5 546.9,89.2 546.6,89.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "546.9,92 546.9,91.8 546.6,91.9 546.6,92.2  "
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "502.6,120.6 493.8,116.6 493.8,103.7 502.6,107.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "521.8,90.8 493.8,103.7 502.6,107.7 530.5,94.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "530.5,94.8 530.5,107.7 502.6,120.6 502.6,107.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "528.7,97.2 525.3,98.8 525.3,108.5 528.7,106.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "523.5,99.6 520,101.2 520,110.9 523.5,109.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "518.3,102 514.8,103.7 514.8,113.3 518.3,111.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "513,104.5 509.5,106.1 509.5,115.7 513,114.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "507.8,106.9 504.3,108.5 504.3,118.2 507.8,116.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "528.7,106.3 528.7,97.2 528,97.5 528,106.7 528.7,106.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "528,106.7 528,106.7 525.3,107.9 525.3,108.5 528.7,106.9 528.7,106.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M525.5,99.1l2.1-1v0.3l-2.1,1V99.1z M525.5,99.7l2.1-1v-0.3l-2.1,1V99.7z M525.5,100.2l2.1-1v-0.3l-2.1,1 V100.2z M525.5,100.6l2.1-1v-0.3l-2.1,1V100.6z M525.5,101l2.1-1v-0.3l-2.1,1V101z M525.5,101.4l2.1-1v-0.3l-2.1,1V101.4z  M525.5,101.9l2.1-1v-0.3l-2.1,1V101.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "525.5,103.1 527.7,102.1 527.7,101.9 525.5,102.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "525.5,103.5 527.7,102.6 527.7,102.3 525.5,103.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "525.5,104 527.7,103 527.7,102.7 525.5,103.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "525.5,104.4 527.7,103.4 527.7,103.2 525.5,104.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "527.7,99.6 527.7,99.3 527.4,99.5 527.4,99.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "527.7,100 527.7,99.8 527.4,99.9 527.4,100.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "527.7,98.5 527.4,98.6 527.4,98.9 527.7,98.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "527.7,99.2 527.7,98.9 527.4,99.1 527.4,99.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "527.7,100.4 527.7,100.2 527.4,100.3 527.4,100.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "527.4,98.5 527.7,98.3 527.7,98.1 527.4,98.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "527.7,100.9 527.7,100.6 527.4,100.8 527.4,101  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "523.5,108.8 523.5,99.6 522.8,99.9 522.8,109.1 523.5,109.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "522.8,109.1 522.8,109.1 520,110.4 520,110.9 523.5,109.3 523.5,109.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M520.3,101.5l2.1-1v0.3l-2.1,1V101.5z M520.3,102.2l2.1-1v-0.3l-2.1,1V102.2z M520.3,102.6l2.1-1v-0.3 l-2.1,1V102.6z M520.3,103l2.1-1v-0.3l-2.1,1V103z M520.3,103.4l2.1-1v-0.3l-2.1,1V103.4z M520.3,103.8l2.1-1v-0.3l-2.1,1 V103.8z M520.3,104.3l2.1-1V103l-2.1,1V104.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "520.3,105.5 522.4,104.6 522.4,104.3 520.3,105.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "520.3,106 522.4,105 522.4,104.7 520.3,105.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "520.3,106.4 522.4,105.4 522.4,105.1 520.3,106.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "520.3,106.8 522.4,105.8 522.4,105.6 520.3,106.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "522.4,102 522.4,101.8 522.1,101.9 522.1,102.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "522.4,102.4 522.4,102.2 522.1,102.3 522.1,102.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "522.4,100.9 522.1,101.1 522.1,101.3 522.4,101.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "522.4,101.6 522.4,101.3 522.1,101.5 522.1,101.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "522.4,102.9 522.4,102.6 522.1,102.7 522.1,103  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "522.1,100.9 522.4,100.7 522.4,100.5 522.1,100.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "522.4,103.3 522.4,103 522.1,103.2 522.1,103.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "518.3,111.2 518.3,102 517.6,102.4 517.6,111.5 518.3,111.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "517.6,111.5 517.6,111.5 514.8,112.8 514.8,113.3 518.3,111.7 518.3,111.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M515.1,103.9l2.1-1v0.3l-2.1,1V103.9z M515.1,104.6l2.1-1v-0.3l-2.1,1V104.6z M515.1,105l2.1-1v-0.3 l-2.1,1V105z M515.1,105.4l2.1-1v-0.3l-2.1,1V105.4z M515.1,105.8l2.1-1v-0.3l-2.1,1V105.8z M515.1,106.3l2.1-1V105l-2.1,1 V106.3z M515.1,106.7l2.1-1v-0.3l-2.1,1V106.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "515.1,108 517.2,107 517.2,106.7 515.1,107.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "515.1,108.4 517.2,107.4 517.2,107.1 515.1,108.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "515.1,108.8 517.2,107.8 517.2,107.6 515.1,108.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "515.1,109.2 517.2,108.2 517.2,108 515.1,109  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "517.2,104.4 517.2,104.2 516.9,104.3 516.9,104.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "517.2,104.9 517.2,104.6 516.9,104.7 516.9,105  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "517.2,103.3 516.9,103.5 516.9,103.7 517.2,103.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "517.2,104 517.2,103.8 516.9,103.9 516.9,104.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "517.2,105.3 517.2,105 516.9,105.2 516.9,105.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "516.9,103.3 517.2,103.2 517.2,102.9 516.9,103  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "517.2,105.7 517.2,105.4 516.9,105.6 516.9,105.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "513,113.6 513,104.5 512.3,104.8 512.3,113.9 513,114.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "512.3,113.9 512.3,113.9 509.5,115.2 509.5,115.7 513,114.1 513,114.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M509.8,106.3l2.1-1v0.3l-2.1,1V106.3z M509.8,107l2.1-1v-0.3l-2.1,1V107z M509.8,107.4l2.1-1v-0.3l-2.1,1 V107.4z M509.8,107.8l2.1-1v-0.3l-2.1,1V107.8z M509.8,108.3l2.1-1V107l-2.1,1V108.3z M509.8,108.7l2.1-1v-0.3l-2.1,1V108.7z  M509.8,109.1l2.1-1v-0.3l-2.1,1V109.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "509.8,110.4 512,109.4 512,109.1 509.8,110.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "509.8,110.8 512,109.8 512,109.6 509.8,110.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "509.8,111.2 512,110.2 512,110 509.8,111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "509.8,111.6 512,110.7 512,110.4 509.8,111.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "512,106.8 512,106.6 511.7,106.7 511.7,107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "512,107.3 512,107 511.7,107.2 511.7,107.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "512,105.7 511.7,105.9 511.7,106.1 512,106  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "512,106.4 512,106.2 511.7,106.3 511.7,106.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "512,107.7 512,107.4 511.7,107.6 511.7,107.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "511.7,105.7 512,105.6 512,105.3 511.7,105.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "512,108.1 512,107.9 511.7,108 511.7,108.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "507.8,116 507.8,106.9 507.1,107.2 507.1,116.3 507.8,116.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "507.1,116.3 507.1,116.3 504.3,117.6 504.3,118.2 507.8,116.6 507.8,116.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M504.6,108.7l2.1-1v0.3l-2.1,1V108.7z M504.6,109.4l2.1-1v-0.3l-2.1,1V109.4z M504.6,109.8l2.1-1v-0.3 l-2.1,1V109.8z M504.6,110.3l2.1-1V109l-2.1,1V110.3z M504.6,110.7l2.1-1v-0.3l-2.1,1V110.7z M504.6,111.1l2.1-1v-0.3l-2.1,1 V111.1z M504.6,111.5l2.1-1v-0.3l-2.1,1V111.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "504.6,112.8 506.7,111.8 506.7,111.6 504.6,112.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "504.6,113.2 506.7,112.2 506.7,112 504.6,113  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "504.6,113.6 506.7,112.7 506.7,112.4 504.6,113.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "504.6,114.1 506.7,113.1 506.7,112.8 504.6,113.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "506.7,109.3 506.7,109 506.4,109.2 506.4,109.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "506.7,109.7 506.7,109.4 506.4,109.6 506.4,109.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "506.7,108.2 506.4,108.3 506.4,108.6 506.7,108.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "506.7,108.8 506.7,108.6 506.4,108.7 506.4,109  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "506.7,110.1 506.7,109.9 506.4,110 506.4,110.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "506.4,108.1 506.7,108 506.7,107.7 506.4,107.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "506.7,110.5 506.7,110.3 506.4,110.4 506.4,110.7  "
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "558.4,109.3 549.7,105.3 549.7,92.4 558.4,96.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "577.6,79.5 549.7,92.4 558.4,96.4 586.3,83.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "586.3,83.5 586.3,96.4 558.4,109.3 558.4,96.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "584.6,85.9 581.1,87.5 581.1,97.2 584.6,95.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "579.4,88.3 575.9,89.9 575.9,99.6 579.4,98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "574.1,90.8 570.6,92.4 570.6,102 574.1,100.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "568.9,93.2 565.4,94.8 565.4,104.5 568.9,102.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "563.7,95.6 560.2,97.2 560.2,106.9 563.7,105.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "584.6,95 584.6,85.9 583.9,86.2 583.9,95.4 584.6,95.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "583.9,95.4 583.9,95.4 581.1,96.7 581.1,97.2 584.6,95.6 584.6,95.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M581.4,87.8l2.1-1V87l-2.1,1V87.8z M581.4,88.4l2.1-1v-0.3l-2.1,1V88.4z M581.4,88.9l2.1-1v-0.3l-2.1,1 V88.9z M581.4,89.3l2.1-1v-0.3l-2.1,1V89.3z M581.4,89.7l2.1-1v-0.3l-2.1,1V89.7z M581.4,90.1l2.1-1v-0.3l-2.1,1V90.1z  M581.4,90.6l2.1-1v-0.3l-2.1,1V90.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "581.4,91.8 583.5,90.8 583.5,90.6 581.4,91.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "581.4,92.3 583.5,91.3 583.5,91 581.4,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "581.4,92.7 583.5,91.7 583.5,91.4 581.4,92.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "581.4,93.1 583.5,92.1 583.5,91.9 581.4,92.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "583.5,88.3 583.5,88.1 583.2,88.2 583.2,88.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "583.5,88.7 583.5,88.5 583.2,88.6 583.2,88.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "583.5,87.2 583.2,87.3 583.2,87.6 583.5,87.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "583.5,87.9 583.5,87.6 583.2,87.8 583.2,88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "583.5,89.2 583.5,88.9 583.2,89 583.2,89.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "583.2,87.2 583.5,87 583.5,86.8 583.2,86.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "583.5,89.6 583.5,89.3 583.2,89.5 583.2,89.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "579.4,97.5 579.4,88.3 578.6,88.7 578.6,97.8 579.4,98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "578.6,97.8 578.6,97.8 575.9,99.1 575.9,99.6 579.4,98 579.4,98  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M576.1,90.2l2.1-1v0.3l-2.1,1V90.2z M576.1,90.9l2.1-1v-0.3l-2.1,1V90.9z M576.1,91.3l2.1-1V90l-2.1,1 V91.3z M576.1,91.7l2.1-1v-0.3l-2.1,1V91.7z M576.1,92.1l2.1-1v-0.3l-2.1,1V92.1z M576.1,92.6l2.1-1v-0.3l-2.1,1V92.6z  M576.1,93l2.1-1v-0.3l-2.1,1V93z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "576.1,94.3 578.3,93.3 578.3,93 576.1,94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "576.1,94.7 578.3,93.7 578.3,93.4 576.1,94.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "576.1,95.1 578.3,94.1 578.3,93.9 576.1,94.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "576.1,95.5 578.3,94.5 578.3,94.3 576.1,95.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "578.3,90.7 578.3,90.5 578,90.6 578,90.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "578.3,91.1 578.3,90.9 578,91 578,91.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "578.3,89.6 578,89.8 578,90 578.3,89.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "578.3,90.3 578.3,90 578,90.2 578,90.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "578.3,91.6 578.3,91.3 578,91.5 578,91.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "578,89.6 578.3,89.5 578.3,89.2 578,89.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "578.3,92 578.3,91.7 578,91.9 578,92.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "574.1,99.9 574.1,90.8 573.4,91.1 573.4,100.2 574.1,100.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "573.4,100.2 573.4,100.2 570.6,101.5 570.6,102 574.1,100.4 574.1,100.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M570.9,92.6l2.1-1v0.3l-2.1,1V92.6z M570.9,93.3l2.1-1V92l-2.1,1V93.3z M570.9,93.7l2.1-1v-0.3l-2.1,1 V93.7z M570.9,94.1l2.1-1v-0.3l-2.1,1V94.1z M570.9,94.6l2.1-1v-0.3l-2.1,1V94.6z M570.9,95l2.1-1v-0.3l-2.1,1V95z  M570.9,95.4l2.1-1v-0.3l-2.1,1V95.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "570.9,96.7 573,95.7 573,95.4 570.9,96.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "570.9,97.1 573,96.1 573,95.9 570.9,96.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "570.9,97.5 573,96.5 573,96.3 570.9,97.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "570.9,97.9 573,97 573,96.7 570.9,97.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "573,93.1 573,92.9 572.7,93 572.7,93.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "573,93.6 573,93.3 572.7,93.5 572.7,93.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "573,92 572.7,92.2 572.7,92.4 573,92.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "573,92.7 573,92.5 572.7,92.6 572.7,92.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "573,94 573,93.7 572.7,93.9 572.7,94.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "572.7,92 573,91.9 573,91.6 572.7,91.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "573,94.4 573,94.2 572.7,94.3 572.7,94.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "568.9,102.3 568.9,93.2 568.2,93.5 568.2,102.6 568.9,102.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "568.2,102.6 568.2,102.6 565.4,103.9 565.4,104.5 568.9,102.8 568.9,102.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M565.7,95l2.1-1v0.3l-2.1,1V95z M565.7,95.7l2.1-1v-0.3l-2.1,1V95.7z M565.7,96.1l2.1-1v-0.3l-2.1,1V96.1 z M565.7,96.5l2.1-1v-0.3l-2.1,1V96.5z M565.7,97l2.1-1v-0.3l-2.1,1V97z M565.7,97.4l2.1-1v-0.3l-2.1,1V97.4z M565.7,97.8 l2.1-1v-0.3l-2.1,1V97.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "565.7,99.1 567.8,98.1 567.8,97.9 565.7,98.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "565.7,99.5 567.8,98.5 567.8,98.3 565.7,99.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "565.7,99.9 567.8,99 567.8,98.7 565.7,99.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "565.7,100.4 567.8,99.4 567.8,99.1 565.7,100.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "567.8,95.6 567.8,95.3 567.5,95.4 567.5,95.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "567.8,96 567.8,95.7 567.5,95.9 567.5,96.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "567.8,94.5 567.5,94.6 567.5,94.9 567.8,94.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "567.8,95.1 567.8,94.9 567.5,95 567.5,95.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "567.8,96.4 567.8,96.2 567.5,96.3 567.5,96.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "567.5,94.4 567.8,94.3 567.8,94 567.5,94.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "567.8,96.8 567.8,96.6 567.5,96.7 567.5,97  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "563.7,104.7 563.7,95.6 562.9,95.9 562.9,105 563.7,105.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "562.9,105 562.9,105 560.2,106.3 560.2,106.9 563.7,105.3 563.7,105.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M560.4,97.4l2.1-1v0.3l-2.1,1V97.4z M560.4,98.1l2.1-1v-0.3l-2.1,1V98.1z M560.4,98.5l2.1-1v-0.3l-2.1,1 V98.5z M560.4,99l2.1-1v-0.3l-2.1,1V99z M560.4,99.4l2.1-1v-0.3l-2.1,1V99.4z M560.4,99.8l2.1-1v-0.3l-2.1,1V99.8z  M560.4,100.2l2.1-1V99l-2.1,1V100.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "560.4,101.5 562.6,100.5 562.6,100.3 560.4,101.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "560.4,101.9 562.6,100.9 562.6,100.7 560.4,101.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "560.4,102.4 562.6,101.4 562.6,101.1 560.4,102.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "560.4,102.8 562.6,101.8 562.6,101.5 560.4,102.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "562.6,98 562.6,97.7 562.3,97.9 562.3,98.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "562.6,98.4 562.6,98.2 562.3,98.3 562.3,98.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "562.6,96.9 562.3,97 562.3,97.3 562.6,97.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "562.6,97.6 562.6,97.3 562.3,97.4 562.3,97.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "562.6,98.8 562.6,98.6 562.3,98.7 562.3,99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "562.3,96.9 562.6,96.7 562.6,96.5 562.3,96.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "562.6,99.3 562.6,99 562.3,99.1 562.3,99.4  "
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "518.3,127.8 509.5,123.8 509.5,110.9 518.3,114.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "537.5,98 509.5,110.9 518.3,114.9 546.2,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "546.2,102 546.2,114.9 518.3,127.8 518.3,114.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "544.5,104.4 541,106 541,115.7 544.5,114.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "539.2,106.8 535.7,108.4 535.7,118.1 539.2,116.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "534,109.3 530.5,110.9 530.5,120.5 534,118.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "528.7,111.7 525.3,113.3 525.3,123 528.7,121.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "523.5,114.1 520,115.7 520,125.4 523.5,123.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "544.5,113.5 544.5,104.4 543.7,104.7 543.7,113.9 544.5,114.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "543.7,113.9 543.7,113.9 541,115.2 541,115.7 544.5,114.1 544.5,114.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M541.2,106.3l2.1-1v0.3l-2.1,1V106.3z M541.2,106.9l2.1-1v-0.3l-2.1,1V106.9z M541.2,107.4l2.1-1v-0.3 l-2.1,1V107.4z M541.2,107.8l2.1-1v-0.3l-2.1,1V107.8z M541.2,108.2l2.1-1V107l-2.1,1V108.2z M541.2,108.6l2.1-1v-0.3l-2.1,1 V108.6z M541.2,109.1l2.1-1v-0.3l-2.1,1V109.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "541.2,110.3 543.4,109.4 543.4,109.1 541.2,110.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "541.2,110.8 543.4,109.8 543.4,109.5 541.2,110.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "541.2,111.2 543.4,110.2 543.4,109.9 541.2,110.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "541.2,111.6 543.4,110.6 543.4,110.4 541.2,111.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "543.4,106.8 543.4,106.6 543.1,106.7 543.1,106.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "543.4,107.2 543.4,107 543.1,107.1 543.1,107.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "543.4,105.7 543.1,105.8 543.1,106.1 543.4,106  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "543.4,106.4 543.4,106.1 543.1,106.3 543.1,106.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "543.4,107.7 543.4,107.4 543.1,107.5 543.1,107.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "543.1,105.7 543.4,105.5 543.4,105.3 543.1,105.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "543.4,108.1 543.4,107.8 543.1,108 543.1,108.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "539.2,116 539.2,106.8 538.5,107.2 538.5,116.3 539.2,116.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "538.5,116.3 538.5,116.3 535.7,117.6 535.7,118.1 539.2,116.5 539.2,116.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M536,108.7l2.1-1v0.3l-2.1,1V108.7z M536,109.4l2.1-1v-0.3l-2.1,1V109.4z M536,109.8l2.1-1v-0.3l-2.1,1 V109.8z M536,110.2l2.1-1V109l-2.1,1V110.2z M536,110.6l2.1-1v-0.3l-2.1,1V110.6z M536,111.1l2.1-1v-0.3l-2.1,1V111.1z  M536,111.5l2.1-1v-0.3l-2.1,1V111.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "536,112.8 538.1,111.8 538.1,111.5 536,112.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "536,113.2 538.1,112.2 538.1,111.9 536,112.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "536,113.6 538.1,112.6 538.1,112.4 536,113.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "536,114 538.1,113 538.1,112.8 536,113.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "538.1,109.2 538.1,109 537.8,109.1 537.8,109.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "538.1,109.7 538.1,109.4 537.8,109.5 537.8,109.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "538.1,108.1 537.8,108.3 537.8,108.5 538.1,108.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "538.1,108.8 538.1,108.5 537.8,108.7 537.8,108.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "538.1,110.1 538.1,109.8 537.8,110 537.8,110.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "537.8,108.1 538.1,108 538.1,107.7 537.8,107.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "538.1,110.5 538.1,110.2 537.8,110.4 537.8,110.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "534,118.4 534,109.3 533.3,109.6 533.3,118.7 534,118.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "533.3,118.7 533.3,118.7 530.5,120 530.5,120.5 534,118.9 534,118.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M530.8,111.1l2.1-1v0.3l-2.1,1V111.1z M530.8,111.8l2.1-1v-0.3l-2.1,1V111.8z M530.8,112.2l2.1-1V111 l-2.1,1V112.2z M530.8,112.6l2.1-1v-0.3l-2.1,1V112.6z M530.8,113.1l2.1-1v-0.3l-2.1,1V113.1z M530.8,113.5l2.1-1v-0.3l-2.1,1 V113.5z M530.8,113.9l2.1-1v-0.3l-2.1,1V113.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "530.8,115.2 532.9,114.2 532.9,113.9 530.8,114.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "530.8,115.6 532.9,114.6 532.9,114.4 530.8,115.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "530.8,116 532.9,115 532.9,114.8 530.8,115.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "530.8,116.4 532.9,115.5 532.9,115.2 530.8,116.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "532.9,111.6 532.9,111.4 532.6,111.5 532.6,111.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "532.9,112.1 532.9,111.8 532.6,112 532.6,112.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "532.9,110.5 532.6,110.7 532.6,110.9 532.9,110.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "532.9,111.2 532.9,111 532.6,111.1 532.6,111.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "532.9,112.5 532.9,112.2 532.6,112.4 532.6,112.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "532.6,110.5 532.9,110.4 532.9,110.1 532.6,110.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "532.9,112.9 532.9,112.7 532.6,112.8 532.6,113.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "528.7,120.8 528.7,111.7 528,112 528,121.1 528.7,121.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "528,121.1 528,121.1 525.3,122.4 525.3,123 528.7,121.3 528.7,121.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M525.5,113.5l2.1-1v0.3l-2.1,1V113.5z M525.5,114.2l2.1-1V113l-2.1,1V114.2z M525.5,114.6l2.1-1v-0.3 l-2.1,1V114.6z M525.5,115l2.1-1v-0.3l-2.1,1V115z M525.5,115.5l2.1-1v-0.3l-2.1,1V115.5z M525.5,115.9l2.1-1v-0.3l-2.1,1 V115.9z M525.5,116.3l2.1-1v-0.3l-2.1,1V116.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "525.5,117.6 527.7,116.6 527.7,116.4 525.5,117.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "525.5,118 527.7,117 527.7,116.8 525.5,117.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "525.5,118.4 527.7,117.5 527.7,117.2 525.5,118.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "525.5,118.9 527.7,117.9 527.7,117.6 525.5,118.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "527.7,114.1 527.7,113.8 527.4,114 527.4,114.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "527.7,114.5 527.7,114.2 527.4,114.4 527.4,114.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "527.7,113 527.4,113.1 527.4,113.4 527.7,113.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "527.7,113.6 527.7,113.4 527.4,113.5 527.4,113.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "527.7,114.9 527.7,114.7 527.4,114.8 527.4,115.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "527.4,112.9 527.7,112.8 527.7,112.5 527.4,112.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "527.7,115.3 527.7,115.1 527.4,115.2 527.4,115.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "523.5,123.2 523.5,114.1 522.8,114.4 522.8,123.6 523.5,123.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "522.8,123.6 522.8,123.6 520,124.8 520,125.4 523.5,123.8 523.5,123.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M520.3,115.9l2.1-1v0.3l-2.1,1V115.9z M520.3,116.6l2.1-1v-0.3l-2.1,1V116.6z M520.3,117l2.1-1v-0.3 l-2.1,1V117z M520.3,117.5l2.1-1v-0.3l-2.1,1V117.5z M520.3,117.9l2.1-1v-0.3l-2.1,1V117.9z M520.3,118.3l2.1-1v-0.3l-2.1,1 V118.3z M520.3,118.7l2.1-1v-0.3l-2.1,1V118.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "520.3,120 522.4,119 522.4,118.8 520.3,119.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "520.3,120.4 522.4,119.4 522.4,119.2 520.3,120.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "520.3,120.9 522.4,119.9 522.4,119.6 520.3,120.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "520.3,121.3 522.4,120.3 522.4,120 520.3,121  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "522.4,116.5 522.4,116.2 522.1,116.4 522.1,116.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "522.4,116.9 522.4,116.7 522.1,116.8 522.1,117  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "522.4,115.4 522.1,115.5 522.1,115.8 522.4,115.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "522.4,116.1 522.4,115.8 522.1,115.9 522.1,116.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "522.4,117.3 522.4,117.1 522.1,117.2 522.1,117.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "522.1,115.4 522.4,115.2 522.4,115 522.1,115.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "522.4,117.8 522.4,117.5 522.1,117.6 522.1,117.9  "
  }))))))))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000031909178547259651110000000595403223133866942_",
    points: "723.5,111.7 723.5,65.5 683.5,42.3 643.5,65.5  643.5,111.7 683.5,134.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165936949007412915490000006639004924996552121_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031909178547259651110000000595403223133866942_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000165936949007412915490000006639004924996552121_)"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 683.5,
    cy: 94,
    r: 62.2
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st208",
    points: "693,148.6 617.4,138.2 617.4,90.8 693,101.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "716.9,138.2 693,148.6 693,101.1 716.9,90.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "693,101.1 617.4,90.8 641.4,80.4 716.9,90.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st209",
    points: "693,148.6 617.4,138.2 617.4,90.8 693,101.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "620.2,94 620.2,97.2 690.2,106.7 690.2,103.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "620.2,98.8 620.2,102 690.2,111.6 690.2,108.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "620.2,103.7 620.2,106.9 690.2,116.5 690.2,113.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "620.2,108.5 620.2,111.7 690.2,121.3 690.2,118.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "620.2,113.4 620.2,116.6 690.2,126.2 690.2,123  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "620.2,118.3 620.2,121.5 690.2,131.1 690.2,127.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "620.2,123.1 620.2,126.3 690.2,135.9 690.2,132.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "620.2,128 620.2,131.2 690.2,140.8 690.2,137.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "620.2,132.8 620.2,136 690.2,145.6 690.2,142.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "632.4,124.8 628.3,124.2 628.3,127.4 632.4,128  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "654.9,127.9 650.8,127.3 650.8,130.5 654.9,131.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "628.3,108 632.4,108.5 632.4,105.4 628.3,104.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "636.9,125.4 632.8,124.8 632.8,128 636.9,128.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "645.9,126.6 641.8,126.1 641.8,129.3 645.9,129.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "641.4,126 637.3,125.5 637.3,128.7 641.4,129.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "650.4,127.3 646.3,126.7 646.3,129.9 650.4,130.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "677.8,111.6 677.8,114.8 681.9,115.3 681.9,112.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "632.8,108.6 636.9,109.2 636.9,106 632.8,105.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "659.8,112.3 663.9,112.9 663.9,109.7 659.8,109.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "668.8,113.5 672.9,114.1 672.9,110.9 668.8,110.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "641.8,109.8 645.9,110.4 645.9,107.2 641.8,106.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "673.3,114.1 677.4,114.7 677.4,111.5 673.3,111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "664.3,112.9 668.4,113.5 668.4,110.3 664.3,109.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "646.3,110.4 650.4,111 650.4,107.8 646.3,107.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "650.8,111.1 654.9,111.6 654.9,108.4 650.8,107.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "655.3,111.7 659.4,112.3 659.4,109.1 655.3,108.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "637.3,109.2 641.4,109.8 641.4,106.6 637.3,106  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "659.4,128.5 655.3,127.9 655.3,131.1 659.4,131.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "655.3,106.8 659.4,107.4 659.4,104.2 655.3,103.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "646.3,105.6 650.4,106.2 650.4,103 646.3,102.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "659.8,107.4 663.9,108 663.9,104.8 659.8,104.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "632.8,103.7 636.9,104.3 636.9,101.1 632.8,100.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "641.8,105 645.9,105.5 645.9,102.3 641.8,101.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "664.3,108.1 668.4,108.6 668.4,105.4 664.3,104.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "637.3,104.3 641.4,104.9 641.4,101.7 637.3,101.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "650.8,106.2 654.9,106.8 654.9,103.6 650.8,103  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "677.4,131 673.3,130.4 673.3,133.6 677.4,134.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "668.4,129.7 664.3,129.2 664.3,132.4 668.4,132.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "668.8,108.7 672.9,109.2 672.9,106 668.8,105.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "663.9,129.1 659.8,128.5 659.8,131.7 663.9,132.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "672.9,130.4 668.8,129.8 668.8,133 672.9,133.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "673.3,109.3 677.4,109.9 677.4,106.7 673.3,106.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "677.8,109.9 681.9,110.5 681.9,107.3 677.8,106.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "681.9,131.6 677.8,131 677.8,134.2 681.9,134.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "641.4,121.2 637.3,120.6 637.3,123.8 641.4,124.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "673.3,119 677.4,119.6 677.4,116.4 673.3,115.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "668.8,118.4 672.9,119 672.9,115.8 668.8,115.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "664.3,117.8 668.4,118.3 668.4,115.2 664.3,114.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "677.4,121.2 673.3,120.7 673.3,123.9 677.4,124.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "646.3,115.3 650.4,115.9 650.4,112.7 646.3,112.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "672.9,120.6 668.8,120.1 668.8,123.3 672.9,123.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "650.8,115.9 654.9,116.5 654.9,113.3 650.8,112.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "655.3,116.5 659.4,117.1 659.4,113.9 655.3,113.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "659.8,117.2 663.9,117.7 663.9,114.5 659.8,114  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "677.8,116.4 677.8,119.6 681.9,120.2 681.9,117  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "650.4,117.5 646.3,117 646.3,120.2 650.4,120.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "645.9,116.9 641.8,116.4 641.8,119.5 645.9,120.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "636.9,115.7 632.8,115.1 632.8,118.3 636.9,118.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "654.9,118.2 650.8,117.6 650.8,120.8 654.9,121.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "668.4,120 664.3,119.4 664.3,122.6 668.4,123.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "663.9,119.4 659.8,118.8 659.8,122 663.9,122.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "659.4,118.8 655.3,118.2 655.3,121.4 659.4,122  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "641.4,116.3 637.3,115.7 637.3,118.9 641.4,119.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "663.9,124.3 659.8,123.7 659.8,126.9 663.9,127.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "668.4,124.9 664.3,124.3 664.3,127.5 668.4,128.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "659.4,123.6 655.3,123.1 655.3,126.3 659.4,126.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "672.9,125.5 668.8,124.9 668.8,128.1 672.9,128.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "677.4,126.1 673.3,125.5 673.3,128.7 677.4,129.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "654.9,123 650.8,122.4 650.8,125.6 654.9,126.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "641.8,114.7 645.9,115.3 645.9,112.1 641.8,111.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "681.9,126.7 677.8,126.2 677.8,129.3 681.9,129.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "677.8,121.3 677.8,124.5 681.9,125.1 681.9,121.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "632.8,113.5 636.9,114 636.9,110.8 632.8,110.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "628.3,112.8 632.4,113.4 632.4,110.2 628.3,109.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "637.3,114.1 641.4,114.6 641.4,111.4 637.3,110.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "632.4,123.1 632.4,119.9 628.3,119.4 628.3,122.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "650.4,122.4 646.3,121.8 646.3,125 650.4,125.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "636.9,120.6 632.8,120 632.8,123.2 636.9,123.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "645.9,121.8 641.8,121.2 641.8,124.4 645.9,125  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "628.3,103.1 632.4,103.7 632.4,100.5 628.3,99.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "632.4,118.3 632.4,115.1 628.3,114.5 628.3,117.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "668.4,139.5 664.3,138.9 664.3,142.1 668.4,142.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "663.9,138.8 659.8,138.3 659.8,141.5 663.9,142  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "659.4,138.2 655.3,137.7 655.3,140.8 659.4,141.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "623.4,94.4 620.2,94 620.2,97.2 623.4,97.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "654.9,137.6 650.8,137 650.8,140.2 654.9,140.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "681.9,141.3 677.8,140.7 677.8,143.9 681.9,144.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "686.4,141.9 682.3,141.4 682.3,144.6 686.4,145.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "672.9,140.1 668.8,139.5 668.8,142.7 672.9,143.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "677.4,140.7 673.3,140.1 673.3,143.3 677.4,143.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "650.4,137 646.3,136.4 646.3,139.6 650.4,140.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "628.3,98.3 632.4,98.8 632.4,95.6 628.3,95.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "627.9,133.9 623.8,133.3 623.8,136.5 627.9,137.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "623.8,97.6 627.9,98.2 627.9,95 623.8,94.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "637.3,99.5 641.4,100.1 641.4,96.9 637.3,96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "632.4,134.5 628.3,133.9 628.3,137.1 632.4,137.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "641.4,135.8 637.3,135.2 637.3,138.4 641.4,139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "636.9,135.1 632.8,134.6 632.8,137.8 636.9,138.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "645.9,136.4 641.8,135.8 641.8,139 645.9,139.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "632.8,98.9 636.9,99.4 636.9,96.2 632.8,95.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "686.8,120.9 690.2,121.3 690.2,118.1 686.8,117.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "623.4,99.3 620.2,98.8 620.2,102 623.4,102.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "686.8,125.7 690.2,126.2 690.2,123 686.8,122.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "686.8,135.4 690.2,135.9 690.2,132.7 686.8,132.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "686.8,130.6 690.2,131.1 690.2,127.9 686.8,127.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "686.8,103.1 686.8,106.3 690.2,106.7 690.2,103.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "686.8,111.1 690.2,111.6 690.2,108.4 686.8,107.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "686.8,116 690.2,116.5 690.2,113.3 686.8,112.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "686.8,140.3 690.2,140.8 690.2,137.6 686.8,137.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "623.4,118.7 620.2,118.3 620.2,121.5 623.4,121.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "686.8,145.2 690.2,145.6 690.2,142.4 686.8,142  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "623.4,113.8 620.2,113.4 620.2,116.6 623.4,117  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "623.4,104.1 620.2,103.7 620.2,106.9 623.4,107.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "623.4,109 620.2,108.5 620.2,111.7 623.4,112.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "623.4,133.3 620.2,132.8 620.2,136 623.4,136.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "623.4,123.6 620.2,123.1 620.2,126.3 623.4,126.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "623.4,128.4 620.2,128 620.2,131.2 623.4,131.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "682.3,102.5 682.3,105.7 686.4,106.2 686.4,103  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "654.9,132.7 650.8,132.2 650.8,135.4 654.9,135.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "650.4,132.1 646.3,131.6 646.3,134.8 650.4,135.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "645.9,131.5 641.8,130.9 641.8,134.1 645.9,134.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "659.4,133.4 655.3,132.8 655.3,136 659.4,136.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "668.4,134.6 664.3,134 664.3,137.2 668.4,137.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "663.9,134 659.8,133.4 659.8,136.6 663.9,137.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "672.9,135.2 668.8,134.6 668.8,137.8 672.9,138.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "677.4,135.8 673.3,135.3 673.3,138.5 677.4,139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "641.4,130.9 637.3,130.3 637.3,133.5 641.4,134.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "627.9,122.5 627.9,119.3 623.8,118.7 623.8,121.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "636.9,130.3 632.8,129.7 632.8,132.9 636.9,133.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "627.9,112.8 627.9,109.6 623.8,109 623.8,112.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "627.9,107.9 627.9,104.7 623.8,104.2 623.8,107.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "627.9,117.7 627.9,114.5 623.8,113.9 623.8,117.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "632.4,129.7 628.3,129.1 628.3,132.3 632.4,132.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "627.9,132.2 627.9,129 623.8,128.5 623.8,131.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "641.8,100.1 645.9,100.7 645.9,97.5 641.8,96.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "627.9,127.4 627.9,124.2 623.8,123.6 623.8,126.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "659.8,102.6 663.9,103.1 663.9,99.9 659.8,99.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "664.3,103.2 668.4,103.8 668.4,100.6 664.3,100  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "668.8,103.8 672.9,104.4 672.9,101.2 668.8,100.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "673.3,104.4 677.4,105 677.4,101.8 673.3,101.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "677.8,105 681.9,105.6 681.9,102.4 677.8,101.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "646.3,100.7 650.4,101.3 650.4,98.1 646.3,97.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "650.8,101.3 654.9,101.9 654.9,98.7 650.8,98.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "655.3,102 659.4,102.5 659.4,99.3 655.3,98.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "681.9,136.4 677.8,135.9 677.8,139.1 681.9,139.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "682.3,126.8 682.3,130 686.4,130.5 686.4,127.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "623.8,102.5 627.9,103.1 627.9,99.9 623.8,99.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "682.3,121.9 682.3,125.1 686.4,125.7 686.4,122.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "686.4,137.1 682.3,136.5 682.3,139.7 686.4,140.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "682.3,131.6 682.3,134.8 686.4,135.4 686.4,132.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "682.3,107.3 682.3,110.5 686.4,111.1 686.4,107.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "682.3,112.2 682.3,115.4 686.4,116 686.4,112.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "682.3,117 682.3,120.2 686.4,120.8 686.4,117.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st211",
    points: "667.6,97.6 666.6,97.5 667.5,97.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st212",
    points: "669.4,96.3 690.5,87.1 714.9,90.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st211",
    points: "715.9,90.6 716.9,90.8 716,91.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st212",
    points: "714.2,92 693,101.1 668.6,97.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st60",
    cx: 692.3,
    cy: 94,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st62",
    cx: 692.3,
    cy: 93.9,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st213",
    cx: 692.3,
    cy: 93.9,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st64",
    cx: 692.3,
    cy: 93.9,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st214",
    cx: 692.3,
    cy: 93.9,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st67",
    cx: 692.3,
    cy: 93.8,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st69",
    cx: 692.3,
    cy: 93.8,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st70",
    cx: 692.3,
    cy: 93.8,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st115",
    cx: 692.3,
    cy: 93.8,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st73",
    cx: 692.3,
    cy: 93.7,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st215",
    cx: 692.3,
    cy: 93.7,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st75",
    cx: 692.3,
    cy: 93.7,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st216",
    cx: 692.3,
    cy: 93.6,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st79",
    cx: 692.3,
    cy: 93.6,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st120",
    cx: 692.3,
    cy: 93.6,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st81",
    cx: 692.3,
    cy: 93.6,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st217",
    cx: 692.3,
    cy: 93.5,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st85",
    cx: 692.3,
    cy: 93.5,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st218",
    cx: 692.3,
    cy: 93.5,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st124",
    cx: 692.3,
    cy: 93.5,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st219",
    cx: 692.3,
    cy: 93.4,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st220",
    cx: 692.3,
    cy: 93.4,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st221",
    cx: 692.3,
    cy: 93.4,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st222",
    cx: 692.3,
    cy: 93.4,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st223",
    cx: 692.3,
    cy: 93.3,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st224",
    cx: 692.3,
    cy: 93.3,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st225",
    cx: 692.3,
    cy: 93.3,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st226",
    cx: 692.3,
    cy: 93.2,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st227",
    cx: 692.3,
    cy: 93.2,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st228",
    cx: 692.3,
    cy: 93.2,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st134",
    cx: 692.3,
    cy: 93.2,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st229",
    cx: 692.3,
    cy: 93.1,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st230",
    cx: 692.3,
    cy: 93.1,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st231",
    cx: 692.3,
    cy: 93.1,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st232",
    cx: 692.3,
    cy: 93.1,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st138",
    cx: 692.3,
    cy: 93,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st139",
    cx: 692.3,
    cy: 93,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st140",
    cx: 692.3,
    cy: 93,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st141",
    cx: 692.3,
    cy: 93,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st233",
    cx: 692.3,
    cy: 92.9,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st142",
    cx: 692.3,
    cy: 92.9,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st143",
    cx: 692.3,
    cy: 92.9,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st144",
    cx: 692.3,
    cy: 92.8,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st234",
    cx: 692.3,
    cy: 92.8,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st235",
    cx: 692.3,
    cy: 92.8,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st236",
    cx: 692.3,
    cy: 92.8,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st237",
    cx: 692.3,
    cy: 92.7,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st238",
    cx: 692.3,
    cy: 92.7,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st239",
    cx: 692.3,
    cy: 92.7,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st240",
    cx: 692.3,
    cy: 92.7,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st241",
    cx: 692.3,
    cy: 92.6,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st152",
    cx: 692.3,
    cy: 92.6,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st153",
    cx: 692.3,
    cy: 92.6,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st154",
    cx: 692.3,
    cy: 92.5,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st242",
    cx: 692.3,
    cy: 92.5,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st243",
    cx: 692.3,
    cy: 92.5,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st156",
    cx: 692.3,
    cy: 92.5,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st157",
    cx: 692.3,
    cy: 92.4,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st244",
    cx: 692.3,
    cy: 92.4,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st159",
    cx: 692.3,
    cy: 92.4,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st160",
    cx: 692.3,
    cy: 92.4,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st245",
    cx: 692.3,
    cy: 92.3,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st246",
    cx: 692.3,
    cy: 92.3,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st162",
    cx: 692.3,
    cy: 92.3,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st163",
    cx: 692.3,
    cy: 92.3,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st164",
    cx: 692.3,
    cy: 92.2,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st247",
    cx: 692.3,
    cy: 92.2,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st166",
    cx: 692.3,
    cy: 92.2,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st167",
    cx: 692.3,
    cy: 92.1,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st248",
    cx: 692.3,
    cy: 92.1,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st249",
    cx: 692.3,
    cy: 92.1,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st250",
    cx: 692.3,
    cy: 92.1,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st170",
    cx: 692.3,
    cy: 92,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st251",
    cx: 692.3,
    cy: 92,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st172",
    cx: 692.3,
    cy: 92,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st173",
    cx: 692.3,
    cy: 92,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st252",
    cx: 692.3,
    cy: 91.9,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st253",
    cx: 692.3,
    cy: 91.9,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st175",
    cx: 692.3,
    cy: 91.9,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st176",
    cx: 692.3,
    cy: 91.8,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st177",
    cx: 692.3,
    cy: 91.8,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st254",
    cx: 692.3,
    cy: 91.8,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st179",
    cx: 692.3,
    cy: 91.8,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st255",
    cx: 692.3,
    cy: 91.7,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st256",
    cx: 692.3,
    cy: 91.7,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st181",
    cx: 692.3,
    cy: 91.7,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st182",
    cx: 692.3,
    cy: 91.7,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st183",
    cx: 692.3,
    cy: 91.6,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st257",
    cx: 692.3,
    cy: 91.6,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st184",
    cx: 692.3,
    cy: 91.6,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st186",
    cx: 692.3,
    cy: 91.6,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st258",
    cx: 692.3,
    cy: 91.5,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st259",
    cx: 692.3,
    cy: 91.5,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st260",
    cx: 692.3,
    cy: 91.5,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st189",
    cx: 692.3,
    cy: 91.4,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st190",
    cx: 692.3,
    cy: 91.4,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st261",
    cx: 692.3,
    cy: 91.4,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st202",
    cx: 692.3,
    cy: 91.4,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st193",
    cx: 692.3,
    cy: 91.3,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st262",
    cx: 692.3,
    cy: 91.3,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st263",
    cx: 692.3,
    cy: 91.3,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 692.3,
    cy: 91.3,
    rx: 4.1,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 692.3,
    cy: 91.3,
    rx: 4.1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st264",
    x1: 690,
    y1: 73.1,
    x2: 688.2,
    y2: 91.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st264",
    x1: 692.3,
    y1: 92.8,
    x2: 692.3,
    y2: 73.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st264",
    x1: 696.4,
    y1: 91.4,
    x2: 694.7,
    y2: 73.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st162",
    cx: 692.3,
    cy: 73.7,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st162",
    cx: 692.3,
    cy: 73.7,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st265",
    cx: 692.3,
    cy: 73.7,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st163",
    cx: 692.3,
    cy: 73.7,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st266",
    cx: 692.3,
    cy: 73.7,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st164",
    cx: 692.3,
    cy: 73.7,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st267",
    cx: 692.3,
    cy: 73.7,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st267",
    cx: 692.3,
    cy: 73.7,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st268",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st269",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st269",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st166",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st270",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st271",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st167",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st272",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st248",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st248",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st273",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st249",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st169",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st169",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st250",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st274",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st170",
    cx: 692.3,
    cy: 73.6,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st251",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st251",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st251",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st275",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st275",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st172",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st276",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st173",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st173",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st173",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st252",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st252",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st174",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st253",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st277",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st175",
    cx: 692.3,
    cy: 73.5,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st278",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st176",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st176",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st279",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st279",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st280",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st280",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st254",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st178",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st178",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st179",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st179",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st255",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st180",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st180",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st256",
    cx: 692.3,
    cy: 73.4,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st256",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st181",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st181",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st281",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st282",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st182",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st283",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st183",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st284",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st284",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st184",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st184",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st184",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st185",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st285",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st186",
    cx: 692.3,
    cy: 73.3,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st186",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st258",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st258",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st258",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st286",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st259",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st188",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st260",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st260",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st287",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st189",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st190",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st190",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st288",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st289",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st261",
    cx: 692.3,
    cy: 73.2,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st191",
    cx: 692.3,
    cy: 73.1,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st202",
    cx: 692.3,
    cy: 73.1,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st192",
    cx: 692.3,
    cy: 73.1,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st192",
    cx: 692.3,
    cy: 73.1,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st290",
    cx: 692.3,
    cy: 73.1,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st193",
    cx: 692.3,
    cy: 73.1,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st193",
    cx: 692.3,
    cy: 73.1,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st262",
    cx: 692.3,
    cy: 73.1,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st291",
    cx: 692.3,
    cy: 73.1,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st194",
    cx: 692.3,
    cy: 73.1,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st263",
    cx: 692.3,
    cy: 73.1,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 692.3,
    cy: 73.1,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 692.3,
    cy: 73.1,
    rx: 2.3,
    ry: 0.9
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 692.3,
    cy: 73.1,
    rx: 2.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st264",
    points: "692.3,90 688.5,88.4 692.3,86.7 696.1,88.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st264",
    points: "692.3,87 688.8,85.5 692.3,83.9 695.8,85.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st264",
    points: "692.3,84 689.1,82.6 692.3,81.2 695.6,82.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st264",
    points: "692.3,80.9 689.3,79.7 692.3,78.4 695.3,79.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st264",
    points: "692.3,77.9 689.6,76.7 692.3,75.6 695,76.7  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st292",
    x1: 692.3,
    y1: 73.1,
    x2: 692.3,
    y2: 69.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 692.3,
    cy: 69.4,
    r: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "uZYL1A_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M686.4,72.9C686.4,72.9,686.4,72.9,686.4,72.9c-0.1,0.1-0.2,0.1-0.3,0c-1.8-1.9-1.9-5.1,0-7 c0.1-0.1,0.2-0.1,0.3,0l0,0c0.1,0.1,0.1,0.2,0,0.3c-0.8,0.9-1.3,2-1.3,3.3c0,1.3,0.4,2.3,1.3,3.2 C686.5,72.8,686.5,72.9,686.4,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M698.2,72.9C698.2,72.9,698.2,72.9,698.2,72.9c-0.1-0.1-0.1-0.2,0-0.3c0.8-0.9,1.3-2,1.3-3.3 c0-1.3-0.4-2.3-1.3-3.2c-0.1-0.1-0.1-0.2,0-0.3c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.3,0c1.8,1.9,1.9,5,0,7 C698.4,73,698.3,73,698.2,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M687.3,66.8C687.3,66.8,687.3,66.8,687.3,66.8c0.1,0.1,0.1,0.2,0,0.3c-0.6,0.7-0.9,1.5-0.9,2.4 c0,0.9,0.3,1.7,0.9,2.4c0.1,0.1,0.1,0.2,0,0.3c0,0,0,0,0,0c-0.1,0.1-0.2,0.1-0.3,0c-1.4-1.4-1.4-3.8,0-5.3 C687.1,66.7,687.2,66.7,687.3,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M697.4,72.1C697.4,72.1,697.4,72.1,697.4,72.1c-0.1-0.1-0.1-0.2,0-0.3c1.2-1.4,1.2-3.5,0-4.8 c-0.1-0.1-0.1-0.2,0-0.3c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.3,0c1.3,1.3,1.4,3.7,0,5.3C697.6,72.1,697.4,72.1,697.4,72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M696.5,71.3C696.5,71.3,696.5,71.2,696.5,71.3c-0.1-0.1-0.1-0.2,0-0.3c0.4-0.4,0.6-1,0.6-1.6 c0-0.6-0.2-1.1-0.6-1.6c-0.1-0.1-0.1-0.2,0-0.3c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.3,0c0.9,0.9,1,2.6,0,3.6 C696.7,71.3,696.6,71.3,696.5,71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M688.1,67.6C688.1,67.6,688.1,67.6,688.1,67.6c0.1,0.1,0.1,0.2,0,0.3c-0.8,1-0.8,2.1,0,3.1 c0.1,0.1,0,0.2,0,0.2c0,0,0,0,0,0c-0.1,0.1-0.2,0.1-0.3,0c-0.9-0.9-0.9-2.6,0-3.6C687.9,67.5,688,67.5,688.1,67.6z"
  })))))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 683.5,
    cy: 94,
    r: 40
  })))), /*#__PURE__*/React.createElement("g", null, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000076594863804085078400000008007767896317442738_",
    className: "st197",
    points: "318.6,385.4 318.6,339.1  278.5,316 238.5,339.1 238.5,385.4 278.5,408.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000029012440731258613820000013643493882298847625_",
    points: "318.6,385.4 318.6,339.1 278.5,316  238.5,339.1 238.5,385.4 278.5,408.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098928886957314871240000008118489449729024904_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029012440731258613820000013643493882298847625_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000098928886957314871240000008118489449729024904_)"
    }
  }, _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "312,377.4 302.2,371.7 290.9,378.3 300.5,384.1  "
  })), /*#__PURE__*/React.createElement("g", null, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M266,377.5l-11.6-6.9c-1.6-1-2.5-2.3-2.5-3.8c0-1.6,0.8-2.8,2.5-3.7l29-17c1.3-0.7,3.1-1.2,4.9-1.2 c1.8,0,3.5,0.4,4.9,1.2l11.5,6.8c1.6,1,2.5,2.3,2.5,3.8c0,1.5-0.9,2.9-2.5,3.8l-29.9,17.5C274.7,378,271,379.8,266,377.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M272.5,378.7c-1.8,0-3.4-0.3-4.7-1.1l-19.1-11.1c-1.6-0.9-2.5-2.5-2.5-3.9c0-1.5,0.7-2.9,2.3-3.8 l34.9-20.3c1-0.7,3.4-1,5.3-1c1.8,0,3.6,0.5,5,1.3l17.8,10.2c1.6,0.9,2.2,2,2.2,3.5c0,1.5-0.7,2.9-2.3,3.7l-34.1,21.3 C277.2,377.6,275.2,378.7,272.5,378.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M271.3,378.7c-1.8,0-3.4-0.3-4.7-1.1l-17.9-10.4c-1.6-0.9-2.5-2.5-2.5-3.9c0-1.5,0.7-2.9,2.3-3.8 l34.9-20.3c1-0.7,3.4-1,5.3-1c1.8,0,3.6,0.5,5,1.3l17.7,10.1c1.6,0.9,2.2,2,2.2,3.5c0,1.5-0.7,2.9-2.3,3.7l-35.3,20.6 C275.9,377.5,274,378.7,271.3,378.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M271.3,379.1c-1.8,0-3.4-0.3-4.7-1.1l-17.9-10.5c-1.6-0.9-2.5-2.5-2.5-3.9c0-1.5,0.7-2.9,2.3-3.8 l34.9-20.3c1-0.7,3.4-1,5.3-1c1.8,0,3.6,0.5,5,1.3l17.7,10.2c1.6,0.9,2.2,2,2.2,3.5c0,1.5-0.7,2.9-2.3,3.7l-35.4,20.7 C275.9,377.9,274,379.1,271.3,379.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M271.1,379.4c-1.8,0-3.4-0.3-4.7-1.1l-17.6-10.2c-1.6-0.9-2.5-2.5-2.5-3.9c0-1.5,0.7-2.9,2.3-3.8 l34.9-20.3c1-0.7,3.4-1,5.3-1c1.8,0,3.6,0.5,5,1.3l17.4,9.9c1.6,0.9,2.2,2,2.2,3.5c0,1.5-0.7,2.9-2.3,3.7l-35.3,20.6 C275.7,378.2,273.8,379.4,271.1,379.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M271.2,379.7c-1.8,0-3.4-0.3-4.7-1.1l-17.7-10.3c-1.6-0.9-2.5-2.5-2.5-3.9c0-1.5,0.7-2.9,2.3-3.8 l34.9-20.3c1-0.7,3.4-1,5.3-1c1.8,0,3.6,0.5,5,1.3l17.4,10c1.6,0.9,2.2,2,2.2,3.5c0,1.5-0.7,2.9-2.3,3.7l-35.4,20.6 C275.8,378.6,273.8,379.7,271.2,379.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M271,380.1c-1.8,0-3.4-0.3-4.7-1.1l-17.5-10.2c-1.6-0.9-2.5-2.5-2.5-3.9c0-1.5,0.7-2.9,2.3-3.8l34.9-20.3 c1-0.7,3.4-1,5.3-1c1.8,0,3.6,0.5,5,1.3l17.3,9.9c1.6,0.9,2.2,2,2.2,3.5c0,1.5-0.7,2.9-2.3,3.7l-35.4,20.6 C275.7,378.9,273.7,380.1,271,380.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M270.8,380.3c-1.8,0-3.4-0.3-4.7-1.1l-17.3-10.1c-1.6-0.9-2.5-2.5-2.5-3.9c0-1.5,0.7-2.9,2.3-3.8 l34.9-20.3c1-0.7,3.4-1,5.3-1c1.8,0,3.6,0.5,5,1.3l17.1,9.7c1.6,0.9,2.2,2,2.2,3.5s-0.7,2.9-2.3,3.7l-35.3,20.6 C275.5,379.1,273.5,380.3,270.8,380.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M270.8,380.8c-1.8,0-3.4-0.3-4.7-1.1l-17.3-10.1c-1.6-0.9-2.5-2.5-2.5-3.9c0-1.5,0.7-2.9,2.3-3.8 l34.9-20.3c1-0.7,3.4-1,5.3-1c1.8,0,3.6,0.5,5,1.3l17.1,9.7c1.6,0.9,2.2,2,2.2,3.5s-0.7,2.9-2.3,3.7l-35.3,20.6 C275.5,379.6,273.5,380.8,270.8,380.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M270.8,381c-1.8,0-3.4-0.3-4.7-1.1l-17.3-10.1c-1.6-0.9-2.5-2.5-2.5-3.9c0-1.5,0.7-2.9,2.3-3.8l34.9-20.3 c1-0.7,3.4-1,5.3-1c1.8,0,3.6,0.5,5,1.3l17.1,9.7c1.6,0.9,2.2,2,2.2,3.5s-0.7,2.9-2.3,3.7l-35.3,20.6 C275.5,379.9,273.5,381,270.8,381z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M271.2,380.8c-1.8,0-3.3-0.3-4.6-1l-17.2-9.9c-1.6-0.9-2.5-2.4-2.5-3.8s0.7-2.8,2.2-3.7l34.3-20 c1-0.6,3.4-1,5.2-1c1.8,0,3.5,0.5,4.9,1.2l17,9.6c1.6,0.9,2.2,2,2.2,3.5c0,1.4-0.7,2.8-2.3,3.7l-34.7,20.3 C275.7,379.7,273.8,380.8,271.2,380.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M271.2,380.8c-1.8,0-3.3-0.3-4.6-1l-16.8-9.7c-1.6-0.9-2.5-2.4-2.5-3.8c0-1.4,0.7-2.8,2.2-3.7l33.9-19.8 c1-0.6,3.4-1,5.2-1c1.8,0,3.5,0.5,4.8,1.2l16.6,9.3c1.6,0.9,2.2,2,2.2,3.5s-0.7,2.8-2.3,3.7l-34.2,20.2 C275.7,379.7,273.8,380.8,271.2,380.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M270.7,378c-1.8,0-3.3-0.3-4.6-1l-13.3-7.8c-1.6-0.9-2.5-2.4-2.5-3.8c0-1.4,0.7-2.8,2.2-3.7l30.9-17.9 c1.3-0.7,3.5-1,5.2-1c1.8,0,3.5,0.5,4.9,1.3l13.1,7.5c1.6,0.9,2.2,2,2.2,3.5c0,1.4-0.7,2.8-2.3,3.7l-31.3,18.3 C275.3,376.9,273.4,378,270.7,378z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M270.7,378.2c-1.8,0-3.3-0.3-4.6-1l-13.3-7.8c-1.6-0.9-2.5-2.4-2.5-3.8c0-1.4,0.7-2.8,2.2-3.7l30.9-17.9 c1.3-0.7,3.5-1,5.2-1c1.8,0,3.5,0.5,4.9,1.3l13.1,7.5c1.6,0.9,2.2,2,2.2,3.5s-0.7,2.8-2.3,3.7l-31.3,18.3 C275.3,377.1,273.4,378.2,270.7,378.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M270.7,378.7c-1.8,0-3.3-0.3-4.6-1l-13.3-7.8c-1.6-0.9-2.5-2.4-2.5-3.8c0-1.4,0.7-2.8,2.2-3.7l30.9-17.9 c1.3-0.7,3.4-1.1,5.2-1.1c1.8,0,3.6,0.6,5,1.4l13.1,7.5c1.6,0.9,2.2,2,2.2,3.5s-0.7,2.8-2.3,3.7l-31.3,18.3 C275.3,377.6,273.4,378.7,270.7,378.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M270.7,378.6c-1.8,0-3.3-0.3-4.6-1L253,370c-1.6-0.9-2.5-2.4-2.5-3.8s0.7-2.8,2.2-3.7l30.7-17.8 c1.3-0.7,3.3-1.1,5.1-1.1c1.8,0,3.7,0.6,5,1.4l12.7,7.4c1.6,0.9,2.2,2,2.2,3.5s-0.7,2.7-2.2,3.5l-31.1,18.2 C275.3,377.4,273.4,378.6,270.7,378.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M270.7,378.4c-1.8,0-3.3-0.3-4.6-1l-12.9-7.4c-1.6-0.9-2.5-2.2-2.5-3.7c0-1.4,0.7-2.8,2.2-3.7l30.2-17.6 c1.3-0.7,3.3-1.1,5-1.1c1.8,0,3.7,0.5,5,1.2l12.5,7.2c1.6,0.9,2.2,2,2.2,3.5c0,1.4-0.7,2.6-2.2,3.5l-30.7,18 C275.2,377.2,273.3,378.4,270.7,378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M270.7,378.4c-1.8,0-3.3-0.3-4.6-1l-12.9-7.4c-1.6-0.9-2.5-2.2-2.5-3.7c0-1.4,0.7-2.8,2.2-3.7l30.2-17.6 c1.3-0.7,3.3-1.1,5-1.1c1.8,0,3.7,0.5,5,1.2l12.5,7.2c1.6,0.9,2.2,2,2.2,3.5c0,1.4-0.7,2.6-2.2,3.5l-30.7,18 C275.2,377.2,273.3,378.4,270.7,378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M270.8,378.4c-1.8,0-3.3-0.3-4.6-1l-12.8-7.3c-1.6-0.9-2.4-2.2-2.5-3.6c0-1.4,0.7-2.8,2.2-3.7l30.1-17.6 c1.3-0.7,3.2-1,5-1c1.8,0,3.5,0.3,4.8,1.1l12.5,7.2c1.6,0.9,2.2,2,2.2,3.5c0,1.4-0.5,2.6-2.1,3.5l-30.5,17.8 C275.3,377.2,273.4,378.4,270.8,378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M270.8,378.4c-1.8,0-3.3-0.3-4.6-1l-12.7-7.2c-1.6-0.9-2.4-2.2-2.4-3.5c0-1.4,0.7-2.7,2.2-3.6l30-17.4 c1.3-0.7,3-1.1,4.8-1.1c1.8,0,3.6,0.4,4.9,1.2l12.5,7.2c1.7,1,2.1,2,2.2,3.5c0,1.4-0.5,2.6-2.1,3.5l-30.5,17.4 C275.3,377.2,273.4,378.4,270.8,378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M270.9,378.6c-1.8,0-3.3-0.3-4.6-1l-12.7-7.2c-1.6-0.9-2.4-2.2-2.4-3.6s0.7-2.8,2.2-3.7l29.8-17.4 c1.3-0.7,3-1.1,4.8-1.1c1.8,0,3.7,0.4,5,1.2l12.4,7.1c1.6,0.9,2.2,2,2.2,3.5s-0.5,2.6-2.1,3.5l-30.2,17.7 C275.3,377.5,273.4,378.6,270.9,378.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M271.1,378.7c-1.8,0-3.3-0.3-4.6-1l-12.7-7.2c-1.6-0.9-2.4-2.2-2.4-3.6s0.8-2.7,2.4-3.6l29.6-17.4 c1.3-0.7,2.9-1.1,4.7-1.1c1.8,0,3.5,0.3,4.8,1.1l12.5,7.2c1.6,0.9,2.2,2,2.2,3.5s-0.5,2.6-2.1,3.5l-30,17.6 C275.5,377.6,273.7,378.7,271.1,378.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M270.7,378.8c1.8,0,3.7-0.5,5-1.2l29.6-17.4c1.4-0.8,2.2-2,2.2-3.4c0-1.4-0.8-2.6-2.3-3.5l-12.3-7 c-1.3-0.7-3-1.2-4.8-1.2s-3.5,0.4-4.8,1.2l-29.6,17.4c-1.5,0.9-2.3,2.1-2.3,3.5s0.8,2.6,2.3,3.5l12.4,7 C266.2,377.5,268.2,378.7,270.7,378.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M271,378.7c-1.7,0-3.4-0.4-4.6-1.1l-12.7-7.2c-1.4-0.8-2.2-2-2.2-3.2c0-1.3,0.7-2.5,2.2-3.2l29.9-17.4 c1.2-0.7,2.9-1.1,4.6-1.1c1.7,0,3.4,0.4,4.6,1.1l12.5,7.2c1.4,0.8,2.2,2,2.2,3.2c0,1.3-0.6,2.4-2,3.1l-29.9,17.6 C274.3,378.2,272.7,378.7,271,378.7L271,378.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M271,378.6c-1.7,0-3.3-0.4-4.6-1.1l-12.6-7.2c-1.4-0.8-2.2-1.9-2.2-3.2c0-1.3,0.7-2.4,2.1-3.2l29.7-17.4 c1.2-0.7,2.9-1.1,4.6-1.1s3.3,0.4,4.6,1.1l12.5,7.2c1.4,0.8,2.2,1.9,2.2,3.2s-0.6,2.3-2,3.1l-29.6,17.4 C274.4,378.2,272.8,378.6,271,378.6L271,378.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M271.2,378.4c-1.7,0-3.3-0.4-4.5-1.1l-12.3-7.1c-1.4-0.8-2.3-1.8-2.3-3.1c0-1.2,0.6-2.2,2.3-3.2l29.4-17.2 c1.2-0.7,2.8-1.1,4.5-1.1c1.7,0,3.3,0.4,4.5,1.1l12.2,7.1c2,1.2,2.2,2,2.1,3.1c-0.1,1.2-0.7,2.4-2.1,3.1l-29.3,17.2 C274.5,378.1,272.9,378.4,271.2,378.4L271.2,378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M271,378.4c-1.6,0-3.2-0.3-4.4-1l-12.7-7.4c-1.2-0.7-2-1.7-2-2.8s0.7-2.1,1.9-2.9l30-17.5 c1.2-0.7,2.7-1,4.4-1s3.2,0.3,4.4,1l12.6,7.3c1.2,0.7,2,1.7,2,2.8s-0.7,2.1-1.9,2.9l-29.8,17.5 C274.2,378,272.6,378.4,271,378.4L271,378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M270.9,378.2c-1.6,0-2.9-0.3-4-1l-12.6-7.3c-1.2-0.7-2-1.6-2-2.7c0-1.1,0.7-2.1,1.9-2.8l29.6-17.3 c1.2-0.7,2.7-1.1,4.3-1.1c1.6,0,3.2,0.3,4.4,1l12.5,7.2c1.9,1.1,1.9,1.8,2,2.9c0,1.1-0.7,2.1-1.9,2.8l-29.4,17.2 c-1.2,0.7-2.7,1-4.3,1H270.9z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st197",
    d: "M275.7,376.9l29.4-17.2c1.1-0.6,1.7-1.5,1.7-2.4s-0.6-1.8-1.7-2.4l-12.7-7.4c-1.1-0.6-2.6-1-4.2-1 c-1.6,0-3.1,0.3-4.2,1l-30.2,17.6c-1.1,0.6-1.7,1.5-1.7,2.4s0.6,1.8,1.7,2.4l12.8,7.4c1.1,0.6,2.6,1,4.2,1s3.1-0.4,4.2-1 L275.7,376.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st294",
    d: "M306.7,357.1c0,0,0.3,1.3-1.4,2.5L275,377.4c0,0-1.5,1-4.1,1c-2.6,0-4-0.9-4-0.9l-13.2-7.6 c0,0-1.4-0.9-1.5-2.1v-0.3l0.1,0.1c0,0,0.1,1,1.3,1.8l4,2.3l9.5,5.5c0,0,1.4,0.9,3.9,0.9s4-0.9,4-0.9l5.2-3.1l7.6-4.4l3.5-2 l3.7-2.2l10.6-6.3C305.4,359.2,306.7,358.3,306.7,357.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M317.9,361.8c0,2.2-1.5,4.4-4.4,6.1l-32.3,17.6c-5.8,3.4-15.3,3.4-21.2,0l-14.1-7.9 c-3.1-1.8-4.6-4.2-4.4-6.5v-11l24.5,13.7l9.3-0.1L311,353l6.8-2.8C317.9,350.2,317.9,361.7,317.9,361.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M262,383.4l0.1,3.1c0,0,10.4,4.4,20.3-1.6v-3.6l-3.1,1.7c0,0-2.8,1.2-5.7,1.4 C270.6,384.4,266.5,384.6,262,383.4z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "262,386.4 262,382.9 261.6,383.2 261.6,386.8  "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M240.8,364.1l2,4.7l10.3,6.5l10.7,5.3c0,0,2.8,0.7,3.7,0.7c5.9,0.6,12.6-1.8,12.6-1.8l15.3-9.1 c0,0,19.6-11.3,20.9-12.2c1.3-1,1.7-1.6,2-2.5c0.3-0.9,0.5-1.4,0.5-1.4v4c0,2.2-1,3.7-4,5.4l-33.2,18.5 c-6,3.5-15.8,3.7-21.8,0.2l-14.8-8.5c-3.1-1.8-4.2-4.3-4.1-6.7L240.8,364.1z"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "248.6,375.6 251.4,377.2 251.4,375.2 248.6,373.6  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "252,377.6 254.8,379.2 254.8,377.2 252,375.7  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "255.4,379.6 258.2,381.2 258.2,379.2 255.4,377.6  "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M317.4,351.3c1.5,1.4,1.4,3.2,1.4,3.2c0,2.2-1,3.4-4,5.1l-33.2,19.2c-6.5,3-15.9,3.7-21.8,0.5l-14.8-8.5 c-3.1-1.8-4.2-4.3-4.1-6.7c0.1-1,1.6-2.5,1.6-2.5l-0.9,2.5c-0.1,2.3,1.3,4.7,4.4,6.5l14.1,7.9c5.5,3.1,15.1,2.5,21.2-0.5 l32.3-18.7c2.9-1.6,4.3-2.4,4.4-4.6L317.4,351.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M317.4,351.3l0.5,3.6c0,2.2-1.5,2.9-4.4,4.6l-32.3,18.7c-6.2,2.9-15.7,3.5-21.2,0.5l-1.8-1v0.8l1.6,0.9 c5.9,3.2,15.3,2.5,21.8-0.5l33.2-19.2c2.9-1.7,4-2.9,4-5.1C318.8,354.5,318.9,352.8,317.4,351.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M270.9,378c-1.6,0-3.1-0.3-4.2-1l-12.9-7.4c-1.1-0.6-1.7-1.5-1.7-2.5c0-1,0.6-1.8,1.7-2.5l30.2-17.6 c1.1-0.6,2.6-1,4.2-1c1.6,0,3.1,0.3,4.2,1l12.7,7.4c1.1,0.6,1.7,1.5,1.7,2.5c0,1-0.6,1.8-1.7,2.5l-30,17.6 C274,377.7,272.5,378,270.9,378z M288.2,346.3c-1.6,0-3.1,0.3-4.1,1l-30.2,17.6c-1.1,0.6-1.7,1.5-1.6,2.4c0,0.9,0.6,1.8,1.7,2.4 l12.8,7.4c1.1,0.6,2.6,1,4.2,1c1.6,0,3.1-0.3,4.1-1l30-17.6c1.1-0.6,1.7-1.5,1.6-2.4c0-0.9-0.6-1.8-1.7-2.4l-12.6-7.4 C291.3,346.6,289.8,346.3,288.2,346.3z"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "286.8,349.5 301.8,358.2 302.6,358.7 301.8,359.2 274.2,375.2 273.3,375.7 272.5,375.2  257.5,366.5 256.6,366 257.5,365.6 285.1,349.6 286,349  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "274.2,375.2 273.4,375.7 272.5,375.2 257.5,366.5 256.7,366 257.5,365.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "275.9,374.2 275,374.6 274.2,374.2 259.2,365.5 258.3,365 259.2,364.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "277.6,373.1 276.7,373.6 275.9,373.1 260.9,364.5 260,364 260.9,363.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "279.3,372.1 278.4,372.6 277.6,372.1 262.6,363.5 261.7,363 262.6,362.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "281,371.2 280.2,371.6 279.3,371.2 264.4,362.5 263.5,362 264.4,361.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "282.8,370.1 281.9,370.6 281,370.1 266.1,361.5 265.2,361 266.1,360.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "284.5,369.1 283.6,369.6 282.8,369.1 267.8,360.5 266.9,360 267.8,359.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "286.3,368.1 285.4,368.6 284.6,368.2 269.5,359.4 268.7,359 269.6,358.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "288,367.1 287.1,367.6 286.3,367.1 271.2,358.4 270.4,357.9 271.3,357.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "289.8,366.1 288.9,366.6 288,366.1 273,357.5 272.2,357 273,356.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "291.5,365.2 290.7,365.6 289.8,365.2 274.8,356.5 274,356 274.8,355.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "293.2,364.1 292.4,364.6 291.5,364.1 276.6,355.5 275.7,355 276.6,354.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "294.9,363.1 294.1,363.6 293.2,363.1 278.3,354.5 277.4,354 278.3,353.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "296.7,362.1 295.8,362.6 295,362.2 280,353.4 279.1,353 280,352.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "298.4,361.1 297.5,361.6 296.7,361.1 281.7,352.4 280.8,351.9 281.7,351.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "300.2,360.1 299.3,360.6 298.5,360.1 283.5,351.5 282.6,351 283.5,350.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "301.9,359.1 301,359.6 300.2,359.1 285.2,350.4 284.3,350 285.2,349.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M301.8,358.1l-15-8.7l-0.9-0.5l-1,0.5l-13.7,8l0,0l0,0l-13.8,8l-1,0.6l1,0.5l15,8.7l0.9,0.5l1-0.5 l27.6-16l1-0.6L301.8,358.1z M299.4,357.1l-3.9,2.2l-7.4-4.3c0,0,0,0,0,0l-0.1-0.1c0,0,0,0,0,0l-3.5-2.1l3.9-2.2l2.3,1.3 l-2.9,1.6l6.5,3.7l2.9-1.6l0,0l1.2,0.7l-1.2-0.7l-0.1,0.1L299.4,357.1z M288.1,355.1C288.1,355.1,288.1,355.1,288.1,355.1 C288.1,355.1,288.1,355.1,288.1,355.1L288.1,355.1z M288.1,355.2l3.5,2c0-0.1,0.1-0.1,0.1-0.1l0.1,0c0,0-0.1,0-0.1,0 c-0.5,0.2-1.6-0.1-2.5-0.6C288.3,356.1,287.9,355.5,288.1,355.2z M297.1,355.6l-2.7,1.6l-6.2-3.6l2.7-1.6L297.1,355.6z  M286.6,349.5c-0.5,0.3-1,0.1-1.3,0l0.7-0.4L286.6,349.5z M256.8,366l0.7-0.4c0.1,0.1,0.1,0.2,0.1,0.4c0,0.1-0.1,0.3-0.2,0.4 L256.8,366z M261.6,368.8l2.7-1.6l6.2,3.6l-2.7,1.6L261.6,368.8z M274.1,375.1l-0.8,0.5l-0.8-0.5l-2.2-1.3l4.1-2.3l-3.7-2.1 c0.4-0.3,0-1-1-1.6c-1-0.5-2.1-0.8-2.7-0.6l-3.7-2.2l-4.2,2.4l2.4,1.4l0.1-0.1l-2.3-1.3l3.9-2.2l7.4,4.3c0,0,0,0,0,0l0.1,0.1 c0,0,0,0,0,0l3.5,2.1l-3.9,2.2l-2.3-1.3l2.9-1.6l-6.5-3.7l-2.9,1.6l-0.1,0l-3.8-2.2c0.1-0.1,0.2-0.3,0.2-0.5 c0-0.2-0.1-0.3-0.2-0.4l13.6-7.9l0.7,0.5l2.9,1.7c-1.1,0.7-1.7,1.6-1.7,2.6c0,1,0.7,2,1.9,2.7c1.2,0.7,2.9,1.1,4.6,1.1 c1.7,0,3.3-0.3,4.5-1.1l2.8,1.6l0.7,0.4L274.1,375.1z M270.6,369.2l-3.6-2c0.5-0.2,1.6,0.1,2.5,0.6 C270.4,368.3,270.8,368.9,270.6,369.2z M270.6,369.3C270.6,369.3,270.6,369.3,270.6,369.3 C270.6,369.3,270.6,369.3,270.6,369.3L270.6,369.3z M275.3,359.8c1.1-0.6,2.7-1,4.3-1c1.7,0,3.3,0.4,4.5,1.1 c1.2,0.7,1.8,1.6,1.8,2.6c0,0.9-0.6,1.8-1.8,2.5L275.3,359.8z M284,365.1c-1.2,0.6-2.7,1-4.4,1c-1.7,0-3.3-0.4-4.5-1.1 c-1.2-0.7-1.8-1.6-1.8-2.6c0-0.9,0.7-1.8,1.8-2.5L284,365.1z M301.7,359.1l-13.8,8l-0.8-0.4l-2.7-1.6 c1.1-0.7,1.8-1.7,1.8-2.6c0-1-0.7-2-1.9-2.7c-1.2-0.7-2.9-1.1-4.6-1.1c-1.7,0-3.3,0.4-4.5,1.1l-3-1.8l-0.7-0.4l13.6-7.9 c0.2,0.1,0.5,0.2,0.9,0.2c0.3,0,0.5-0.1,0.7-0.2l0-0.1l0.1,0.1l1.6,0.9l-4.1,2.3l3.7,2.1c-0.4,0.3,0,1,1,1.6 c1,0.6,2.1,0.8,2.7,0.6l3.7,2.2l4.1-2.4l2.1,1.2l0.7,0.4L301.7,359.1z"
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 249.4,
    y: 348.2,
    className: "st2",
    width: 0.3,
    height: 5.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 252.4,
    y: 346.4,
    className: "st2",
    width: 0.3,
    height: 5.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M248,348.8v-2.5c0-0.1,0.1-0.2,0.1-0.2l5-2.9c0.1,0,0.1-0.1,0.2-0.1c0.3,0.1,0.5,0.2,0.5,0.3v2.4 c0,0.1-0.1,0.2-0.1,0.2l-5,3.1C248.5,349.3,248,349,248,348.8z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 270.9,
    y: 335.8,
    className: "st2",
    width: 0.3,
    height: 5.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 334,
    className: "st2",
    width: 0.3,
    height: 5.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M269.5,336.4v-2.5c0-0.1,0.1-0.2,0.1-0.2l5-2.9c0.1,0,0.1-0.1,0.2-0.1c0.3,0.1,0.5,0.2,0.5,0.3v2.4 c0,0.1-0.1,0.2-0.1,0.2l-5,3.1C270,336.8,269.5,336.6,269.5,336.4z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M314,343c6.3,3.7,6.4,9.7,0.1,13.4l-32.7,19c-6.3,3.7-16.7,3.7-23,0l-13.1-7.6c-6.3-3.7-6.4-9.7-0.1-13.4 l32.7-19c6.3-3.7,16.7-3.7,23,0L314,343z M274.5,371.1l32.5-18.9c1.2-0.7,1.8-1.6,1.8-2.6c0-1-0.7-1.9-1.8-2.6l-13.1-7.6 c-1.2-0.7-2.7-1-4.4-1c-1.7,0-3.3,0.3-4.4,1l-32.7,19c-1.2,0.7-1.8,1.6-1.8,2.6c0,1,0.7,1.9,1.8,2.6l13.1,7.6 c1.2,0.7,2.7,1,4.4,1c1.7,0,3.3-0.3,4.4-1L274.5,371.1z"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M314,342.8c6.6,3.3,6.4,11.4,0.1,15.1l-32.7,19c-6.3,3.7-16.7,3.7-23,0l-13.1-7.6 c-6.3-3.7-6.4-11.4-0.1-15.1l32.7-17.3c6.3-3.7,16.7-3.7,23,0L314,342.8z M274.5,372.7l36.4-21.2c1.2-0.7,1.8-1.6,1.8-2.6 c0-1-0.7-1.9-1.8-2.6l-17.2-9.7c-1.2-0.7-2.7-1-4.4-1c-1.7,0-3.3,0.3-4.4,1l-32.7,19c-1.2,0.7-5,3.1-4.2,5.9 c0.3,1,3,2.9,4.2,3.6l13.1,7.6c1.2,0.7,2.7,1,4.4,1c1.7,0,3.3-0.3,4.4-1L274.5,372.7z"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250.7,367.6c-0.6-0.5-1.2-1-1.8-1.4c-1.1-1.2-1.9-2.5-2.3-4c-0.1-0.8-0.2-1.6-0.3-2.4 c-0.1-1.2,0.2-2.4,0.7-3.5c0.3-1.1,1-2.1,1.8-2.9c0.8-0.9,1.8-1.5,2.9-1.8c0.9-0.5,1.9-0.7,2.9-0.7v-1.6l-9.7,5.1 c-6.3,3.7-6.3,11.4,0.1,15.1l9.6,5.5v-6C253.3,368.7,252,368.4,250.7,367.6z"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314,342.8c6.6,3.3,6.4,9.9,0.1,13.6l-32.7,19c-6.3,3.7-16.7,3.7-23,0l-13.1-7.6 c-6.3-3.7-6.4-9.8-0.1-13.5l32.7-17.3c6.3-3.7,16.7-3.7,23,0L314,342.8z M274.5,372.7l36.4-21.2c1.2-0.7,1.8-1.6,1.8-2.6 c0-1-0.7-1.9-1.8-2.6l-17.2-9.7c-1.2-0.7-2.7-1-4.4-1c-1.7,0-3.3,0.3-4.4,1l-32.7,19c-1.2,0.7-5,3.1-4.2,5.9 c0.3,1,3,2.9,4.2,3.6l13.1,7.6c1.2,0.7,2.7,1,4.4,1c1.7,0,3.3-0.3,4.4-1L274.5,372.7z"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M314,342.6c6.3,3.7,6.4,9.7,0.1,13.4l-32.7,19c-6.3,3.7-16.7,3.7-23,0l-13.1-7.6 c-6.3-3.7-6.4-9.7-0.1-13.4l32.7-19c6.3-3.7,16.7-3.7,23,0L314,342.6z M274.4,370.8l32.6-18.9c1.2-0.7,1.8-1.6,1.8-2.6 c0-1-0.7-1.9-1.8-2.6l-13.1-7.6c-1.2-0.7-2.7-1-4.4-1c-1.7,0-3.3,0.3-4.4,1l-32.7,19c-1.2,0.7-1.8,1.6-1.8,2.6 c0,1,0.7,1.9,1.8,2.6l13.1,7.6c1.2,0.7,2.7,1,4.4,1C271.6,371.9,273.1,371.6,274.4,370.8L274.4,370.8z"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "298,365.3 297.7,365.4 290.7,361.3 290.9,361.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st295",
    points: "298,365.2 297.7,365.4 290.7,361.2 290.9,361.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "295.3,366.9 295.1,367 288,362.8 288.2,362.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st295",
    points: "295.3,366.8 295.1,366.9 288,362.8 288.2,362.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "292.6,368.4 292.4,368.5 285.3,364.3 285.5,364.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st295",
    points: "292.6,368.3 292.4,368.4 285.3,364.3 285.5,364.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "290,369.9 289.8,370 282.7,365.9 282.9,365.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st295",
    points: "290,369.9 289.8,370 282.7,365.8 282.9,365.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "287.3,371.4 287.1,371.6 280,367.4 280.2,367.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st295",
    points: "287.3,371.4 287.1,371.5 280,367.4 280.2,367.3  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "308.6,359.1 308.4,359.2 301.4,355.1 301.6,355  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st295",
    points: "308.6,359.1 308.4,359.2 301.4,355.1 301.6,354.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "306,360.7 305.8,360.8 298.7,356.6 298.9,356.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st295",
    points: "306,360.6 305.8,360.7 298.7,356.6 298.9,356.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "303.3,362.2 303.1,362.4 296,358.2 296.2,358.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st295",
    points: "303.3,362.2 303.1,362.3 296,358.1 296.2,358  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "300.7,363.7 300.4,363.9 293.3,359.8 293.6,359.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st295",
    points: "300.7,363.7 300.4,363.8 293.3,359.7 293.6,359.6  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "250.3,361.3 242.8,365.8 243,365.9 250.5,361.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "261.6,376.5 261.8,376.6 269.7,372.1 269.4,372  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "252.3,363.3 245.2,367.5 245.4,367.5 252.5,363.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "255,364.9 247.9,369 248.1,369.2 255.2,365  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "257.6,366.4 250.5,370.5 250.7,370.7 257.8,366.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "260.3,368 253.2,372 253.4,372.2 260.5,368.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "262.9,369.5 255.8,373.6 256,373.7 263.1,369.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "265.7,371 258.6,375.2 258.8,375.3 265.9,371.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "277.4,369 284.5,373.1 284.7,373 277.6,368.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "274.6,370.6 281.7,374.8 281.9,374.6 274.8,370.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "306.7,352 313.8,356.2 314,356 306.9,351.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "304,353.6 311.1,357.7 311.3,357.7 304.2,353.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "270.8,372 278.5,376.5 278.7,376.3 271.1,371.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "308.6,350.1 316.1,354.6 316.3,354.5 308.8,350  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "269.1,348.3 262,344.2 261.8,344.2 268.9,348.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "266.4,349.9 259.3,345.7 259,345.9 266.1,350  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "263.7,351.3 256.6,347.2 256.4,347.4 263.5,351.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "261,352.9 253.9,348.7 253.7,348.9 260.8,353  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "258.4,354.5 251.3,350.3 251.1,350.4 258.2,354.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "255.7,356 248.6,351.9 248.4,352 255.5,356.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "253,357.7 246,353.5 245.7,353.6 252.8,357.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "277.7,335 284.8,339.2 285.1,339.1 278,334.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "282.3,340.6 275.3,336.5 275.1,336.6 282.1,340.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "279.7,342.1 272.6,338 272.4,338.1 279.5,342.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "277,343.7 269.9,339.5 269.7,339.7 276.8,343.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "274.4,345.2 267.3,341.1 267.1,341.2 274.2,345.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "271.7,346.8 264.6,342.6 264.4,342.7 271.5,346.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "250.5,359.8 243.1,355.5 242.9,355.6 250.5,360.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "280.6,333.7 288.1,338.2 288.3,338 280.8,333.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "298.1,333.6 290.5,338 290.8,338.1 298.3,333.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "309,349.2 316.8,344.7 316.6,344.6 308.8,349.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "301,335 293.9,339.1 294.1,339.3 301.2,335.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "303.7,336.6 296.6,340.7 296.8,340.8 303.9,336.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "306.3,338.1 299.2,342.2 299.4,342.3 306.5,338.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "309,339.6 301.9,343.8 302.1,343.9 309.2,339.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "304.8,345.4 311.8,341.3 311.6,341.2 304.6,345.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "307.5,347 314.6,342.8 314.4,342.7 307.3,346.8  "
  })))), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st296",
    points: "309.8,367.4 309.8,361.3 285.9,375.2 285.9,382.8  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st297",
    points: "309.8,367.4 308.8,366.9 284.9,380.7 285.9,381.3  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st298",
    points: "309.8,367.4 308.8,366.9 308.8,361.9 309.8,361.3  "
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st299",
    points: "313.3,354.8 313.3,365.4 309.9,367.5 309.9,356.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st300",
    points: "314.6,355.5 314.6,367.6 311.1,369.7 311.1,357.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st301",
    points: "314.2,356.7 314.2,358 311.6,359.6 311.6,358.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "309.9,368.9 311.1,369.7 311.1,357.5 309.9,356.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "313.3,354.8 314.6,355.5 311.1,357.5 309.9,356.8  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st302",
    points: "314.2,356.7 314.2,358 314.1,357.9 314.1,356.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st303",
    points: "311.6,359.6 314.2,358 314.1,357.9 311.6,359.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st301",
    points: "314.1,356.8 311.6,358.2 311.6,359.4 314.1,357.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st302",
    points: "314.2,358.7 314.2,360 314.1,359.9 314.1,358.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st303",
    points: "311.6,361.6 314.2,360 314.1,359.9 311.6,361.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st301",
    points: "314.1,358.8 311.6,360.3 311.6,361.4 314.1,359.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st302",
    points: "314.2,360.7 314.2,362 314.1,362 314.1,360.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st303",
    points: "311.6,363.5 314.2,362 314.1,362 311.6,363.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st301",
    points: "314.1,360.8 311.6,362.2 311.6,363.5 314.1,362  "
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "309.9,358.8 311.1,360.3 287.2,374.2 286,372.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "287.2,374.5 311.1,360.7 311.1,360.3 287.2,374.2  "
  }))), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.1,360.7 311.1,369.7 287.2,383.5 287.2,374.5  "
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "300.9,351.5 309.8,358.6 310.8,360.3 287.1,374 286.1,372.2 277.3,365  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "309.8,358.6 310.8,360.3 287.1,374 286.1,372.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.1,360.8v-0.1l-13.1,7.6h0v0l-9.2,5.3h0v0l-0.8,0.4l-0.1,0v0l-0.8,0.5v0.1l0.8-0.5v2.3l-0.8,0.5v0.1 l0.8-0.5v2.4l-0.8,0.5v0.1l0.8-0.5v3.9l0.1-0.1v-3.9l0.7-0.4v3.9l0.1-0.1v-3.8l0.7-0.4v3.9l0.1-0.1v-3.9l0.6-0.4v3.9l0.1-0.1 v-3.9l0.7-0.4v3.9l0.1-0.1v-3.9l0.7-0.4v3.9l0.1-0.1v-4l0.6-0.4v3.9l0.1-0.1v-3.9l0.7-0.4v3.9l0.1-0.1v-3.9l0.7-0.4v3.9 l0.1-0.1v-3.9l0.6-0.4v3.9h0.1v-4l0.7-0.4v3.9l0.1-0.1v-3.9l0.7-0.4v3.9l0.1-0.1v-3.9l0.6-0.4v3.9l0.1-0.1v-3.9l0.6-0.4v3.9 l0.1-0.1v-3.9l0.7-0.4v3.9l0.1-0.1v-3.9l0.7-0.4v3.9l0.1-0.1v-3.9l0.6-0.4v3.9l0.1-0.1v-3.9l0.7-0.4v3.9l0.1-0.1v-3.9l0.7-0.4 v3.9l0.1-0.1v-4l0.6-0.4v3.9l0.1-0.1v-3.9l0.7-0.4v4l0.1-0.1v-3.9l0.7-0.4v3.9l0.1-0.1v-3.9l0.6-0.4v3.9l0.1-0.1v-4l0.7-0.4 v3.9l0.1-0.1v-3.9l0.7-0.4v4l0.1-0.1v-4l0.6-0.4v3.9l0.1-0.1v-3.9l0.7-0.4v3.9l0.1-0.1v-3.9l0.7-0.4v3.9l0.1-0.1V367l0.7-0.4 v3.9l0.1-0.1v-3.9l0.6-0.4v3.9l0.1-0.1v-3.9l0.6-0.4v-0.1l-0.6,0.4v-2.4l0.6-0.4v-0.1l-0.6,0.4v-2.3L311.1,360.8z  M288.8,378.5l-0.7,0.4v-2.4l0.7-0.4V378.5z M288.8,376l-0.7,0.4v-2.3l0.7-0.4V376z M289.6,378.1l-0.7,0.4v-2.4l0.7-0.4V378.1 z M289.6,375.6l-0.7,0.4v-2.3l0.7-0.4V375.6z M290.3,377.7l-0.6,0.4v-2.4l0.6-0.4V377.7z M290.3,375.1l-0.6,0.4v-2.3l0.6-0.4 V375.1z M291.1,377.2l-0.7,0.4v-2.4l0.7-0.4V377.2z M291.1,374.7l-0.7,0.4v-2.3l0.7-0.4V374.7z M291.9,376.7l-0.7,0.4v-2.4 l0.7-0.4V376.7z M291.9,374.2l-0.7,0.4v-2.3l0.7-0.4V374.2z M292.6,376.3l-0.6,0.4v-2.4l0.6-0.4V376.3z M292.6,373.8l-0.6,0.4 v-2.3l0.6-0.4V373.8z M293.4,375.8l-0.7,0.4v-2.4l0.7-0.4V375.8z M293.4,373.3l-0.7,0.4v-2.3l0.7-0.4V373.3z M294.2,375.4 l-0.7,0.4v-2.4l0.7-0.4V375.4z M294.2,372.9l-0.7,0.4V371l0.7-0.4V372.9z M294.9,375l-0.6,0.4v-2.4l0.6-0.4V375z M294.9,372.5 l-0.6,0.4v-2.3l0.6-0.4V372.5z M295.8,374.5l-0.7,0.4v-2.4l0.7-0.4V374.5z M295.8,372l-0.7,0.4v-2.3l0.7-0.4V372z  M296.5,374.1l-0.7,0.4v-2.4l0.7-0.4V374.1z M296.5,371.5l-0.7,0.4v-2.3l0.7-0.4V371.5z M297.3,373.6l-0.6,0.4v-2.4l0.6-0.4 V373.6z M297.3,371.1l-0.6,0.4v-2.3l0.6-0.4V371.1z M298,373.2l-0.6,0.4v-2.4l0.6-0.4V373.2z M298,370.7l-0.6,0.4v-2.3 l0.6-0.4V370.7z M298.8,372.7l-0.7,0.4v-2.4l0.7-0.4V372.7z M298.8,370.2l-0.7,0.4v-2.3l0.7-0.4V370.2z M299.6,372.3l-0.7,0.4 v-2.4l0.7-0.4V372.3z M299.6,369.8l-0.7,0.4v-2.3l0.7-0.4V369.8z M300.3,371.9l-0.6,0.4v-2.4l0.6-0.4V371.9z M300.3,369.3 l-0.6,0.4v-2.3l0.6-0.4V369.3z M301.1,371.4l-0.7,0.4v-2.4l0.7-0.4V371.4z M301.1,368.9l-0.7,0.4v-2.3l0.7-0.4V368.9z  M301.9,371l-0.7,0.4V369l0.7-0.4V371z M301.9,368.4l-0.7,0.4v-2.3l0.7-0.4V368.4z M302.6,370.5l-0.6,0.4v-2.4l0.6-0.4V370.5z  M302.6,368l-0.6,0.4V366l0.6-0.4V368z M303.5,370.1l-0.7,0.4v-2.4l0.7-0.4V370.1z M303.5,367.5l-0.7,0.4v-2.3l0.7-0.4V367.5z  M304.2,369.6l-0.7,0.4v-2.4l0.7-0.4V369.6z M304.2,367.1l-0.7,0.4v-2.3l0.7-0.4V367.1z M305,369.2l-0.6,0.4v-2.4l0.6-0.4 V369.2z M305,366.7l-0.6,0.4v-2.3l0.6-0.4V366.7z M305.8,368.7l-0.7,0.4v-2.4l0.7-0.4V368.7z M305.8,366.2l-0.7,0.4v-2.3 l0.7-0.4V366.2z M306.5,368.3l-0.7,0.4v-2.4l0.7-0.4V368.3z M306.5,365.8l-0.7,0.4v-2.3l0.7-0.4V365.8z M307.3,367.8l-0.6,0.4 v-2.4l0.6-0.4V367.8z M307.3,365.3l-0.6,0.4v-2.3l0.6-0.4V365.3z M308.1,367.4l-0.7,0.4v-2.4l0.7-0.4V367.4z M308.1,364.9 l-0.7,0.4v-2.3l0.7-0.4V364.9z M308.8,366.9l-0.7,0.4v-2.4l0.7-0.4V366.9z M308.8,364.4l-0.7,0.4v-2.3l0.7-0.4V364.4z  M309.6,366.5l-0.7,0.4v-2.4l0.7-0.4V366.5z M309.6,364l-0.7,0.4v-2.3l0.7-0.4V364z M310.3,366.1l-0.6,0.4V364l0.6-0.4V366.1z  M310.3,363.6l-0.6,0.4v-2.3l0.6-0.4V363.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "286.1,372.2 277.4,365 277.3,365 277.3,365.1 286,372.2 287,374 287.2,373.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "287.8,373.6 287.9,373.5 286.8,371.7 278.1,364.5 278,364.6 286.8,371.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "288.5,373.2 288.6,373.1 287.6,371.3 278.8,364.1 278.7,364.2 287.5,371.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "289.2,372.8 289.3,372.7 288.3,370.9 279.5,363.7 279.4,363.8 288.2,371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "289.9,372.4 290,372.3 289,370.5 280.2,363.3 280.2,363.4 288.9,370.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "290.7,371.9 290.8,371.9 289.7,370.1 281,362.9 280.8,363 289.6,370.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "291.3,371.6 291.5,371.5 290.5,369.7 281.7,362.5 281.6,362.6 290.3,369.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "292.1,371.2 292.2,371.1 291.1,369.2 282.4,362.1 282.3,362.2 291.1,369.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "292.8,370.7 292.9,370.7 291.9,368.8 283.1,361.7 283,361.8 291.7,368.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "293.5,370.3 293.7,370.2 292.6,368.4 283.8,361.3 283.7,361.3 292.5,368.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "294.3,369.9 294.3,369.8 293.3,368 284.6,360.9 284.5,360.9 293.2,368  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "294.9,369.5 295.1,369.4 294.1,367.6 285.3,360.5 285.1,360.5 293.9,367.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "295.7,369 295.8,369 294.7,367.1 286,360.1 285.9,360.1 294.7,367.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "296.4,368.6 296.5,368.6 295.5,366.7 286.7,359.6 286.6,359.7 295.4,366.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "297.1,368.2 297.3,368.2 296.2,366.3 287.5,359.2 287.3,359.2 296.1,366.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "297.8,367.8 297.9,367.7 296.9,365.9 288.1,358.8 288.1,358.8 296.8,366  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "298.6,367.4 298.6,367.3 297.6,365.6 288.8,358.3 288.7,358.5 297.5,365.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "299.3,367 299.4,366.9 298.4,365.1 289.6,357.9 289.5,358 298.2,365.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "300,366.5 300.1,366.5 299,364.6 290.4,357.5 290.2,357.6 299,364.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "300.7,366.1 300.8,366 299.8,364.2 291.1,357.1 291,357.2 299.6,364.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "301.4,365.7 301.6,365.6 300.5,363.8 291.8,356.7 291.7,356.8 300.4,363.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "302.2,365.3 302.2,365.2 301.2,363.4 292.5,356.3 292.4,356.4 301.1,363.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "302.9,364.9 303,364.8 302,363 293.2,355.9 293.1,356 301.8,363  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "303.6,364.5 303.7,364.4 302.6,362.6 293.9,355.5 293.9,355.6 302.6,362.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "304.3,364.1 304.4,364 303.4,362.2 294.7,355.1 294.5,355.1 303.3,362.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "305,363.7 305.1,363.6 304.1,361.8 295.4,354.7 295.2,354.7 304,361.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "305.7,363.2 305.8,363.2 304.8,361.3 296.1,354.3 296,354.3 304.7,361.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "306.5,362.8 306.6,362.8 305.5,360.9 296.9,353.8 296.7,353.9 305.4,361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "307.2,362.4 307.3,362.3 306.3,360.5 297.5,353.4 297.5,353.4 306.1,360.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "307.9,362 308,362 306.9,360.1 298.3,353 298.1,353 306.9,360.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "308.6,361.6 308.7,361.5 307.7,359.6 299,352.6 298.9,352.6 307.6,359.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "309.3,361.1 309.5,361.1 308.4,359.2 299.7,352.1 299.6,352.2 308.3,359.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "310.1,360.7 310.1,360.7 309.1,358.8 300.5,351.7 300.3,351.8 309.1,358.9  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000091011786354300438390000010362352986873810357_",
    points: "293.5,379.8 293.5,373.5 305,366.8  305,373.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072269534857475721730000015347325500859038111_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091011786354300438390000010362352986873810357_",
    style: {
      overflow: "visible"
    }
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st299",
    points: "285.9,370.6 285.9,382.8 282.4,384.8 282.4,372.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st300",
    points: "287.2,371.4 287.2,383.5 283.7,385.5 283.7,373.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st301",
    points: "286.8,372.6 286.8,373.9 284.1,375.4 284.1,374.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.4,384.8 283.7,385.5 283.7,373.4 282.4,372.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "285.9,370.6 287.2,371.4 283.7,373.4 282.4,372.7  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st302",
    points: "286.8,372.6 286.8,373.9 286.6,373.8 286.6,372.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st303",
    points: "284.1,375.4 286.8,373.9 286.6,373.8 284.1,375.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st301",
    points: "286.6,372.6 284.1,374.1 284.1,375.2 286.6,373.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st302",
    points: "286.8,374.6 286.8,375.9 286.6,375.8 286.6,374.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st303",
    points: "284.1,377.4 286.8,375.9 286.6,375.8 284.1,377.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st301",
    points: "286.6,374.6 284.1,376.1 284.1,377.3 286.6,375.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st302",
    points: "286.8,376.5 286.8,377.8 286.6,377.8 286.6,376.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st303",
    points: "284.1,379.4 286.8,377.8 286.6,377.8 284.1,379.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st301",
    points: "286.6,376.6 284.1,378.1 284.1,379.3 286.6,377.8  "
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st299",
    points: "314.6,355.5 314.6,366.2 311.1,368.2 311.1,357.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "315.9,356.2 315.9,368.4 312.4,370.4 312.4,358.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "315.5,357.5 315.5,358.8 312.8,360.3 312.8,359  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.1,369.7 312.4,370.4 312.4,358.3 311.1,357.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "314.6,355.5 315.9,356.2 312.4,358.3 311.1,357.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st302",
    points: "315.5,357.5 315.5,358.8 315.4,358.7 315.4,357.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st302",
    points: "315.5,359.4 315.5,360.7 315.4,360.7 315.4,359.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "315.4,359.5 312.8,360.9 312.8,362.2 315.4,360.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st302",
    points: "315.5,361.4 315.5,362.7 315.4,362.6 315.4,361.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "315.4,361.5 312.8,363 312.8,364.1 315.4,362.6  "
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st299",
    points: "287.2,371.4 287.2,383.5 283.7,385.5 283.7,373.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "288.5,372 288.5,384.2 284.9,386.3 284.9,374.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "283.7,385.5 284.9,386.3 284.9,374.2 283.7,373.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "287.2,371.4 288.5,372 284.9,374.2 283.7,373.4  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st302",
    points: "288,373.3 288,374.6 287.9,374.5 287.9,373.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "287.9,373.3 285.4,374.8 285.4,376 287.9,374.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st302",
    points: "288,375.3 288,376.6 287.9,376.5 287.9,375.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "287.9,375.3 285.4,376.8 285.4,378 287.9,376.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st302",
    points: "288,377.3 288,378.6 287.9,378.5 287.9,377.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "287.9,377.4 285.4,378.8 285.4,380 287.9,378.5  "
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "265.4,346.6 265.4,350.9 273,346.6 273,342.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "265.4,350.9 265.1,350.6 265.1,346.4 265.4,346.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "273,342.3 265.4,346.6 265.1,346.4 272.7,342.1  "
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "245.3,373.6 248,375.2 248,373.3 245.2,371.6  "
  }))), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "261.6,383.4 261.6,384.4 260.1,385.3 260.1,384.7  "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M261.6,383.4c0,0-0.9-0.3-1.4-0.7l-15.9-9.2c0,0-0.7-0.5-0.7-0.6l-1.5,1.4l18.1,10.4L261.6,383.4z"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "242,374.8 260.1,385.3 260.1,384.7 242,374.3  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "261.6,384.4 260.1,385.3 260.1,387.6 261.6,386.8  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st304",
    points: "261.6,384.4 260.1,385.3 260.1,386.2 261.6,385.4  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "260.1,387.6 242,377.2 242,376.5 260.1,386.9  "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M265.3,382.1v1.4c0.8,0.1,9.3,1.8,15.7-2v-1.4C280.3,380.4,274.4,383.5,265.3,382.1z"
  }))))), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "293.5,379.8 293.5,373.5 305,366.8 305,373.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgTest2);
export default __webpack_public_path__ + "static/media/SVG-TEST2.a76ead010214ab8ffdc091f8a53b17fb.svg";
export { ForwardRef as ReactComponent };